export interface GlossaryTerm {
  term: string;
  definition: string;
}

export interface ArtisanGlossaryData {
  terms: GlossaryTerm[];
  promotionalText: string;
}

export interface GlossaryData {
  [artisanKey: string]: ArtisanGlossaryData;
}

// Comprehensive glossary data
export const glossaryData: GlossaryData = {
  "air-conditioning": {
    promotionalText:
      "For expert air conditioning services and trusted professionals, LaborHack is your go-to partner.",
    terms: [
      {
        term: "AC Compressor",
        definition:
          "The component in an air conditioning system that pressurizes and circulates refrigerant to facilitate cooling.",
      },
      {
        term: "AC Condenser",
        definition:
          "The outdoor unit of an AC system where refrigerant releases heat and condenses into a liquid.",
      },
      {
        term: "AC Load Calculation",
        definition:
          "The process of determining the correct size of an air conditioning system based on factors like room size, insulation, and climate.",
      },
      {
        term: "Air Changes Per Hour (ACH)",
        definition:
          "A measure of how many times the air in a room is replaced with fresh air in one hour.",
      },
      {
        term: "Air Conditioning (AC) System",
        definition:
          "A system that cools and dehumidifies indoor air for comfort and efficiency.",
      },
      {
        term: "Air Ducts",
        definition:
          "Channels that distribute heated or cooled air throughout a building.",
      },
      {
        term: "Air Filter",
        definition:
          "A filter that removes dust, allergens, and other particles from the air before it enters the HVAC system.",
      },
      {
        term: "Air Handler",
        definition:
          "The indoor unit of an HVAC system that circulates and regulates air through ducts.",
      },
      {
        term: "Air Handler Unit (AHU)",
        definition:
          "A component of an HVAC system that circulates and regulates air, often containing filters, coils, and blowers.",
      },
      {
        term: "Airflow Rate",
        definition:
          "The volume of air moving through a system, usually measured in cubic feet per minute (CFM).",
      },
      {
        term: "Air Ventilation System",
        definition:
          "A system designed to exchange indoor and outdoor air, improving air quality and controlling humidity.",
      },
      {
        term: "Ambient Temperature",
        definition: "The surrounding air temperature in a given environment.",
      },
      {
        term: "Auto Balancing Dampers",
        definition:
          "Dampers that automatically adjust airflow in duct systems for even distribution.",
      },
      {
        term: "Auto Mode",
        definition:
          "A setting in HVAC systems that automatically adjusts temperature and fan speed based on room conditions.",
      },
      {
        term: "Balancing Dampers",
        definition:
          "Devices in ductwork that regulate and balance airflow to maintain even temperature distribution.",
      },
      {
        term: "Blower Fan",
        definition:
          "A fan that circulates air through the heating or cooling system.",
      },
      {
        term: "Blower Motor",
        definition:
          "The motor that powers the fan in an HVAC system to move air through ducts.",
      },
      {
        term: "Breakers (Circuit Breakers)",
        definition:
          "Electrical switches that protect HVAC systems from power overloads.",
      },
      {
        term: "BTU (British Thermal Unit)",
        definition:
          "A measurement of heat energy; in HVAC, it indicates the cooling or heating capacity of a system.",
      },
      {
        term: "Building Management System (BMS)",
        definition:
          "A centralized system that monitors and controls HVAC, lighting, and other building systems for efficiency.",
      },
      {
        term: "Capacitor",
        definition:
          "An electrical component that helps start and run the compressor and fan motors in an HVAC system.",
      },
      {
        term: "Ceiling Diffuser",
        definition:
          "A vent installed in the ceiling to distribute conditioned air evenly into a room.",
      },
      {
        term: "Central Air Conditioning System",
        definition:
          "A system that cools an entire building using a single outdoor unit connected to ductwork.",
      },
      {
        term: "Central Air System",
        definition:
          "A system that provides cooling (and often heating) to an entire building through a network of ducts.",
      },
      {
        term: "Charge (Refrigerant Charge)",
        definition:
          "The amount of refrigerant in an HVAC system, which must be at optimal levels for efficient operation.",
      },
      {
        term: "Chilled Water System",
        definition:
          "An HVAC system that cools air by circulating chilled water through coils in air handlers.",
      },
      {
        term: "Chiller",
        definition:
          "A machine that removes heat from liquid (usually water) to provide cooling in large buildings.",
      },
      {
        term: "Coil (Evaporator & Condenser Coil)",
        definition:
          "Metal tubing that helps absorb heat (evaporator) or release heat (condenser) in an HVAC system.",
      },
      {
        term: "Compressor",
        definition:
          "A crucial component in an AC or heat pump system that pressurizes refrigerant to facilitate heat exchange.",
      },
      {
        term: "Condensate Drain",
        definition:
          "A drain that removes moisture collected from the air during the cooling process.",
      },
      {
        term: "Condensate Drain Line",
        definition:
          "A pipe that removes excess moisture from an HVAC system to prevent water damage and mold growth.",
      },
      {
        term: "Condensation",
        definition:
          "The process where moisture in the air turns into liquid, often seen on cooling coils.",
      },
      {
        term: "Condenser Fan Motor",
        definition:
          "The motor that drives the fan in the outdoor unit to release heat from the refrigerant.",
      },
      {
        term: "Condenser Unit",
        definition:
          "The outdoor unit in an AC system that releases absorbed heat into the atmosphere.",
      },
      {
        term: "Cool Mode",
        definition:
          "An AC setting that actively cools the indoor air by running the compressor.",
      },
      {
        term: "Cooling Load",
        definition:
          "The amount of cooling required to maintain a desired indoor temperature, influenced by external heat sources.",
      },
      {
        term: "Damper",
        definition:
          "A device in ductwork that regulates airflow to different areas of a building.",
      },
      {
        term: "Dampers",
        definition:
          "Adjustable plates within ductwork that control airflow and temperature distribution.",
      },
      {
        term: "Dehumidifier",
        definition:
          "A device that removes excess moisture from the air to improve comfort and air quality.",
      },
      {
        term: "Diffuser",
        definition:
          "A vent that evenly distributes conditioned air into a space.",
      },
      {
        term: "Drain Pan",
        definition:
          "A pan under the evaporator coil that collects and directs condensate water to the drain line.",
      },
      {
        term: "Duct Insulation",
        definition:
          "Material used to reduce heat loss or gain in air ducts, improving system efficiency.",
      },
      {
        term: "Duct Leakage Test",
        definition:
          "A test that measures air leaks in duct systems, affecting HVAC performance and energy costs.",
      },
      {
        term: "Ductless Mini-Split",
        definition:
          "A type of HVAC system with separate indoor and outdoor units that does not require ductwork.",
      },
      {
        term: "Ductless Mini-Split System",
        definition:
          "A cooling and heating system with an outdoor compressor and one or more indoor air-handling units, without ductwork.",
      },
      {
        term: "Ductwork",
        definition:
          "A network of tubes that distribute conditioned air throughout a building.",
      },
      {
        term: "Energy Efficiency Ratio (EER)",
        definition:
          "A rating that measures an AC unit's cooling efficiency in relation to its power consumption.",
      },
      {
        term: "Energy Recovery Ventilator (ERV)",
        definition:
          "A device that exchanges heat and moisture between incoming and outgoing air to improve efficiency and air quality.",
      },
      {
        term: "Evaporator Coil",
        definition:
          "The coil inside the air handler where refrigerant absorbs heat from indoor air.",
      },
      {
        term: "Exhaust Air",
        definition:
          "Used or stale air removed from a building to maintain indoor air quality.",
      },
      {
        term: "Exhaust Vent",
        definition:
          "A vent that expels stale or contaminated air from a building to the outside.",
      },
      {
        term: "Expansion Valve",
        definition:
          "A device that controls the flow of refrigerant into the evaporator coil, reducing pressure and temperature.",
      },
      {
        term: "Fan Coil Unit (FCU)",
        definition:
          "A small heating and cooling unit with a fan and coil, commonly used in commercial HVAC systems.",
      },
      {
        term: "Filter Drier",
        definition:
          "A component in an HVAC system that removes moisture and contaminants from the refrigerant.",
      },
      {
        term: "Filtration System",
        definition:
          "The HVAC component that removes dust, allergens, and contaminants from the air.",
      },
      {
        term: "Fresh Air Intake",
        definition:
          "A vent that brings outdoor air into the HVAC system to improve indoor air quality.",
      },
      {
        term: "Freon (Refrigerant)",
        definition:
          "A chemical compound used in air conditioning and refrigeration systems to absorb and release heat.",
      },
      {
        term: "Grille",
        definition:
          "A cover with slats that allows air to enter or exit HVAC ducts while preventing debris from getting in.",
      },
      {
        term: "Heat Exchanger",
        definition:
          "A component that transfers heat between two fluids or air streams in an HVAC system.",
      },
      {
        term: "Heat Gain",
        definition:
          "The amount of heat added to a space from sources like sunlight, appliances, and occupants.",
      },
      {
        term: "Heat Load",
        definition:
          "The total amount of heat that must be removed (in cooling) or added (in heating) to maintain comfort.",
      },
      {
        term: "Heat Pump",
        definition:
          "A system that provides both heating and cooling by reversing the refrigeration cycle.",
      },
      {
        term: "Heat Pump System",
        definition:
          "A system that transfers heat between indoor and outdoor environments for both cooling and heating.",
      },
      {
        term: "HVAC (Heating, Ventilation & Air Conditioning)",
        definition:
          "A term encompassing all systems used for temperature control and air quality management.",
      },
      {
        term: "Indoor Air Quality (IAQ)",
        definition:
          "The overall air cleanliness and healthiness inside a building, affected by pollutants, humidity, and ventilation.",
      },
      {
        term: "Indoor Unit",
        definition:
          "The part of a split HVAC system located inside a building, containing the evaporator coil and air handler.",
      },
      {
        term: "Insulated Ductwork",
        definition:
          "Ducts lined with insulating material to reduce energy loss and improve HVAC performance.",
      },
      {
        term: "Insulation (Duct Insulation)",
        definition:
          "Material used to prevent heat loss or gain in HVAC ductwork, improving efficiency.",
      },
      {
        term: "Inverter AC",
        definition:
          "An air conditioner with a variable-speed compressor that adjusts cooling output based on demand, improving energy efficiency.",
      },
      {
        term: "Inverter Technology",
        definition:
          "A system that adjusts compressor speed based on demand, improving energy efficiency.",
      },
      {
        term: "Latent Heat",
        definition:
          "The heat energy required to change the state of a substance (e.g., from liquid to gas) without changing its temperature; in HVAC, it refers to the moisture removal process.",
      },
      {
        term: "Line Set",
        definition:
          "The set of copper refrigerant pipes that connect the indoor and outdoor units in a split system.",
      },
      {
        term: "Load Calculation",
        definition:
          "The process of determining the heating or cooling requirements of a space based on factors like size, insulation, and occupancy.",
      },
      {
        term: "Low-Pressure Duct",
        definition:
          "A duct system designed to operate at lower static pressure, reducing energy consumption and noise levels.",
      },
      {
        term: "Makeup Air Unit (MAU)",
        definition:
          "A ventilation system that brings in fresh air to replace exhausted air, maintaining indoor air quality and pressure balance.",
      },
      {
        term: "Mechanical Ventilation",
        definition:
          "A system that uses fans or blowers to exchange indoor and outdoor air, improving air quality and controlling humidity.",
      },
      {
        term: "MERV Rating (Filter Efficiency)",
        definition:
          "A rating that measures the effectiveness of an air filter in trapping airborne particles, with higher numbers indicating better filtration.",
      },
      {
        term: "Multi-Split System",
        definition:
          "A ductless HVAC system where one outdoor unit connects to multiple indoor units, allowing for zoned cooling or heating.",
      },
      {
        term: "Multi-Zone HVAC System",
        definition:
          "An HVAC system that allows independent temperature control in different areas or zones of a building.",
      },
      {
        term: "Outdoor Unit",
        definition:
          "The external part of an HVAC system that houses the compressor, condenser coil, and condenser fan.",
      },
      {
        term: "Outside Air Damper",
        definition:
          "A component that regulates the intake of outdoor air for ventilation and temperature control.",
      },
      {
        term: "Overload Protector",
        definition:
          "A safety device that prevents HVAC components, such as the compressor, from overheating and getting damaged.",
      },
      {
        term: "Overhead Ductwork",
        definition:
          "Ducts installed above ceilings or along upper walls to distribute conditioned air throughout a space.",
      },
      {
        term: "Package Unit",
        definition:
          "A self-contained HVAC system where all components (evaporator, condenser, and compressor) are housed in a single outdoor unit.",
      },
      {
        term: "Packaged HVAC Unit",
        definition:
          "A self-contained heating and cooling system that houses all components in a single unit, often installed on rooftops or exterior walls.",
      },
      {
        term: "Plenum Chamber",
        definition:
          "A space in an HVAC system where air pressure is equalized before distribution through ducts.",
      },
      {
        term: "Pressure Drop",
        definition:
          "A reduction in air pressure within ductwork due to resistance from filters, bends, or obstructions.",
      },
      {
        term: "Programmable Thermostat",
        definition:
          "A thermostat that allows users to set temperature schedules for automatic heating and cooling adjustments.",
      },
      {
        term: "PTAC (Packaged Terminal Air Conditioner)",
        definition:
          "A self-contained heating and cooling unit typically installed through a wall, often used in hotels and apartments.",
      },
      {
        term: "Refrigerant",
        definition:
          "A chemical compound that absorbs and releases heat in an HVAC system, allowing cooling and heating to take place.",
      },
      {
        term: "Refrigerant Charge",
        definition:
          "The correct amount of refrigerant required for an HVAC system to function efficiently.",
      },
      {
        term: "Refrigerant Leak",
        definition:
          "A loss of refrigerant due to damaged or worn-out HVAC components, which can reduce cooling efficiency and harm the environment.",
      },
      {
        term: "Refrigeration Cycle",
        definition:
          "The process by which an HVAC system removes heat from indoor air and releases it outside using refrigerant.",
      },
      {
        term: "Return Air Vent",
        definition:
          "A vent that pulls warm or stale air back into the HVAC system for reconditioning and circulation.",
      },
      {
        term: "Roof-Mounted AC Unit",
        definition:
          "An air conditioning system installed on a building's roof, typically for commercial or industrial applications.",
      },
      {
        term: "SEER Rating (Seasonal Energy Efficiency Ratio)",
        definition:
          "A measure of an AC unit's cooling efficiency over a season, with higher ratings indicating better efficiency.",
      },
      {
        term: "Smart HVAC Controls",
        definition:
          "Digital or automated controls that optimize HVAC performance, often integrating with smart home systems for remote access.",
      },
      {
        term: "Smart Thermostat",
        definition:
          "A Wi-Fi-enabled thermostat that can learn user preferences and be controlled remotely for better energy management.",
      },
      {
        term: "Split AC System",
        definition:
          "An HVAC system with separate indoor and outdoor units, typically used in homes and offices.",
      },
      {
        term: "Split System AC",
        definition:
          "An air conditioning system with separate indoor and outdoor units, commonly used for residential and commercial cooling.",
      },
      {
        term: "Supply Air",
        definition:
          "The cooled or heated air that is distributed into a room through ducts or vents.",
      },
      {
        term: "Surge Protection for HVAC",
        definition:
          "A device that protects HVAC equipment from voltage spikes and power surges, extending system lifespan.",
      },
      {
        term: "Surge Protector",
        definition:
          "A device that protects HVAC systems from electrical voltage spikes or power surges.",
      },
      {
        term: "Thermal Comfort",
        definition:
          "The state of feeling comfortable with indoor temperature, humidity, and air movement.",
      },
      {
        term: "Thermal Insulation",
        definition:
          "Material used to reduce heat transfer and improve HVAC efficiency by minimizing energy loss.",
      },
      {
        term: "Thermostat",
        definition:
          "A device that regulates temperature by controlling an HVAC system's heating or cooling operation.",
      },
      {
        term: "Thermostatic Expansion Valve (TXV)",
        definition:
          "A valve that regulates the flow of refrigerant into the evaporator coil based on cooling demand.",
      },
      {
        term: "Ton (Cooling Capacity)",
        definition:
          "A unit of measurement for AC cooling power, where 1 ton equals the ability to remove 12,000 BTUs of heat per hour.",
      },
      {
        term: "Two-Stage Compressor",
        definition:
          "A compressor that operates at two different speeds to improve energy efficiency and temperature control.",
      },
      {
        term: "Variable Air Volume (VAV) System",
        definition:
          "An HVAC system that adjusts airflow to different areas based on cooling or heating demand, improving efficiency.",
      },
      {
        term: "Variable Refrigerant Flow (VRF) System",
        definition:
          "A system that uses refrigerant to provide simultaneous heating and cooling to different zones within a building.",
      },
      {
        term: "Variable Speed Motor",
        definition:
          "A motor that adjusts its speed to match heating and cooling demands, enhancing efficiency and comfort.",
      },
      {
        term: "Ventilation",
        definition:
          "The process of exchanging indoor air with fresh outdoor air to improve air quality and control humidity.",
      },
      {
        term: "Ventilation System",
        definition:
          "A system that exchanges indoor and outdoor air to maintain air quality, control humidity, and regulate temperature.",
      },
      {
        term: "Vents",
        definition:
          "Openings that allow air to flow in and out of an HVAC system, distributing conditioned air into rooms.",
      },
      {
        term: "Wall-Mounted Split Unit",
        definition:
          "A type of split AC system with an indoor unit mounted on a wall, often used in residential or office settings.",
      },
      {
        term: "Water-Cooled Chiller",
        definition:
          "A cooling system that uses water to remove heat from the refrigerant, commonly used in large commercial buildings.",
      },
      {
        term: "Wind-Driven Ventilation",
        definition:
          "A natural ventilation method that uses wind pressure to circulate air through a building, reducing the need for mechanical cooling.",
      },
      {
        term: "Window AC Unit",
        definition:
          "A self-contained air conditioning unit designed to fit into a window or wall opening.",
      },
      {
        term: "Wireless Control",
        definition:
          "A remote or app-based system that allows users to adjust HVAC settings without physically accessing the thermostat.",
      },
    ],
  },

  aluminum: {
    promotionalText:
      "When it comes to aluminum works, LaborHack connects you with the best hands in the industry.",
    terms: [
      {
        term: "Aluminium Alloy",
        definition:
          "A blend of aluminum with other metals to enhance strength and durability.",
      },
      {
        term: "Aluminium Composite Panel (ACP)",
        definition:
          "A lightweight, durable panel with an aluminum exterior and a core material, used for cladding.",
      },
      {
        term: "Aluminium Curtain Wall",
        definition:
          "A non-structural aluminum and glass wall system that enhances building aesthetics and insulation.",
      },
      {
        term: "Aluminium Extrusion",
        definition:
          "A process of shaping aluminum into specific profiles using high-pressure force.",
      },
      {
        term: "Aluminium Frame",
        definition:
          "A lightweight yet sturdy aluminum structure used in doors, windows, and partitions.",
      },
      {
        term: "Aluminium Partition",
        definition:
          "A modular, lightweight partition system made of aluminum for interior spaces.",
      },
      {
        term: "Aluminium Profile",
        definition:
          "Custom-shaped aluminum sections used in construction, furniture, and fixtures.",
      },
      {
        term: "Aluminium Sheeting",
        definition:
          "Thin, flat aluminum sheets used for roofing, siding, and industrial applications.",
      },
      {
        term: "Anodized Finish",
        definition:
          "A corrosion-resistant surface treatment that enhances aluminum's durability and appearance.",
      },
      {
        term: "Architectural Aluminium",
        definition:
          "High-grade aluminum used for building structures, facades, and decorative elements.",
      },
      {
        term: "Assembly Joint",
        definition:
          "A connection point where aluminum components are joined together.",
      },
      {
        term: "Baffle Ceiling",
        definition:
          "A ceiling system with suspended, vertical aluminum panels for acoustic and aesthetic benefits.",
      },
      {
        term: "Bending Radius",
        definition:
          "The minimum curve an aluminum sheet or profile can be bent without cracking.",
      },
      {
        term: "Beveled Edge",
        definition:
          "An angled edge on aluminum panels for aesthetic or functional purposes.",
      },
      {
        term: "Brushed Aluminium",
        definition:
          "Aluminum with a fine, linear surface texture for a matte, decorative finish.",
      },
      {
        term: "Bullnose Trim",
        definition:
          "A rounded edge trim used to soften sharp corners in aluminum structures.",
      },
      {
        term: "Butt Joint",
        definition:
          "A basic connection where two aluminum sections meet without overlapping.",
      },
      {
        term: "Casement Window",
        definition:
          "A hinged aluminum window that swings open for ventilation.",
      },
      {
        term: "Cladding Panel",
        definition:
          "A protective aluminum panel used for facades and external walls.",
      },
      {
        term: "Coated Aluminium",
        definition:
          "Aluminum with a protective or decorative coating, such as paint or anodization.",
      },
      {
        term: "Corner Bead",
        definition:
          "A metal trim used to reinforce and protect the corners of aluminum panels or drywall.",
      },
      {
        term: "Corrugated Aluminium Sheet",
        definition:
          "A wavy-patterned aluminum sheet used for roofing and siding.",
      },
      {
        term: "Curtain Wall System",
        definition:
          "A lightweight, non-load-bearing exterior aluminum and glass wall system.",
      },
      {
        term: "Double Glazing",
        definition:
          "A window system with two glass panes separated by an air gap for insulation.",
      },
      {
        term: "Drip Edge",
        definition:
          "An angled aluminum strip that directs water away from a building.",
      },
      {
        term: "Duct Cover",
        definition: "A protective aluminum panel used to conceal HVAC ducts.",
      },
      {
        term: "Edge Banding",
        definition:
          "A finishing strip applied to the edges of aluminum panels for a refined look.",
      },
      {
        term: "Embossed Aluminium",
        definition:
          "Aluminum with raised patterns for decorative and functional purposes.",
      },
      {
        term: "End Cap",
        definition:
          "A finishing piece used to cover the open end of aluminum profiles.",
      },
      {
        term: "Epoxy Coating",
        definition:
          "A durable, chemical-resistant protective layer applied to aluminum surfaces.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A gap between aluminum structures to allow for thermal movement.",
      },
      {
        term: "Facade Panel",
        definition:
          "A decorative and protective aluminum panel used on building exteriors.",
      },
      {
        term: "Fascia Board",
        definition:
          "A vertical aluminum board covering roof edges for protection and aesthetics.",
      },
      {
        term: "Fencing Panel",
        definition:
          "A lightweight yet durable aluminum panel used for fencing.",
      },
      {
        term: "Fixing Bracket",
        definition: "A metal support used to secure aluminum structures.",
      },
      {
        term: "Flush Glazing",
        definition:
          "A seamless glass and aluminum window system for a sleek appearance.",
      },
      {
        term: "Framing System",
        definition:
          "An aluminum structural support framework for windows, doors, and partitions.",
      },
      {
        term: "Galvanized Aluminium",
        definition:
          "Aluminum coated with zinc for enhanced corrosion resistance.",
      },
      {
        term: "Glass Reinforced Aluminium",
        definition:
          "Aluminum infused with glass fibers for increased strength.",
      },
      {
        term: "Glazing Bead",
        definition:
          "A small strip that holds the glass in an aluminum window frame.",
      },
      {
        term: "Grille Work",
        definition:
          "Aluminum decorative or protective screening, commonly used in windows and ventilation.",
      },
      {
        term: "Gutter System",
        definition:
          "An aluminum drainage system that directs rainwater away from a building.",
      },
      {
        term: "Handle Lock",
        definition:
          "A locking mechanism integrated into aluminum doors or windows.",
      },
      {
        term: "Heat-Resistant Aluminium",
        definition:
          "Aluminum treated to withstand high temperatures without warping.",
      },
      {
        term: "Hinged Frame",
        definition:
          "An aluminum frame with a hinge for movement in doors or windows.",
      },
      {
        term: "Honeycomb Panel",
        definition:
          "A lightweight aluminum panel with a honeycomb core for strength and insulation.",
      },
      {
        term: "Industrial Aluminium Sheet",
        definition:
          "High-strength aluminum sheets used for industrial applications.",
      },
      {
        term: "Insulated Panel",
        definition:
          "An aluminum panel with an insulating core to enhance energy efficiency.",
      },
      {
        term: "Joint Sealing",
        definition:
          "A process of sealing gaps in aluminum structures to prevent leaks.",
      },
      {
        term: "Laminated Aluminium",
        definition:
          "Aluminum bonded with layers of other materials for added strength.",
      },
      {
        term: "Louvre Panel",
        definition:
          "An aluminum panel with angled slats for ventilation and shading.",
      },
      {
        term: "Mechanical Fixing",
        definition:
          "The process of joining aluminum components using screws, bolts, or clips.",
      },
      {
        term: "Metal Flashing",
        definition:
          "A thin aluminum strip used to prevent water penetration in joints.",
      },
      {
        term: "Mirror Finish Aluminium",
        definition: "Highly polished aluminum with a reflective surface.",
      },
      {
        term: "Miter Joint",
        definition:
          "A corner joint formed by two aluminum pieces cut at an angle.",
      },
      {
        term: "Mullion System",
        definition:
          "A structural aluminum framework used in curtain walls and windows.",
      },
      {
        term: "Non-Rusting Aluminium",
        definition: "Aluminum treated to resist corrosion.",
      },
      {
        term: "Thermal Break Frame",
        definition:
          "An aluminum frame with insulation to reduce heat transfer.",
      },
      {
        term: "UV-Resistant Coating",
        definition: "A finish that protects aluminum from ultraviolet damage.",
      },
      {
        term: "Ventilated Facade",
        definition:
          "A building envelope system allowing airflow behind aluminum panels.",
      },
    ],
  },

  bricklaying: {
    promotionalText:
      "Building strong, reliable structures? LaborHack is your one-stop hub for expert bricklayers.",
    terms: [
      {
        term: "Adhesive Mortar",
        definition:
          "A type of mortar with enhanced bonding properties, used for securing tiles, bricks, or stones.",
      },
      {
        term: "Aggregate",
        definition:
          "Granular materials such as sand, gravel, or crushed stone, used in concrete and mortar mixes.",
      },
      {
        term: "Air-Entrained Mortar",
        definition:
          "Mortar with tiny air bubbles introduced to improve workability, resistance to freeze-thaw cycles, and durability.",
      },
      {
        term: "Anchor Tie",
        definition:
          "A metal component used to connect and secure masonry walls or veneer to structural elements.",
      },
      {
        term: "Application Float",
        definition:
          "A tool used for spreading and leveling mortar, plaster, or concrete during application.",
      },
      {
        term: "Arch Brickwork",
        definition:
          "A curved structure made from bricks, often used over doorways or windows for strength and aesthetics.",
      },
      {
        term: "Ashlar Masonry",
        definition:
          "Masonry using precisely cut stones or bricks arranged in uniform layers with minimal mortar joints.",
      },
      {
        term: "Back Buttering",
        definition:
          "The process of applying a layer of mortar or adhesive to the back of a brick, tile, or stone before installation to ensure better adhesion.",
      },
      {
        term: "Bagging Finish",
        definition:
          "A textured surface finish created by rubbing a coarse cloth or sponge over a fresh mortar coat.",
      },
      {
        term: "Base Coat",
        definition:
          "The initial layer of plaster or render applied to a surface before finishing coats.",
      },
      {
        term: "Bedding Joint",
        definition:
          "The horizontal mortar joint between layers of bricks or masonry units.",
      },
      {
        term: "Bevelled Edge Brick",
        definition:
          "A brick with chamfered or angled edges for decorative or structural purposes.",
      },
      {
        term: "Bond Beam",
        definition:
          "A horizontal reinforced concrete or masonry beam that ties a structure together and provides additional strength.",
      },
      {
        term: "Bonding Coat",
        definition:
          "A preparatory plaster layer applied to improve adhesion for subsequent coats.",
      },
      {
        term: "Brick Veneer",
        definition:
          "A thin layer of brick used as a decorative facing over another structural material.",
      },
      {
        term: "Brick Trowel",
        definition:
          "A hand tool with a flat, pointed blade used for spreading and shaping mortar.",
      },
      {
        term: "Brickwork",
        definition:
          "The construction of walls, arches, or other structures using bricks and mortar.",
      },
      {
        term: "Bull Float",
        definition:
          "A large, flat tool used to smooth freshly poured concrete surfaces.",
      },
      {
        term: "Bullnose Brick",
        definition:
          "A brick with one or more rounded edges, commonly used for window sills, steps, or decorative trims.",
      },
      {
        term: "Buttering",
        definition:
          "The act of applying mortar to the side of a brick or stone before placing it in position.",
      },
      {
        term: "Cavity Wall",
        definition:
          "A wall consisting of two layers (wythes) with a gap (cavity) between them for insulation and moisture control.",
      },
      {
        term: "Cement Render",
        definition:
          "A sand, cement, and water mixture applied to walls for a smooth or textured finish.",
      },
      {
        term: "Clinker Brick",
        definition:
          "A brick that has been overburned in the kiln, resulting in a hard, dense, often irregular shape.",
      },
      {
        term: "Coarse Aggregate",
        definition:
          "Large particles such as gravel or crushed stone used in concrete mixes for added strength.",
      },
      {
        term: "Common Bond",
        definition:
          "A traditional brick-laying pattern where every fifth or sixth course consists of headers to tie the wall together.",
      },
      {
        term: "Compressive Strength",
        definition:
          "The maximum load a material can withstand before failure under compression.",
      },
      {
        term: "Concrete Block",
        definition:
          "A precast, rectangular masonry unit made from concrete, used for walls and structural applications.",
      },
      {
        term: "Control Joint",
        definition:
          "A planned joint in masonry or concrete that allows for expansion and contraction without causing cracks.",
      },
      {
        term: "Course",
        definition:
          "A single horizontal layer of bricks, blocks, or stones in a masonry structure.",
      },
      {
        term: "Crack Control Mesh",
        definition:
          "A mesh reinforcement embedded in plaster or mortar to prevent cracking.",
      },
      {
        term: "Curing Compound",
        definition:
          "A liquid applied to fresh concrete or mortar to retain moisture and promote proper curing.",
      },
      {
        term: "Damp Proof Course",
        definition:
          "A barrier, usually a layer of waterproof material, placed in walls to prevent rising damp from the ground.",
      },
      {
        term: "Decorative Plaster",
        definition:
          "Plaster applied for aesthetic purposes, often featuring textures, patterns, or artistic designs.",
      },
      {
        term: "Dry Bond",
        definition:
          "A construction method where bricks or stones are placed together without mortar, typically for test fitting.",
      },
      {
        term: "Dry Dash Finish",
        definition:
          "A textured wall finish created by throwing small stones onto wet plaster or render.",
      },
      {
        term: "Dry Pack Mortar",
        definition:
          "A stiff, low-water-content mortar mix used for repairing concrete or filling narrow joints.",
      },
      {
        term: "Dutch Bond",
        definition:
          "A brickwork pattern that alternates headers and stretchers in every course for strength and aesthetics.",
      },
      {
        term: "Efflorescence",
        definition:
          "White, powdery salt deposits that appear on masonry surfaces due to water evaporation.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A flexible joint that allows masonry or concrete structures to expand and contract without cracking.",
      },
      {
        term: "Exterior Render",
        definition:
          "A protective and decorative coating applied to external walls.",
      },
      {
        term: "Exposed Brickwork",
        definition:
          "Brick surfaces left visible as a design feature rather than being covered with plaster or paint.",
      },
      {
        term: "Face Brick",
        definition:
          "Bricks with a high-quality finish intended to remain visible on a wall's surface.",
      },
      {
        term: "Fascia Brick",
        definition:
          "A type of face brick specifically designed for external cladding with an aesthetic appeal.",
      },
      {
        term: "Feather Edge",
        definition:
          "A thin, tapered edge created in plastering or rendering for a smooth transition between layers.",
      },
      {
        term: "Fire Clay Brick",
        definition:
          "A heat-resistant brick made from special clay, used in fireplaces, kilns, and furnaces.",
      },
      {
        term: "Fire-Resistant Plaster",
        definition:
          "Plaster formulated with fire-retardant properties to slow the spread of flames.",
      },
      {
        term: "Flemish Bond",
        definition:
          "A brick-laying pattern alternating headers and stretchers in every course for strength and aesthetics.",
      },
      {
        term: "Float Finish",
        definition:
          "A smooth or textured surface achieved by using a float on fresh plaster or concrete.",
      },
      {
        term: "Fly Ash Brick",
        definition:
          "A lightweight, eco-friendly brick made from fly ash, sand, and cement, often used in sustainable construction.",
      },
      {
        term: "Footing",
        definition:
          "The lowest part of a foundation that spreads the load of a structure to the ground.",
      },
      {
        term: "Formwork",
        definition:
          "Temporary molds used to shape and support concrete until it hardens.",
      },
      {
        term: "Furring Strip",
        definition:
          "Thin strips of wood or metal used to create a level surface for attaching wall coverings.",
      },
      {
        term: "Gauge Rod",
        definition:
          "A tool used to ensure uniform thickness and alignment in bricklaying and plastering.",
      },
      {
        term: "Glazed Brick",
        definition:
          "Bricks coated with a ceramic finish to create a glossy, decorative, and water-resistant surface.",
      },
      {
        term: "Grout",
        definition:
          "A fluid mixture of cement, sand, and water used to fill gaps between masonry units or tiles.",
      },
      {
        term: "Groove Joint",
        definition:
          "A joint with a groove cut into it to control cracking or provide an aesthetic finish.",
      },
      {
        term: "Groundwork",
        definition:
          "The preparation of a site for construction, including excavation, foundation laying, and utility installation.",
      },
      {
        term: "Half-Bond",
        definition:
          "A brickwork pattern where each brick is offset by half its length from the bricks in the row below.",
      },
      {
        term: "Header Brick",
        definition:
          "A brick laid with its shorter end exposed in a wall, often used in bonding patterns.",
      },
      {
        term: "High-Density Block",
        definition:
          "A heavy concrete block with high compressive strength, used in structural walls.",
      },
      {
        term: "Hollow Brick",
        definition:
          "A brick with cavities inside to reduce weight and improve insulation.",
      },
      {
        term: "Hydrated Lime",
        definition:
          "A lime product mixed with water to improve the workability and durability of mortar and plaster.",
      },
      {
        term: "Infill Brickwork",
        definition:
          "Masonry used to fill gaps within a structural frame, often for non-load-bearing walls.",
      },
      {
        term: "Insulated Plasterboard",
        definition:
          "A type of plasterboard with an insulating layer to improve thermal efficiency.",
      },
      {
        term: "Interior Plastering",
        definition:
          "The application of plaster to interior walls and ceilings for a smooth or decorative finish.",
      },
      {
        term: "Interlocking Brick",
        definition:
          "A specially designed brick that fits into adjacent bricks, reducing the need for mortar.",
      },
      {
        term: "Jack Arch",
        definition:
          "A shallow, flat arch used above openings, typically constructed with bricks or stones.",
      },
      {
        term: "Jointing Tool",
        definition: "A tool used to shape and finish mortar joints in masonry.",
      },
      {
        term: "Joint Reinforcement",
        definition:
          "Metal reinforcement embedded in mortar joints to strengthen masonry structures and control cracking.",
      },
      {
        term: "Keystone",
        definition:
          "The central, wedge-shaped stone or brick in an arch that holds the structure together.",
      },
      {
        term: "Kiln-Fired Brick",
        definition:
          "A brick hardened by high-temperature firing in a kiln, increasing its durability.",
      },
      {
        term: "Lath",
        definition:
          "Thin wooden, metal, or gypsum strips used as a base for plaster application.",
      },
      {
        term: "Lath and Plaster",
        definition:
          "A traditional wall construction method using wooden laths covered with multiple layers of plaster.",
      },
      {
        term: "Lime Mortar",
        definition:
          "A mortar made with lime, sand, and water, known for its flexibility and breathability.",
      },
      {
        term: "Load-Bearing Wall",
        definition:
          "A structural wall that supports the weight of a building in addition to its own weight.",
      },
      {
        term: "Masonry Cement",
        definition:
          "A type of cement specifically formulated for mortar and masonry construction.",
      },
      {
        term: "Mortar Joints",
        definition:
          "The spaces between bricks or stones filled with mortar, which can have various finishes.",
      },
      {
        term: "Moulding Plaster",
        definition:
          "A fine plaster used for creating decorative moldings and ornamental details.",
      },
      {
        term: "Multi-Finish Plaster",
        definition:
          "A versatile plaster used to create smooth finishes on various surfaces.",
      },
      {
        term: "Muntin",
        definition:
          "A bar or strip that separates panes of glass in a window or door.",
      },
      {
        term: "Non-Load Bearing Wall",
        definition:
          "A partition wall that does not support the weight of a structure but divides spaces.",
      },
      {
        term: "Notched Trowel",
        definition:
          "A trowel with a serrated edge, used for applying adhesive or mortar in ridges.",
      },
      {
        term: "Ornamental Plaster",
        definition:
          "Decorative plaster used for molding intricate designs on walls and ceilings.",
      },
      {
        term: "Overhand Work",
        definition:
          "Plastering or masonry work done on overhead surfaces such as ceilings.",
      },
      {
        term: "Parapet Wall",
        definition:
          "A low protective wall along the edge of a roof, balcony, or terrace.",
      },
      {
        term: "Partition Wall",
        definition: "A non-structural wall used to divide interior spaces.",
      },
      {
        term: "Perforated Brick",
        definition:
          "A brick with holes to reduce weight and improve bonding with mortar.",
      },
      {
        term: "Plaster Bead",
        definition:
          "A strip used to create clean edges and reinforcement in plastered walls.",
      },
      {
        term: "Plaster Skim Coat",
        definition:
          "A thin, smooth layer of plaster applied as a final finish.",
      },
      {
        term: "Plaster Stop Bead",
        definition:
          "A metal or plastic strip used to create a neat edge in plastering.",
      },
      {
        term: "Pointing",
        definition:
          "The process of finishing and sealing mortar joints in masonry for durability and aesthetics.",
      },
      {
        term: "Portland Cement",
        definition:
          "A common type of cement used in concrete, mortar, and plaster.",
      },
      {
        term: "Precast Brick",
        definition:
          "A brick or block manufactured off-site and brought to the construction site for installation.",
      },
      {
        term: "Pumice Block",
        definition:
          "A lightweight concrete block made with pumice aggregate, providing insulation and durability.",
      },
      {
        term: "Quoin",
        definition:
          "The corner of a masonry structure, often emphasized with decorative or larger bricks or stones.",
      },
      {
        term: "Quoin Brickwork",
        definition:
          "A technique using contrasting bricks or stones at corners for structural or aesthetic purposes.",
      },
      {
        term: "Radial Brickwork",
        definition:
          "Brickwork arranged in a circular or curved pattern, commonly used in arches and curved walls.",
      },
      {
        term: "Render Mix",
        definition:
          "A blend of cement, sand, and water used for rendering walls.",
      },
      {
        term: "Repointing",
        definition:
          "The process of renewing deteriorated mortar joints in masonry.",
      },
      {
        term: "Retaining Wall",
        definition: "A wall designed to hold back soil or prevent erosion.",
      },
      {
        term: "Rib Lath",
        definition:
          "A metal mesh used as a reinforcement for plaster and stucco applications.",
      },
      {
        term: "Running Bond",
        definition:
          "A common brickwork pattern where bricks are staggered by half their length in each row.",
      },
      {
        term: "Sand-Faced Plaster",
        definition:
          "A plaster finish with a textured surface resembling sandpaper.",
      },
      {
        term: "Sand-Lime Brick",
        definition:
          "A brick made from sand and lime, known for its smooth finish and durability.",
      },
      {
        term: "Scratch Coat",
        definition:
          "The first rough coat of plaster, providing a textured surface for subsequent layers.",
      },
      {
        term: "Screed",
        definition:
          "A flat board or tool used to level concrete or plaster surfaces.",
      },
      {
        term: "Sealing Plaster",
        definition:
          "A finishing coat designed to seal and smooth surfaces before painting.",
      },
      {
        term: "Segmental Arch",
        definition:
          "An arch with a circular segment profile, commonly used in doorways and windows.",
      },
      {
        term: "Setting Time",
        definition:
          "The time it takes for plaster, cement, or mortar to harden.",
      },
      {
        term: "Skim Coat",
        definition:
          "A thin layer of plaster applied to create a smooth surface.",
      },
      {
        term: "Soffit",
        definition:
          "The underside of a structural element, such as an arch or overhang.",
      },
      {
        term: "Spalling",
        definition:
          "The flaking or chipping of brick or concrete due to weathering or water damage.",
      },
      {
        term: "Stucco",
        definition:
          "A decorative and protective plaster finish applied to walls and ceilings.",
      },
      {
        term: "Structural Brickwork",
        definition: "Brick construction designed to bear structural loads.",
      },
      {
        term: "Structural Plaster",
        definition:
          "A strong, durable plaster used in load-bearing applications.",
      },
      {
        term: "Thin Brick",
        definition:
          "A lightweight, thin version of traditional brick used for veneers.",
      },
      {
        term: "Tiling Render",
        definition:
          "A base layer of plaster designed to support tile installation.",
      },
      {
        term: "Trowel Finish",
        definition:
          "A smooth surface created using a trowel on wet plaster or concrete.",
      },
      {
        term: "Tuckpointing",
        definition:
          "A masonry technique where thin lines of contrasting mortar are used to improve the appearance of joints.",
      },
      {
        term: "Undercoat Plaster",
        definition: "The first layer of plaster applied before the final coat.",
      },
      {
        term: "Veneer Brick",
        definition: "A thin layer of brick used for decorative facades.",
      },
      {
        term: "Wainscot",
        definition:
          "A decorative or protective covering on the lower portion of an interior wall.",
      },
      {
        term: "Water-Resistant Plaster",
        definition:
          "A plaster mix designed to resist moisture, commonly used in bathrooms and kitchens.",
      },
      {
        term: "Weep Holes",
        definition:
          "Small openings in walls to allow water drainage and prevent moisture buildup.",
      },
      {
        term: "Workability",
        definition:
          "The ease with which mortar or plaster can be applied, shaped, and finished.",
      },
      {
        term: "Zero-Slump Mortar",
        definition:
          "A stiff mortar mix that retains its shape and does not flow under its own weight.",
      },
      {
        term: "Zoning Regulations",
        definition:
          "Legal requirements dictating the use, size, and construction of buildings in specific areas.",
      },
    ],
  },

  carpentry: {
    promotionalText:
      "From furniture to fine finishes, LaborHack carpenters craft perfection you can trust.",
    terms: [
      {
        term: "Adhesive",
        definition:
          "A substance used for bonding materials together, such as wood glue or epoxy.",
      },
      {
        term: "Air-Dried Lumber",
        definition:
          "Wood that has been naturally dried by exposure to air rather than using a kiln.",
      },
      {
        term: "Architrave",
        definition:
          "A decorative molding that frames a doorway, window, or opening.",
      },
      {
        term: "Auger Bit",
        definition:
          "A drill bit designed for boring deep holes in wood, featuring a spiral body and a screw tip.",
      },
      {
        term: "Awl",
        definition:
          "A pointed tool used for marking or piercing wood and other materials.",
      },
      {
        term: "Baluster",
        definition:
          "A vertical support in a staircase or railing, commonly used in balustrades.",
      },
      {
        term: "Band Saw",
        definition:
          "A power saw with a continuous looped blade used for cutting curves and resawing wood.",
      },
      {
        term: "Baseboard",
        definition:
          "A molding installed along the bottom of interior walls for protection and decoration.",
      },
      {
        term: "Bevel Cut",
        definition: "An angled cut along the edge of a piece of wood.",
      },
      {
        term: "Biscuit Joint",
        definition:
          "A woodworking joint reinforced with an oval-shaped, compressed wood biscuit.",
      },
      {
        term: "Blockboard",
        definition:
          "A type of engineered wood panel made of a core of softwood strips sandwiched between layers of veneer.",
      },
      {
        term: "Brace",
        definition:
          "A reinforcing piece of wood or metal used to strengthen a structure.",
      },
      {
        term: "Bridle Joint",
        definition:
          "A joint in which one piece has a slot (or mortise) that fits over the end of another piece (tenon).",
      },
      {
        term: "Built-in Cabinet",
        definition:
          "A cabinet designed to fit permanently within a wall or structure.",
      },
      {
        term: "Butt Joint",
        definition:
          "A simple joint where two pieces of wood are joined at their ends or edges without any special shaping.",
      },
      {
        term: "Cabinet Hinge",
        definition:
          "A hinge specifically designed for cabinet doors, available in different styles like concealed or overlay hinges.",
      },
      {
        term: "Carcass",
        definition:
          "The main framework or structure of a cabinet, furniture piece, or other woodworking project.",
      },
      {
        term: "Caulking",
        definition:
          "A flexible sealing material used to fill gaps and joints in construction and woodworking.",
      },
      {
        term: "Chamfer",
        definition:
          "A beveled edge cut at a 45-degree angle on the corner of a piece of wood.",
      },
      {
        term: "Chisel",
        definition:
          "A hand tool with a sharpened edge used for carving or shaping wood.",
      },
      {
        term: "Circular Saw",
        definition:
          "A power saw with a rotating toothed blade for making straight cuts in wood and other materials.",
      },
      {
        term: "Cladding",
        definition:
          "A covering or layer applied to a surface for protection or decorative purposes.",
      },
      {
        term: "Claw Hammer",
        definition:
          "A hammer with one side used for driving nails and the other side (a curved claw) for removing them.",
      },
      {
        term: "Composite Wood",
        definition:
          "Engineered wood products made from wood fibers, particles, or veneers bonded with adhesives.",
      },
      {
        term: "Countersink",
        definition:
          "A conical hole drilled to allow a screw head to sit flush with or below the wood surface.",
      },
      {
        term: "Countertop",
        definition:
          "A flat work surface found in kitchens, bathrooms, or workspaces, typically made from wood, laminate, or stone.",
      },
      {
        term: "Crosscut Saw",
        definition: "A saw designed to cut across the grain of wood.",
      },
      {
        term: "Crown Molding",
        definition:
          "Decorative trim installed at the junction of walls and ceilings.",
      },
      {
        term: "Custom Shelving",
        definition:
          "Shelving systems built to specific measurements and designs for storage or display.",
      },
      {
        term: "Dado Joint",
        definition:
          "A joint in which a slot is cut across the grain of one piece to receive another piece.",
      },
      {
        term: "Decorative Trim",
        definition:
          "Molding or detailing added to furniture, walls, or cabinetry for aesthetic enhancement.",
      },
      {
        term: "Dovetail Joint",
        definition:
          "A strong interlocking woodworking joint with wedge-shaped cuts resembling a dove's tail.",
      },
      {
        term: "Dowels",
        definition:
          "Cylindrical wooden or metal rods used to reinforce joints.",
      },
      {
        term: "Drawer Slides",
        definition:
          "Metal or plastic mechanisms that allow drawers to open and close smoothly.",
      },
      {
        term: "Drill Press",
        definition:
          "A stationary power tool used for drilling precise holes in wood and other materials.",
      },
      {
        term: "Drywall Screws",
        definition:
          "Screws designed for securing drywall to wood or metal studs, often used in construction and carpentry.",
      },
      {
        term: "Eaves",
        definition:
          "The lower edges of a roof that extend beyond the walls of a building.",
      },
      {
        term: "Edge Banding",
        definition:
          "A thin strip of material applied to the exposed edges of plywood or MDF for a finished look.",
      },
      {
        term: "Engineered Wood",
        definition:
          "A broad category of manufactured wood products, including plywood, MDF, and particleboard.",
      },
      {
        term: "Epoxy Adhesive",
        definition:
          "A strong, durable adhesive commonly used in woodworking and construction.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A gap designed to accommodate the expansion and contraction of materials due to temperature changes.",
      },
      {
        term: "Face Frame",
        definition:
          "The front frame of a cabinet or furniture piece to which doors and drawers are attached.",
      },
      {
        term: "Fasteners",
        definition:
          "Hardware such as nails, screws, and bolts used to join materials together.",
      },
      {
        term: "Feather Edge",
        definition: "A tapered or thin edge on a piece of wood.",
      },
      {
        term: "Finger Joint",
        definition:
          "An interlocking joint made by cutting a series of complementary rectangular profiles into two pieces of wood.",
      },
      {
        term: "Finish Carpentry",
        definition:
          "The final stages of carpentry, including trim work, molding, and other decorative details.",
      },
      {
        term: "Floating Shelves",
        definition:
          "Wall-mounted shelves that appear to have no visible supports.",
      },
      {
        term: "Flush Trim",
        definition:
          "A technique or tool used to trim one surface flush with another, often using a router.",
      },
      {
        term: "Formica",
        definition:
          "A brand of laminate material used for countertops and surfaces.",
      },
      {
        term: "Formwork",
        definition:
          "Temporary molds or frameworks used to shape concrete until it hardens.",
      },
      {
        term: "Framing",
        definition: "The structural skeleton of a building or furniture piece.",
      },
      {
        term: "Framing Square",
        definition:
          "A large, L-shaped measuring tool used for marking and checking right angles in framing and woodworking.",
      },
      {
        term: "Gable Roof",
        definition: "A roof with two sloping sides that form a peak.",
      },
      {
        term: "Grain",
        definition:
          "The pattern and direction of wood fibers in a piece of lumber.",
      },
      {
        term: "Grit",
        definition:
          "A measure of the coarseness of sandpaper or grinding materials.",
      },
      {
        term: "Groove Joint",
        definition:
          "A woodworking joint where one piece has a groove cut to fit another piece.",
      },
      {
        term: "Glue-Laminated Timber (Glulam)",
        definition:
          "An engineered wood product made by bonding layers of wood together with adhesives.",
      },
      {
        term: "Hand Saw",
        definition: "A manually operated saw for cutting wood.",
      },
      {
        term: "Hardwood",
        definition:
          "Wood from deciduous trees, typically denser and stronger than softwood.",
      },
      {
        term: "Hinge Mortise",
        definition:
          "A recessed area cut into wood to house a hinge, ensuring it sits flush with the surface.",
      },
      {
        term: "Hinges",
        definition:
          "Metal pivoting devices that allow doors, cabinets, or furniture to open and close.",
      },
      {
        term: "Housing Joint",
        definition:
          "A woodworking joint where a slot is cut into one piece to receive another piece, often used in shelving.",
      },
      {
        term: "Impact Driver",
        definition:
          "A power tool designed for driving screws and fasteners with high torque.",
      },
      {
        term: "Inlay Work",
        definition:
          "A decorative technique where pieces of contrasting material are embedded into wood surfaces.",
      },
      {
        term: "Inset Cabinet Door",
        definition:
          "A cabinet door that fits flush within the frame rather than overlapping it.",
      },
      {
        term: "Insulation Board",
        definition:
          "Rigid boards made of materials like foam or fiberglass used to improve thermal insulation.",
      },
      {
        term: "Interior Trim",
        definition:
          "Decorative moldings used inside buildings, such as baseboards, crown molding, and door casings.",
      },
      {
        term: "Jack Plane",
        definition: "A hand plane used for smoothing and shaping wood.",
      },
      {
        term: "Jigsaw",
        definition:
          "A power saw with a narrow, reciprocating blade used for making curved and intricate cuts.",
      },
      {
        term: "Joinery",
        definition:
          "The craft of joining wood pieces together using various techniques like dovetails, mortise and tenon, or biscuits.",
      },
      {
        term: "Kerf",
        definition:
          "The width of the cut made by a saw blade, which determines how much material is removed.",
      },
      {
        term: "Kick Plate",
        definition:
          "A protective plate, usually metal, attached to the bottom of doors to prevent damage from foot traffic.",
      },
      {
        term: "Kiln-Dried Wood",
        definition:
          "Wood that has been dried in a kiln to reduce moisture content and improve stability.",
      },
      {
        term: "Kitchen Cabinets",
        definition:
          "Storage units installed in kitchens, often made from wood, MDF, or laminate.",
      },
      {
        term: "Laminated Board",
        definition:
          "A type of engineered wood made by gluing layers of thin wood or veneer together.",
      },
      {
        term: "Lap Joint",
        definition:
          "A joint where two pieces of wood overlap and are secured together, often used for added strength.",
      },
      {
        term: "Ledger Board",
        definition:
          "A horizontal board attached to a wall to support joists or beams in decking and framing.",
      },
      {
        term: "Leveling Screed",
        definition:
          "A layer of material applied to a surface to ensure it is level and smooth, often used in flooring.",
      },
      {
        term: "MDF (Medium-Density Fiberboard)",
        definition:
          "A type of engineered wood made from compressed wood fibers and resin, known for its smooth surface.",
      },
      {
        term: "Miter Joint",
        definition:
          "A joint made by cutting two pieces of wood at an angle (usually 45 degrees) to form a corner.",
      },
      {
        term: "Molding",
        definition:
          "Decorative trim used to enhance architectural details on walls, ceilings, and furniture.",
      },
      {
        term: "Mortise and Tenon Joint",
        definition:
          "A strong, traditional woodworking joint where a tenon (a rectangular projection) fits into a mortise (a corresponding hole).",
      },
      {
        term: "Mullion",
        definition:
          "A vertical or horizontal divider used in windows, doors, and paneling.",
      },
      {
        term: "Nail Gun",
        definition:
          "A power tool that drives nails into wood quickly and efficiently.",
      },
      {
        term: "Notching",
        definition:
          "The process of cutting out sections of wood to fit another piece, commonly used in framing and joinery.",
      },
      {
        term: "Ornamental Trim",
        definition:
          "Decorative woodwork used to enhance furniture, doors, or architectural details.",
      },
      {
        term: "Overhang",
        definition:
          "The portion of a roof, countertop, or ledge that extends beyond the supporting structure.",
      },
      {
        term: "Paneling",
        definition:
          "Decorative or protective wood panels used on walls, ceilings, or furniture.",
      },
      {
        term: "Particle Board",
        definition:
          "An engineered wood product made from compressed wood chips and resin, used for furniture and flooring.",
      },
      {
        term: "Pergola",
        definition:
          "An outdoor structure with an open framework, often used for shading or decorative purposes.",
      },
      {
        term: "Pilot Hole",
        definition:
          "A small hole drilled before inserting a screw to prevent wood from splitting.",
      },
      {
        term: "Plinth",
        definition:
          "A base or support at the bottom of a column, furniture piece, or door frame.",
      },
      {
        term: "Plywood",
        definition:
          "A strong, multi-layered engineered wood made by gluing thin sheets of wood together in alternating grain directions.",
      },
      {
        term: "Pocket Hole Joint",
        definition:
          "A joint created by drilling angled holes for screws, commonly used in cabinetry and furniture making.",
      },
      {
        term: "Polyurethane Finish",
        definition:
          "A durable, protective wood finish that enhances appearance and resists moisture.",
      },
      {
        term: "Porch Railing",
        definition:
          "A protective and decorative barrier installed along the edge of a porch.",
      },
      {
        term: "Post and Beam Construction",
        definition:
          "A framing method using large, heavy timber posts and beams instead of studs.",
      },
      {
        term: "Quarter Round Trim",
        definition:
          "A molding with a quarter-circle profile used to cover gaps between flooring and walls.",
      },
      {
        term: "Rabbet Joint",
        definition:
          "A joint where a groove is cut into the edge of one piece of wood to receive another piece.",
      },
      {
        term: "Rail and Stile",
        definition:
          "A construction method used in door and cabinet frames, consisting of horizontal (rails) and vertical (stiles) components.",
      },
      {
        term: "Rafter",
        definition: "A sloped structural beam that supports a roof.",
      },
      {
        term: "Raised Panel",
        definition:
          "A decorative panel with a raised center, commonly used in doors and cabinetry.",
      },
      {
        term: "Rebated Joint",
        definition:
          "A type of joint similar to a rabbet joint, where a recess is cut along the edge of a board to fit another board.",
      },
      {
        term: "Router Tool",
        definition:
          "A power tool used to hollow out areas in wood for decorative edges, joinery, or grooves.",
      },
      {
        term: "Sanding Block",
        definition:
          "A handheld tool used to hold sandpaper for smoothing wood surfaces.",
      },
      {
        term: "Sawhorse",
        definition:
          "A sturdy frame used to support wood during cutting or construction.",
      },
      {
        term: "Scarf Joint",
        definition:
          "A joint where two pieces are tapered and overlapped to create a longer piece of wood.",
      },
      {
        term: "Scribe Work",
        definition:
          "The process of precisely fitting wood pieces to irregular surfaces.",
      },
      {
        term: "Sill Plate",
        definition:
          "A horizontal wooden member placed at the base of a wall or structure for support.",
      },
      {
        term: "Skirting Board",
        definition:
          "A molding along the bottom of walls, protecting them from damage and hiding gaps.",
      },
      {
        term: "Softwood",
        definition:
          "Wood sourced from coniferous trees, generally lighter and easier to work with than hardwood.",
      },
      {
        term: "Spline Joint",
        definition:
          "A joint reinforced with a thin strip of wood (spline) inserted into matching grooves on both pieces.",
      },
      {
        term: "Structural Plywood",
        definition:
          "Plywood specifically designed for load-bearing applications in construction.",
      },
      {
        term: "Stud Wall",
        definition:
          "A wall constructed with vertical wooden or metal framing members (studs).",
      },
      {
        term: "Subfloor",
        definition:
          "The foundational layer of flooring onto which the final floor covering is installed.",
      },
      {
        term: "Tongue and Groove Joint",
        definition:
          "A joint where one piece of wood has a protruding tongue that fits into a groove in another piece for a tight connection.",
      },
      {
        term: "Trusses",
        definition:
          "Structural frameworks used to support roofs or bridges, often made of interconnected wooden or metal beams.",
      },
      {
        term: "Underlayment",
        definition:
          "A layer of material placed beneath flooring to provide cushioning, support, or moisture protection.",
      },
      {
        term: "Varnish",
        definition:
          "A protective wood finish that enhances durability and appearance.",
      },
      {
        term: "Veneer",
        definition:
          "A thin sheet of wood applied to a surface for decorative purposes.",
      },
      {
        term: "Warping",
        definition:
          "The distortion of wood due to uneven drying, moisture, or heat exposure.",
      },
      {
        term: "Weatherproofing",
        definition:
          "The process of protecting wood from moisture, wind, and temperature changes to increase its lifespan.",
      },
      {
        term: "Window Casings",
        definition:
          "The trim or molding that surrounds a window to provide a finished look.",
      },
    ],
  },

  electrical: {
    promotionalText:
      "Keep the lights on and the systems safe, LaborHack electricians deliver power you can rely on.",
    terms: [
      {
        term: "AC (Alternating Current)",
        definition:
          "An electric current that reverses direction periodically, commonly used in homes and businesses.",
      },
      {
        term: "Ampacity",
        definition:
          "The maximum amount of electrical current a conductor can safely carry without overheating.",
      },
      {
        term: "Ampere (Amp)",
        definition: "The unit of measurement for electrical current.",
      },
      {
        term: "Architectural Wiring",
        definition:
          "The electrical wiring designed to be aesthetically integrated into a building's architecture.",
      },
      {
        term: "Armored Cable (BX Cable)",
        definition:
          "A type of electrical cable covered with a metal sheath for added protection.",
      },
      {
        term: "Bonding",
        definition:
          "The practice of connecting electrical conductors to ensure a continuous and safe grounding system.",
      },
      {
        term: "Breaker Panel",
        definition:
          "A metal box containing circuit breakers used to distribute electrical power and protect circuits.",
      },
      {
        term: "Busbar",
        definition:
          "A metallic strip or bar that conducts electricity within a switchboard or distribution board.",
      },
      {
        term: "Cable Pulling",
        definition:
          "The process of installing electrical cables through conduits or trays.",
      },
      {
        term: "Cable Tray",
        definition:
          "A system of trays used to support insulated electrical cables.",
      },
      {
        term: "Capacitor",
        definition:
          "An electrical component that stores and releases energy in a circuit.",
      },
      {
        term: "Circuit",
        definition: "A complete path through which electricity flows.",
      },
      {
        term: "Circuit Breaker",
        definition:
          "A device that automatically stops electrical flow in case of an overload or short circuit.",
      },
      {
        term: "Conduit",
        definition: "A protective tube used to house electrical wiring.",
      },
      {
        term: "Conduit Bender",
        definition:
          "A tool used to manually shape metal conduits to route electrical wiring.",
      },
      {
        term: "Contactors",
        definition:
          "Electrically controlled switches used in high-power circuits.",
      },
      {
        term: "Current",
        definition: "The flow of electric charge in a circuit.",
      },
      {
        term: "Direct Burial Cable",
        definition:
          "Electrical wiring designed to be buried underground without requiring a conduit.",
      },
      {
        term: "Disconnect Switch",
        definition:
          "A switch used to isolate electrical circuits for maintenance or safety.",
      },
      {
        term: "Distribution Board",
        definition:
          "A panel that distributes electrical power to different circuits in a building.",
      },
      {
        term: "Drip Loop",
        definition:
          "A loop of electrical wire placed before an entry point to prevent water from following the wire into a building.",
      },
      {
        term: "Earthing System",
        definition:
          "A network of conductors that safely dissipates electrical faults into the ground.",
      },
      {
        term: "Electrical Code",
        definition:
          "A set of regulations governing the safe installation of electrical systems.",
      },
      {
        term: "Electrical Conduit",
        definition: "A protective tube that encases electrical wiring.",
      },
      {
        term: "Electrical Grounding",
        definition:
          "The practice of connecting an electrical system to the ground to enhance safety.",
      },
      {
        term: "Electrical Load",
        definition:
          "The amount of power consumed by electrical devices in a system.",
      },
      {
        term: "Electrical Panel",
        definition:
          "A box containing circuit breakers or fuses that control electricity distribution.",
      },
      {
        term: "Electrical Resistance",
        definition:
          "The opposition to the flow of electrical current in a circuit.",
      },
      {
        term: "Emergency Lighting",
        definition:
          "Battery-powered or generator-backed lighting systems that activate during a power outage.",
      },
      {
        term: "Energy Efficiency",
        definition:
          "The ratio of useful energy output to energy input, indicating how effectively electricity is used in a system.",
      },
      {
        term: "Fault Current",
        definition:
          "The excess electrical current that flows through a circuit during a fault condition.",
      },
      {
        term: "Feeder Cable",
        definition:
          "A main electrical cable that delivers power from a distribution panel to sub-panels or equipment.",
      },
      {
        term: "Flexible Conduit",
        definition:
          "A bendable tube used to protect electrical wiring in tight or movable installations.",
      },
      {
        term: "Fuse",
        definition:
          "A protective device that melts and breaks the circuit when excessive current flows through it.",
      },
      {
        term: "Generator Transfer Switch",
        definition:
          "A switch that transfers power between the electrical grid and a backup generator.",
      },
      {
        term: "GFCI (Ground Fault Circuit Interrupter)",
        definition:
          "A safety device that shuts off electrical power when it detects a ground fault, preventing electric shocks.",
      },
      {
        term: "Grounding Electrode",
        definition:
          "A metal rod or plate buried in the earth to provide a safe path for electrical faults.",
      },
      {
        term: "High-Voltage Wiring",
        definition:
          "Electrical wiring designed for systems operating at high voltage levels, typically above 1,000 volts.",
      },
      {
        term: "HVAC Wiring",
        definition:
          "Electrical wiring used in heating, ventilation, and air conditioning systems.",
      },
      {
        term: "HVLP (High Volume Low Pressure) Sprayer",
        definition:
          "A spray system that delivers paint with minimal overspray and waste.",
      },
      {
        term: "Industrial Circuit Breaker",
        definition:
          "A high-capacity circuit breaker used in industrial electrical systems.",
      },
      {
        term: "Insulation Resistance",
        definition:
          "A measure of how well an electrical insulator prevents current leakage.",
      },
      {
        term: "Inverter",
        definition:
          "A device that converts direct current (DC) into alternating current (AC).",
      },
      {
        term: "Isolator Switch",
        definition:
          "A switch used to disconnect electrical equipment from the power source.",
      },
      {
        term: "Junction Box",
        definition:
          "A protective enclosure where electrical wires are connected and contained.",
      },
      {
        term: "Lightning Protection System",
        definition:
          "A network of rods, conductors, and grounding devices designed to protect buildings from lightning strikes.",
      },
      {
        term: "Load Balancing",
        definition:
          "The process of evenly distributing electrical loads across different circuits to prevent overloading.",
      },
      {
        term: "Load Center",
        definition:
          "Another term for a breaker panel; it distributes electrical power to different circuits.",
      },
      {
        term: "Low-Voltage Wiring",
        definition:
          "Electrical wiring used for systems operating below 50 volts, such as doorbells, security cameras, and LED lighting.",
      },
      {
        term: "Main Service Panel",
        definition:
          "The primary electrical panel that receives power from the utility and distributes it throughout a building.",
      },
      {
        term: "Megohmmeter",
        definition:
          "A testing device that measures electrical insulation resistance in megohms.",
      },
      {
        term: "Metal-Clad (MC) Cable",
        definition:
          "Electrical cable with a metal sheath for added protection.",
      },
      {
        term: "Multimeter",
        definition:
          "A handheld device used to measure voltage, current, and resistance.",
      },
      {
        term: "Neutral Wire",
        definition:
          "A conductor that carries current back to the power source to complete an electrical circuit.",
      },
      {
        term: "Non-Metallic Sheathed Cable (NM Cable)",
        definition:
          "A type of electrical cable with a plastic outer sheath, commonly used in residential wiring.",
      },
      {
        term: "Ohm",
        definition: "The unit of measurement for electrical resistance.",
      },
      {
        term: "Overcurrent Protection",
        definition:
          "Devices such as circuit breakers and fuses that prevent excessive current from damaging electrical systems.",
      },
      {
        term: "Overload Relay",
        definition:
          "A device that protects electrical motors from overheating by shutting off power when excessive current is detected.",
      },
      {
        term: "Panelboard",
        definition:
          "A distribution board that contains circuit breakers or fuses for controlling electrical circuits.",
      },
      {
        term: "Power Factor",
        definition:
          "A measure of how efficiently electrical power is converted into useful work.",
      },
      {
        term: "Power Surge",
        definition:
          "A sudden increase in voltage that can damage electrical devices.",
      },
      {
        term: "Protective Relay",
        definition:
          "A device that detects electrical faults and triggers circuit protection mechanisms.",
      },
      {
        term: "Rebar Grounding",
        definition:
          "The practice of connecting electrical grounding systems to steel reinforcement bars in concrete structures.",
      },
      {
        term: "Relay Switch",
        definition:
          "An electrically operated switch used to control high-power devices with low-power signals.",
      },
      {
        term: "Rigid Conduit",
        definition:
          "A heavy-duty metal or PVC pipe used to protect electrical wiring.",
      },
      {
        term: "Riser Cable",
        definition:
          "Electrical cable designed for vertical installation between building floors.",
      },
      {
        term: "Short Circuit",
        definition:
          "An electrical fault where current bypasses the normal path, leading to excessive current flow.",
      },
      {
        term: "Single-Phase Power",
        definition:
          "A type of electrical power supply commonly used in residential buildings, featuring one alternating current waveform.",
      },
      {
        term: "Smart Meters",
        definition:
          "Digital electricity meters that monitor and report energy usage in real time.",
      },
      {
        term: "Step-Down Transformer",
        definition:
          "A transformer that reduces voltage levels from high to low.",
      },
      {
        term: "Step-Up Transformer",
        definition:
          "A transformer that increases voltage levels from low to high.",
      },
      {
        term: "Surge Protector",
        definition:
          "A device that protects electrical equipment from voltage spikes.",
      },
      {
        term: "Switchgear",
        definition:
          "A combination of electrical disconnects, circuit breakers, and protective devices used to control and protect electrical systems.",
      },
      {
        term: "Temporary Power Supply",
        definition:
          "A provisional electrical supply used on construction sites or for events.",
      },
      {
        term: "Thermographic Inspection",
        definition:
          "The use of infrared cameras to detect heat buildup and potential electrical faults.",
      },
      {
        term: "Three-Phase Power",
        definition:
          "A high-efficiency power system commonly used in industrial and commercial settings.",
      },
      {
        term: "Transformer",
        definition:
          "A device that changes the voltage level of an alternating current (AC) electrical supply.",
      },
      {
        term: "Trunking",
        definition:
          "A protective casing used to organize and conceal electrical wiring.",
      },
      {
        term: "TSP (Trisodium Phosphate)",
        definition:
          "A cleaning agent used to remove grease and prepare surfaces before painting.",
      },
      {
        term: "Underground Conduit",
        definition:
          "A protective tube used to house electrical cables buried underground.",
      },
      {
        term: "Uninterruptible Power Supply (UPS)",
        definition:
          "A backup power system that provides electricity during outages.",
      },
      {
        term: "Voltage Drop",
        definition:
          "The reduction in electrical voltage as current flows through a circuit due to resistance.",
      },
      {
        term: "Voltage Regulator",
        definition:
          "A device that maintains a steady voltage level in an electrical system.",
      },
      {
        term: "Wattage",
        definition:
          "The measurement of electrical power consumption, expressed in watts.",
      },
      {
        term: "Weatherproof Electrical Box",
        definition:
          "An outdoor-rated electrical enclosure designed to protect connections from moisture and environmental elements.",
      },
      {
        term: "Wire Gauge",
        definition:
          "A measurement of wire thickness, which affects electrical capacity.",
      },
      {
        term: "Wiring Diagram",
        definition: "A graphical representation of an electrical circuit.",
      },
    ],
  },

  foreman: {
    promotionalText:
      "Need a project leader who gets the job done right? Every Foreman at LaborHack is a master of coordination.",
    terms: [
      {
        term: "Access Control",
        definition:
          "A system that regulates who can enter a construction site to ensure safety and security.",
      },
      {
        term: "Activity Schedule",
        definition:
          "A detailed timeline outlining the sequence and duration of construction tasks.",
      },
      {
        term: "Aggregate Planning",
        definition:
          "The process of balancing supply and demand in construction projects over a specific period.",
      },
      {
        term: "As-Built Drawings",
        definition:
          "Revised drawings that reflect all changes made during construction, showing the final structure.",
      },
      {
        term: "Asset Management",
        definition:
          "The tracking and maintenance of physical assets like equipment and materials in construction.",
      },
      {
        term: "AutoCAD",
        definition:
          "A computer-aided design (CAD) software used for drafting and designing construction projects.",
      },
      {
        term: "Backfilling",
        definition:
          "Refilling excavated areas with soil or other materials after construction work, such as foundation laying.",
      },
      {
        term: "Benchmarking",
        definition:
          "The process of comparing construction performance metrics against industry standards.",
      },
      {
        term: "Bill of Quantities",
        definition:
          "A detailed document listing materials, labor, and costs required for a project.",
      },
      {
        term: "Blueprint",
        definition:
          "A technical drawing that provides detailed construction plans and specifications.",
      },
      {
        term: "Building Code",
        definition:
          "A set of regulations that dictate safety and design standards for construction projects.",
      },
      {
        term: "Building Envelope",
        definition:
          "The physical barrier between the interior and exterior of a structure, including walls, roofs, and windows.",
      },
      {
        term: "Budget Estimation",
        definition:
          "The process of predicting costs for a construction project, including materials, labor, and contingencies.",
      },
      {
        term: "Bulk Materials",
        definition:
          "Large quantities of materials such as sand, gravel, cement, and steel used in construction.",
      },
      {
        term: "Cash Flow Forecast",
        definition:
          "A financial plan that estimates the inflow and outflow of money in a construction project.",
      },
      {
        term: "Ceiling Joist",
        definition:
          "A horizontal structural member that supports the ceiling and connects to walls.",
      },
      {
        term: "Change Order",
        definition:
          "A formal document modifying the original construction contract due to scope changes.",
      },
      {
        term: "Civil Works",
        definition:
          "Construction activities related to infrastructure, such as roads, bridges, and drainage systems.",
      },
      {
        term: "Clash Detection",
        definition:
          "The process of identifying and resolving conflicts in design elements using 3D modeling tools.",
      },
      {
        term: "Closeout Report",
        definition:
          "A final project document summarizing completion, inspections, and compliance with specifications.",
      },
      {
        term: "Code Compliance",
        definition:
          "Ensuring that a construction project meets local building regulations and safety codes.",
      },
      {
        term: "Concrete Pouring",
        definition:
          "The process of placing and setting liquid concrete into formwork.",
      },
      {
        term: "Construction Schedule",
        definition:
          "A detailed timeline outlining the duration and sequence of construction activities.",
      },
      {
        term: "Contingency Plan",
        definition:
          "A backup plan addressing potential risks and unforeseen circumstances in a project.",
      },
      {
        term: "Cost Analysis",
        definition:
          "The evaluation of construction expenses to determine cost efficiency and budget adherence.",
      },
      {
        term: "Crane Operation",
        definition:
          "The management and use of cranes for lifting and moving heavy construction materials.",
      },
      {
        term: "Crew Management",
        definition:
          "The supervision and coordination of workers on a construction site.",
      },
      {
        term: "Critical Path Method",
        definition:
          "A project management technique used to determine the longest sequence of dependent tasks in a project.",
      },
      {
        term: "Cross-Bracing",
        definition:
          "Structural reinforcements using diagonal braces to improve stability and resistance to lateral forces.",
      },
      {
        term: "Daily Log",
        definition:
          "A record of daily construction activities, including progress, delays, and site conditions.",
      },
      {
        term: "Damp Proofing",
        definition:
          "A treatment applied to building surfaces to prevent moisture penetration.",
      },
      {
        term: "Defect Liability Period",
        definition:
          "A post-construction phase where the contractor is responsible for fixing defects within a set timeframe.",
      },
      {
        term: "Design-Build",
        definition:
          "A project delivery method where one entity handles both design and construction services.",
      },
      {
        term: "Dispute Resolution",
        definition:
          "The process of resolving conflicts between parties in a construction project.",
      },
      {
        term: "Drafting",
        definition:
          "The creation of technical drawings and plans for a construction project.",
      },
      {
        term: "Drainage System",
        definition:
          "Infrastructure designed to manage water runoff and prevent flooding or erosion.",
      },
      {
        term: "Drywall Installation",
        definition:
          "The process of mounting plasterboard sheets to create walls and ceilings.",
      },
      {
        term: "Earthwork",
        definition:
          "The excavation, movement, and compaction of soil for construction purposes.",
      },
      {
        term: "Electrical Plan",
        definition:
          "A blueprint detailing the electrical wiring, outlets, and fixtures for a building.",
      },
      {
        term: "Elevation Drawing",
        definition:
          "A scaled drawing showing the external view of a building from a specific angle.",
      },
      {
        term: "Emergency Preparedness",
        definition:
          "Planning for potential hazards and emergencies on a construction site.",
      },
      {
        term: "Engineer's Estimate",
        definition:
          "A cost prediction prepared by an engineer to assess the expected project expenses.",
      },
      {
        term: "Equipment Log",
        definition:
          "A record tracking the use, maintenance, and condition of construction machinery.",
      },
      {
        term: "Excavation Plan",
        definition:
          "A detailed document outlining the depth, method, and safety measures for site excavation.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A flexible joint that allows building materials to expand and contract without damage.",
      },
      {
        term: "Exterior Cladding",
        definition:
          "The outermost layer of a building that provides insulation and weather resistance.",
      },
      {
        term: "Facade Work",
        definition:
          "Construction or renovation of the external face of a building.",
      },
      {
        term: "Field Report",
        definition:
          "A documented summary of on-site inspections, progress, and observations.",
      },
      {
        term: "Finish Work",
        definition:
          "The final stage of construction, including painting, flooring, and trim installation.",
      },
      {
        term: "Fireproofing",
        definition:
          "The application of materials to improve a building's resistance to fire.",
      },
      {
        term: "Flooring Installation",
        definition:
          "The process of laying tiles, wood, or other flooring materials.",
      },
      {
        term: "Formwork",
        definition:
          "Temporary or permanent molds used to shape poured concrete.",
      },
      {
        term: "Foundation Inspection",
        definition:
          "A structural assessment to ensure the foundation is stable and meets design requirements.",
      },
      {
        term: "Framing Plan",
        definition:
          "A drawing that shows the structural framework of a building, including beams and columns.",
      },
      {
        term: "Frost Line",
        definition:
          "The depth at which the ground freezes in winter, affecting foundation design.",
      },
      {
        term: "General Contractor",
        definition:
          "A professional responsible for overseeing and managing a construction project.",
      },
      {
        term: "Geotechnical Report",
        definition:
          "A document analyzing soil conditions and their impact on construction.",
      },
      {
        term: "Glazing Work",
        definition:
          "The installation of glass windows, doors, and panels in a building.",
      },
      {
        term: "Green Building",
        definition:
          "A construction approach that prioritizes sustainability, energy efficiency, and eco-friendly materials.",
      },
      {
        term: "Groundwater Management",
        definition:
          "Strategies used to control water levels and prevent damage to structures.",
      },
      {
        term: "Gutter Installation",
        definition:
          "The placement of gutters and downspouts to direct rainwater away from a building.",
      },
      {
        term: "HVAC Installation",
        definition:
          "The process of installing heating, ventilation, and air conditioning systems in a building.",
      },
      {
        term: "Hazard Analysis",
        definition:
          "The identification and evaluation of potential dangers on a construction site.",
      },
      {
        term: "Health & Safety Plan",
        definition:
          "A documented strategy outlining measures to protect workers and ensure compliance with safety regulations.",
      },
      {
        term: "Height Clearance",
        definition:
          "The minimum vertical space required for equipment, structures, or personnel movement.",
      },
      {
        term: "Hoisting Equipment",
        definition:
          "Machinery used for lifting and moving heavy materials, such as cranes and winches.",
      },
      {
        term: "Incident Report",
        definition:
          "A formal record detailing accidents or safety issues that occur on a construction site.",
      },
      {
        term: "Infrastructure Planning",
        definition:
          "The process of designing and organizing essential systems like roads, drainage, and utilities.",
      },
      {
        term: "Inspection Checklist",
        definition:
          "A structured list used to verify compliance with construction standards and regulations.",
      },
      {
        term: "Interior Finishes",
        definition:
          "The final decorative and functional materials applied inside a building, such as paint, flooring, and trim.",
      },
      {
        term: "Inventory Control",
        definition:
          "The management of materials and equipment to ensure availability and prevent shortages.",
      },
      {
        term: "Ironwork",
        definition:
          "Construction involving steel and iron elements, including structural beams, railings, and reinforcements.",
      },
      {
        term: "Job Hazard Analysis",
        definition:
          "A safety procedure that identifies risks associated with specific tasks and outlines preventive measures.",
      },
      {
        term: "Jobsite Coordination",
        definition:
          "The management of workers, materials, and schedules to ensure smooth construction operations.",
      },
      {
        term: "Joint Reinforcement",
        definition:
          "Steel or wire reinforcements placed in mortar joints to improve masonry strength.",
      },
      {
        term: "Joist Installation",
        definition:
          "The process of placing horizontal structural members to support floors or ceilings.",
      },
      {
        term: "Key Performance Indicators",
        definition:
          "Measurable metrics used to assess the efficiency and success of a construction project.",
      },
      {
        term: "Knockdown Construction",
        definition:
          "A method where pre-assembled components are shipped and assembled on-site, often used in modular building.",
      },
      {
        term: "Labor Productivity",
        definition:
          "A measure of work output relative to the time and resources used in construction.",
      },
      {
        term: "Land Surveying",
        definition:
          "The process of measuring and mapping land to determine boundaries and topography.",
      },
      {
        term: "Load-Bearing Structure",
        definition:
          "A structural element that supports weight and transfers it to the foundation.",
      },
      {
        term: "Logistics Planning",
        definition:
          "The coordination of materials, equipment, and personnel to optimize construction efficiency.",
      },
      {
        term: "Louver Installation",
        definition:
          "The placement of slatted openings to allow ventilation while blocking direct sunlight or rain.",
      },
      {
        term: "Manpower Allocation",
        definition:
          "The assignment of workers to specific tasks based on skills and project needs.",
      },
      {
        term: "Masonry Inspection",
        definition:
          "The assessment of brick, stone, or concrete structures to ensure compliance with construction standards.",
      },
      {
        term: "Material Handling",
        definition:
          "The movement, storage, and control of building materials on-site.",
      },
      {
        term: "MEP Systems",
        definition:
          "The combined systems responsible for utilities, including air conditioning, electrical wiring, and plumbing.",
      },
      {
        term: "Milestone Schedule",
        definition:
          "A project timeline highlighting major construction phases or critical events.",
      },
      {
        term: "Mobile Crane Operations",
        definition:
          "The use of portable cranes to lift and transport heavy materials.",
      },
      {
        term: "Modular Construction",
        definition:
          "A building method where pre-manufactured sections are assembled on-site.",
      },
      {
        term: "Noise Control",
        definition:
          "Measures taken to reduce construction noise to comply with regulations and minimize disturbances.",
      },
      {
        term: "Non-Destructive Testing",
        definition:
          "Techniques used to evaluate material integrity without causing damage, such as ultrasonic or radiographic inspections.",
      },
      {
        term: "Notice to Proceed",
        definition:
          "A formal document authorizing a contractor to begin work on a project.",
      },
      {
        term: "Occupational Safety",
        definition:
          "Practices and regulations designed to protect workers from hazards on a construction site.",
      },
      {
        term: "On-Site Coordination",
        definition:
          "The real-time management of people, materials, and equipment to keep a project on schedule.",
      },
      {
        term: "Overhead Protection",
        definition:
          "Safety structures, such as scaffolding covers or canopies, that protect workers and pedestrians from falling objects.",
      },
      {
        term: "Owner's Representative",
        definition:
          "A professional acting on behalf of a project owner to oversee construction activities and ensure compliance with objectives.",
      },
      {
        term: "Paving Work",
        definition:
          "The installation of roads, sidewalks, or flooring using materials like concrete, asphalt, or tiles.",
      },
      {
        term: "Permit Application",
        definition:
          "The process of obtaining legal authorization for construction work from relevant authorities.",
      },
      {
        term: "Plastering Supervision",
        definition:
          "The oversight of plaster application on walls and ceilings to ensure quality and adherence to specifications.",
      },
      {
        term: "Plumbing Layout",
        definition:
          "A schematic drawing detailing the arrangement of pipes, drains, and water supply lines.",
      },
      {
        term: "Prefabrication",
        definition:
          "The off-site manufacturing of building components for quick on-site assembly.",
      },
      {
        term: "Pre-Construction Meeting",
        definition:
          "A planning session where project stakeholders discuss objectives, schedules, and safety protocols.",
      },
      {
        term: "Procurement Schedule",
        definition:
          "A timeline outlining the purchase and delivery of construction materials and equipment.",
      },
      {
        term: "Project Closeout",
        definition:
          "The final phase of construction, involving inspections, documentation, and turnover to the client.",
      },
      {
        term: "Project Scope",
        definition:
          "A document defining the work, objectives, and limitations of a construction project.",
      },
      {
        term: "Punch List",
        definition:
          "A checklist of minor tasks or defects that must be corrected before project completion.",
      },
      {
        term: "Quality Assurance",
        definition:
          "The proactive process of ensuring that construction meets defined quality standards.",
      },
      {
        term: "Quality Control",
        definition:
          "The inspection and testing of construction materials and workmanship to identify defects.",
      },
      {
        term: "Quantity Surveying",
        definition:
          "The estimation and management of project costs, including materials, labor, and contracts.",
      },
      {
        term: "Quotation Request",
        definition:
          "A formal inquiry sent to suppliers or contractors for price estimates on materials or services.",
      },
      {
        term: "Reinforcement Work",
        definition:
          "The installation of steel bars, mesh, or fibers to strengthen concrete structures.",
      },
      {
        term: "Renovation Plan",
        definition:
          "A detailed strategy for upgrading or repairing an existing building.",
      },
      {
        term: "Resource Allocation",
        definition:
          "The distribution of labor, materials, and equipment to optimize project efficiency.",
      },
      {
        term: "Retaining Wall Inspection",
        definition:
          "The assessment of walls designed to hold back soil or prevent erosion.",
      },
      {
        term: "Risk Assessment",
        definition:
          "The evaluation of potential hazards and their impact on a construction project.",
      },
      {
        term: "Roofing Work",
        definition:
          "The installation or repair of roofs using materials such as shingles, metal, or tiles.",
      },
      {
        term: "Safety Compliance",
        definition:
          "Adherence to laws and regulations designed to protect workers and the public.",
      },
      {
        term: "Scaffolding Setup",
        definition:
          "The assembly of temporary platforms for workers and materials at elevated heights.",
      },
      {
        term: "Schedule of Values",
        definition:
          "A document outlining project costs, broken down by specific work categories.",
      },
      {
        term: "Site Inspection",
        definition:
          "The evaluation of construction progress, safety, and compliance with design specifications.",
      },
      {
        term: "Site Logistics Plan",
        definition:
          "A layout detailing the movement of materials, equipment, and workers on-site.",
      },
      {
        term: "Slab Work",
        definition:
          "The construction of concrete floors, ceilings, or foundations.",
      },
      {
        term: "Soil Compaction",
        definition:
          "The process of compressing soil to improve stability and load-bearing capacity.",
      },
      {
        term: "Specifications Document",
        definition:
          "A detailed list of materials, methods, and standards required for a project.",
      },
      {
        term: "Structural Integrity",
        definition:
          "The ability of a structure to withstand loads and environmental conditions without failure.",
      },
      {
        term: "Subcontractor Coordination",
        definition:
          "The management of specialized tradespeople working under the main contractor.",
      },
      {
        term: "Sustainable Building",
        definition:
          "Construction practices that minimize environmental impact and maximize efficiency.",
      },
      {
        term: "Task Scheduling",
        definition:
          "The process of planning and assigning construction tasks within a timeline.",
      },
      {
        term: "Tendering Process",
        definition:
          "The competitive bidding procedure used to select contractors or suppliers.",
      },
      {
        term: "Timber Framework",
        definition: "A structural system using wooden beams and columns.",
      },
      {
        term: "Time and Material Contract",
        definition:
          "A contract where payment is based on actual labor and material costs rather than a fixed price.",
      },
      {
        term: "Toolbox Talk",
        definition:
          "A short safety meeting held before work begins on a construction site.",
      },
      {
        term: "Traffic Management Plan",
        definition:
          "A strategy for controlling vehicle and pedestrian movement near a construction zone.",
      },
      {
        term: "Trenching Work",
        definition:
          "The excavation of narrow, deep ditches for utilities, foundations, or drainage systems.",
      },
      {
        term: "Utility Installation",
        definition:
          "The placement of essential services like water, gas, and electricity lines.",
      },
      {
        term: "Value Engineering",
        definition:
          "A cost-saving approach that enhances function while reducing expenses.",
      },
      {
        term: "Ventilation Planning",
        definition:
          "The design of airflow systems to ensure indoor air quality and comfort.",
      },
      {
        term: "Waterproofing Inspection",
        definition:
          "The evaluation of building surfaces to prevent water penetration.",
      },
      {
        term: "Worksite Safety",
        definition:
          "The policies and procedures designed to prevent accidents and injuries on a construction site.",
      },
      {
        term: "Zoning Permit",
        definition:
          "A legal approval indicating that a construction project complies with local land-use regulations.",
      },
    ],
  },

  "gas-appliance-maintenance": {
    promotionalText:
      "Safe, efficient, and worry-free, LaborHack experts keep your gas appliances running smoothly.",
    terms: [
      {
        term: "Adjustable Orifice",
        definition: "A nozzle that regulates gas flow to the burner.",
      },
      {
        term: "Air Gap",
        definition:
          "The vertical space between a water outlet (like a faucet) and the flood level of a fixture to prevent backflow contamination.",
      },
      {
        term: "Air Mixer",
        definition: "A device that blends gas with air for optimal combustion.",
      },
      {
        term: "Air Shutter",
        definition:
          "A component that regulates airflow to the burner for efficient flame control.",
      },
      {
        term: "Anode Rod",
        definition:
          "A sacrificial metal rod in gas water heaters that prevents tank corrosion.",
      },
      {
        term: "Anti-Tilt Device",
        definition:
          "A safety mechanism that prevents gas appliances from tipping over.",
      },
      {
        term: "Appliance Regulator",
        definition:
          "A valve that controls gas pressure for safe appliance operation.",
      },
      {
        term: "Atmospheric Burner",
        definition: "A burner that relies on natural airflow for combustion.",
      },
      {
        term: "Automatic Ignition",
        definition:
          "A system that ignites gas burners automatically without manual lighting.",
      },
      {
        term: "Backflow Preventer",
        definition:
          "A device that prevents gas or water from flowing back into the supply line.",
      },
      {
        term: "Baffle Plate",
        definition: "A heat deflector that improves combustion efficiency.",
      },
      {
        term: "Ball Valve",
        definition: "A gas shutoff valve that allows or stops gas flow.",
      },
      {
        term: "Barbecue Gas Connection",
        definition: "A gas outlet designed for outdoor grills.",
      },
      {
        term: "Baseplate",
        definition: "A mounting surface for securing gas appliances.",
      },
      {
        term: "Bimetallic Sensor",
        definition:
          "A sensor that reacts to temperature changes to control gas flow.",
      },
      {
        term: "Bleed Valve",
        definition: "A valve used to release trapped gas or air from a system.",
      },
      {
        term: "Blower Fan",
        definition: "A fan that distributes heat from gas appliances.",
      },
      {
        term: "Burner Assembly",
        definition:
          "The complete setup of components that generate flames in a gas appliance.",
      },
      {
        term: "Burner Cap",
        definition: "A cover that distributes gas evenly across the burner.",
      },
      {
        term: "Burner Control Knob",
        definition: "A knob that adjusts flame intensity.",
      },
      {
        term: "Burner Ports",
        definition: "Small openings on the burner where gas exits and ignites.",
      },
      {
        term: "Butane Gas",
        definition: "A liquefied petroleum gas used for cooking and heating.",
      },
      {
        term: "Carbon Monoxide Detector",
        definition: "A safety device that detects dangerous CO gas levels.",
      },
      {
        term: "Cast Iron Burner",
        definition:
          "A durable burner made of cast iron for even heat distribution.",
      },
      {
        term: "Check Valve",
        definition: "A valve that allows gas to flow in only one direction.",
      },
      {
        term: "Combustion Chamber",
        definition:
          "The enclosed space where fuel and air mix to produce a flame.",
      },
      {
        term: "Combustion Efficiency",
        definition:
          "A measure of how effectively gas is burned to generate heat.",
      },
      {
        term: "Condensation Drain",
        definition: "A pipe that removes water formed during gas combustion.",
      },
      {
        term: "Control Board",
        definition:
          "The electronic circuit that manages gas appliance functions.",
      },
      {
        term: "Control Valve",
        definition: "A valve that regulates gas flow to the burner.",
      },
      {
        term: "Convection Heating",
        definition: "The process of distributing heat through air movement.",
      },
      {
        term: "Copper Gas Line",
        definition: "A durable piping material for gas supply.",
      },
      {
        term: "Corrosion-Resistant Piping",
        definition:
          "Special piping designed to prevent rust and deterioration.",
      },
      {
        term: "Coupling Nut",
        definition: "A connector used to join gas pipes securely.",
      },
      {
        term: "Crimp Connection",
        definition: "A method of sealing gas pipe joints using pressure.",
      },
      {
        term: "Damper",
        definition: "A movable plate that controls airflow in a gas appliance.",
      },
      {
        term: "Defective Igniter",
        definition: "A faulty ignition system that fails to spark a gas flame.",
      },
      {
        term: "Direct Vent System",
        definition:
          "A sealed system that pulls in outside air for combustion and expels exhaust.",
      },
      {
        term: "Distribution Pipe",
        definition: "A gas line that distributes fuel to multiple appliances.",
      },
      {
        term: "Drip Leg",
        definition:
          "A low point in a gas line that collects moisture and debris.",
      },
      {
        term: "Dual-Fuel Range",
        definition:
          "A cooking appliance that uses both gas and electric heating elements.",
      },
      {
        term: "Ducted Ventilation",
        definition:
          "A vent system that removes combustion byproducts from gas appliances.",
      },
      {
        term: "Dust Cap",
        definition:
          "A protective cover that prevents dirt from entering a gas connection.",
      },
      {
        term: "Earth Bonding",
        definition:
          "An electrical grounding method to prevent gas leaks from causing sparks.",
      },
      {
        term: "Electronic Ignition",
        definition:
          "A gas ignition system that uses electricity instead of a pilot light.",
      },
      {
        term: "Energy Efficiency Rating",
        definition: "A measure of how efficiently a gas appliance uses fuel.",
      },
      {
        term: "Exhaust Flue",
        definition: "A pipe that directs combustion gases outside.",
      },
      {
        term: "Exhaust Hood",
        definition:
          "A ventilation hood that removes heat and fumes from gas appliances.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A flexible connector that allows for movement in gas piping.",
      },
      {
        term: "FFD (Flame Failure Device)",
        definition:
          "A safety feature that shuts off gas if the flame goes out.",
      },
      {
        term: "Fitting Sealant",
        definition: "A special compound used to seal gas pipe connections.",
      },
      {
        term: "Flame Arrestor",
        definition:
          "A device that prevents flames from spreading back into the gas supply.",
      },
      {
        term: "Flame Sensor",
        definition: "A sensor that detects whether a gas flame is burning.",
      },
      {
        term: "Flame Spread",
        definition: "The distribution of flames across a burner.",
      },
      {
        term: "Flare Connection",
        definition: "A gas pipe joint that uses flared ends for a secure fit.",
      },
      {
        term: "Flexible Gas Hose",
        definition:
          "A bendable hose that connects gas appliances to the supply line.",
      },
      {
        term: "Flow Control Valve",
        definition: "A valve that regulates gas pressure and flow.",
      },
      {
        term: "Flue Baffle",
        definition: "A plate inside a flue pipe that improves heat transfer.",
      },
      {
        term: "Flue Damper",
        definition:
          "A device that controls exhaust gas flow in a chimney or vent.",
      },
      {
        term: "Flue Pipe",
        definition:
          "A duct that removes combustion gases from a gas appliance.",
      },
      {
        term: "Fuel Supply Line",
        definition: "The main gas pipe that delivers fuel to appliances.",
      },
      {
        term: "Fume Hood",
        definition: "A ventilation system that removes hazardous gas fumes.",
      },
      {
        term: "Gas Appliance Pressure Test",
        definition: "A safety test to check gas pressure in an appliance.",
      },
      {
        term: "Gas Burner",
        definition:
          "The part of an appliance where gas mixes with air and ignites.",
      },
      {
        term: "Gas Cock Valve",
        definition: "A manual shutoff valve for gas lines.",
      },
      {
        term: "Gas Cylinder",
        definition: "A tank that stores compressed gas for use in appliances.",
      },
      {
        term: "Gas Flow Rate",
        definition:
          "The amount of gas delivered to an appliance per unit of time.",
      },
      {
        term: "Gas Hose Clamp",
        definition: "A metal or plastic fastener that secures gas hoses.",
      },
      {
        term: "Gas Leak Detector",
        definition: "A device that senses and alerts users to gas leaks.",
      },
      {
        term: "Gas Manifold",
        definition: "A pipe system that distributes gas to multiple burners.",
      },
      {
        term: "Gas Meter",
        definition: "A device that measures gas consumption.",
      },
      {
        term: "Gas Pipe Insulation",
        definition:
          "Material used to protect gas pipes from temperature changes.",
      },
      {
        term: "Gas Pilot Light",
        definition:
          "A small flame that ignites the main burner in older appliances.",
      },
      {
        term: "Gas Pressure Regulator",
        definition:
          "A device that controls and maintains consistent gas pressure.",
      },
      {
        term: "Gas Safety Shutoff",
        definition: "A safety mechanism that stops gas flow in emergencies.",
      },
      {
        term: "Gas Service Line",
        definition: "The main pipeline supplying gas to a building.",
      },
      {
        term: "Gas Shutoff Valve",
        definition: "A valve used to stop gas flow in case of a leak.",
      },
      {
        term: "Gas Stove Knob",
        definition: "The control knob that adjusts the flame on a gas stove.",
      },
      {
        term: "Gas Supply Line",
        definition: "The pipe that delivers gas to an appliance.",
      },
      {
        term: "Gas Water Heater",
        definition: "A heating appliance that uses gas to heat water.",
      },
      {
        term: "Gasket Seal",
        definition:
          "A rubber or metal ring that ensures gas-tight seals in connections.",
      },
      {
        term: "Griddle Plate",
        definition: "A flat metal cooking surface heated by a gas burner.",
      },
      {
        term: "Grill Burner",
        definition: "A burner designed for grilling food.",
      },
      {
        term: "Grounding Electrode",
        definition:
          "A metal rod that provides electrical grounding to gas appliances.",
      },
      {
        term: "Heat Exchanger",
        definition:
          "A device that transfers heat from gas combustion to air or water.",
      },
      {
        term: "Heat Output",
        definition:
          "The amount of heat a gas appliance generates, measured in BTUs.",
      },
      {
        term: "High-Pressure Gas Hose",
        definition: "A durable hose designed for high gas pressure systems.",
      },
      {
        term: "Hose Clamp",
        definition: "A fastener that secures gas hoses in place.",
      },
      {
        term: "Hose Connector",
        definition: "A fitting that joins gas hoses to appliances or pipes.",
      },
      {
        term: "Ignition Coil",
        definition: "A component that generates the spark to ignite gas.",
      },
      {
        term: "Ignition Control Module",
        definition: "The electronic system that manages gas ignition.",
      },
      {
        term: "Ignition Electrode",
        definition: "A small metal rod that creates a spark for gas ignition.",
      },
      {
        term: "Ignition Safety Lock",
        definition: "A feature that prevents accidental ignition.",
      },
      {
        term: "Infrared Burner",
        definition: "A burner that uses infrared heat for efficient cooking.",
      },
      {
        term: "Inlet Pressure",
        definition: "The gas pressure at the entry point of an appliance.",
      },
      {
        term: "Insulated Gas Pipe",
        definition: "A gas pipe covered with insulation for protection.",
      },
      {
        term: "Isolation Valve",
        definition:
          "A valve that allows a section of the gas system to be shut off.",
      },
      {
        term: "Joint Compound",
        definition: "A sealant used on gas pipe threads to prevent leaks.",
      },
      {
        term: "Junction Box",
        definition: "A protective enclosure for electrical or gas connections.",
      },
      {
        term: "Knockout Plug",
        definition:
          "A removable piece in gas appliances or pipes that allows for expansion or additional connections.",
      },
      {
        term: "Knurled Nut",
        definition:
          "A textured nut designed for hand tightening without tools.",
      },
      {
        term: "Leak Detection Fluid",
        definition:
          "A liquid used to detect gas leaks by forming bubbles at leak points.",
      },
      {
        term: "Liquid Propane (LP)",
        definition:
          "A compressed gas fuel commonly used for cooking and heating.",
      },
      {
        term: "Low-Pressure Regulator",
        definition:
          "A device that reduces gas pressure for safe appliance operation.",
      },
      {
        term: "LPG (Liquefied Petroleum Gas)",
        definition: "A mixture of propane and butane used as a fuel source.",
      },
      {
        term: "Main Burner",
        definition:
          "The primary burner in a gas appliance that produces the main flame.",
      },
      {
        term: "Manifold Pressure",
        definition:
          "The gas pressure inside a burner manifold, ensuring proper combustion.",
      },
      {
        term: "Mechanical Gas Timer",
        definition:
          "A timer that controls the duration of gas flow for safety.",
      },
      {
        term: "Membrane Seal",
        definition: "A flexible barrier that prevents gas leaks.",
      },
      {
        term: "Meter Regulator",
        definition:
          "A regulator at the gas meter that controls pressure before it enters the home or building.",
      },
      {
        term: "Natural Draft Vent",
        definition:
          "A venting system that uses natural airflow to expel combustion gases.",
      },
      {
        term: "Natural Gas (NG)",
        definition:
          "A fossil fuel gas commonly used for residential and commercial heating.",
      },
      {
        term: "Non-Return Valve",
        definition:
          "A valve that allows gas to flow in one direction, preventing backflow.",
      },
      {
        term: "Nozzle Injector",
        definition:
          "A component that directs and controls gas flow to a burner.",
      },
      {
        term: "O-Ring Seal",
        definition:
          "A circular rubber or silicone gasket used to prevent gas leaks.",
      },
      {
        term: "Overheat Sensor",
        definition:
          "A safety device that detects excessive temperature and shuts down gas flow.",
      },
      {
        term: "Overpressure Protection",
        definition:
          "A mechanism that prevents excessive gas pressure from damaging appliances.",
      },
      {
        term: "Pilot Assembly",
        definition:
          "A group of components that control the pilot flame in a gas appliance.",
      },
      {
        term: "Pilot Flame",
        definition: "A small, continuous flame used to ignite the main burner.",
      },
      {
        term: "Pilot Gas Tube",
        definition: "The tube that delivers gas to the pilot flame.",
      },
      {
        term: "Pilot Light",
        definition:
          "A continuously burning flame that ignites the main burner when needed.",
      },
      {
        term: "Pipe Dope",
        definition: "A sealant used on gas pipe threads to prevent leaks.",
      },
      {
        term: "Pressure Gauge",
        definition: "A device that measures gas pressure in a system.",
      },
      {
        term: "Pressure Relief Valve",
        definition:
          "A safety valve that releases excess pressure to prevent explosions.",
      },
      {
        term: "Propane Conversion Kit",
        definition:
          "A set of parts that allow a gas appliance to switch from natural gas to propane.",
      },
      {
        term: "Propane Gas Cylinder",
        definition: "A portable tank storing liquefied propane gas.",
      },
      {
        term: "Proximity Sensor",
        definition:
          "A sensor that detects nearby objects or motion, sometimes used in gas appliances for safety.",
      },
      {
        term: "Quick-Disconnect Fitting",
        definition:
          "A connector that allows fast and easy connection or disconnection of gas hoses.",
      },
      {
        term: "Quarter-Turn Valve",
        definition:
          "A valve that shuts off gas flow with a 90-degree turn of the handle.",
      },
      {
        term: "Radiant Burner",
        definition:
          "A burner that uses infrared heat for efficient energy transfer.",
      },
      {
        term: "Regulator Vent",
        definition:
          "An opening in a regulator that helps maintain pressure balance.",
      },
      {
        term: "Relief Valve",
        definition:
          "A safety valve that releases pressure if it exceeds safe levels.",
      },
      {
        term: "Return Air Duct",
        definition: "A duct that recirculates air in a gas heating system.",
      },
      {
        term: "Right-Angle Gas Valve",
        definition:
          "A gas shutoff valve designed to operate at a 90-degree angle.",
      },
      {
        term: "Safety Relief Valve",
        definition:
          "A valve that prevents gas system overpressure by releasing excess gas.",
      },
      {
        term: "Safety Shutoff Valve",
        definition:
          "A valve that automatically stops gas flow in emergency situations.",
      },
      {
        term: "Sealed Burner",
        definition:
          "A burner enclosed to prevent spills from clogging the gas ports.",
      },
      {
        term: "Sediment Trap",
        definition:
          "A small section of pipe that collects dirt or moisture from a gas line.",
      },
      {
        term: "Shutoff Valve",
        definition: "A valve that stops gas flow when needed.",
      },
      {
        term: "Sidewall Venting",
        definition:
          "A method of venting gas appliances through a side wall instead of a roof.",
      },
      {
        term: "Silicone Gas Seal",
        definition: "A flexible sealant used to prevent gas leaks.",
      },
      {
        term: "Smart Gas Detector",
        definition:
          "An electronic device that detects gas leaks and alerts users.",
      },
      {
        term: "Solenoid Valve",
        definition:
          "An electrically controlled valve that opens or closes gas flow.",
      },
      {
        term: "Stainless Steel Gas Hose",
        definition:
          "A flexible, durable gas hose made of stainless steel for safety.",
      },
      {
        term: "Supply Line Pressure",
        definition:
          "The pressure of gas coming from the main supply to the appliance.",
      },
      {
        term: "Surface Burner",
        definition: "A gas burner on the surface of a stove or cooktop.",
      },
      {
        term: "Tankless Gas Water Heater",
        definition:
          "A water heater that heats water on demand without a storage tank.",
      },
      {
        term: "Temperature Control Knob",
        definition:
          "A knob that adjusts the temperature setting on a gas appliance.",
      },
      {
        term: "Thermocouple",
        definition:
          "A safety device that shuts off gas flow if the pilot light goes out.",
      },
      {
        term: "Thermostat Sensor",
        definition:
          "A sensor that monitors temperature and adjusts gas flow accordingly.",
      },
      {
        term: "Threaded Gas Pipe",
        definition:
          "A gas pipe with screw-like threads for secure connections.",
      },
      {
        term: "Timer Valve",
        definition:
          "A valve that automatically shuts off gas flow after a set time.",
      },
      {
        term: "T-Joint Connector",
        definition: "A fitting that connects three gas pipes in a T-shape.",
      },
      {
        term: "Tubing Cutter",
        definition: "A tool used to cut gas pipes cleanly and precisely.",
      },
      {
        term: "Two-Stage Regulator",
        definition:
          "A regulator that reduces gas pressure in two steps for better control.",
      },
      {
        term: "UL-Certified Gas Appliance",
        definition:
          "A gas appliance that meets safety standards set by Underwriters Laboratories (UL).",
      },
      {
        term: "Under-Counter Gas Pipe",
        definition:
          "A concealed gas pipe installed under countertops for kitchen appliances.",
      },
      {
        term: "Ventilation Hood",
        definition: "A hood that removes fumes and heat from a gas appliance.",
      },
      {
        term: "Venturi Tube",
        definition: "A tube that mixes gas and air efficiently for combustion.",
      },
      {
        term: "Wall-Mounted Gas Heater",
        definition: "A gas heater attached to a wall for space-saving heating.",
      },
      {
        term: "Weatherproof Gas Cover",
        definition:
          "A protective cover that shields outdoor gas connections from the elements.",
      },
      {
        term: "Zone Control Valve",
        definition:
          "A valve that directs gas flow to specific zones in a heating system.",
      },
    ],
  },

  "glass-partitioning": {
    promotionalText:
      "LaborHack's glass partitioning pros bring elegance and precision to your space.",
    terms: [
      {
        term: "Acoustic Glass",
        definition: "Glass designed to reduce sound transmission.",
      },
      {
        term: "Acrylic Panel",
        definition: "A lightweight, shatter-resistant alternative to glass.",
      },
      {
        term: "Adhesive Film",
        definition:
          "A thin layer applied to glass for privacy, safety, or decoration.",
      },
      {
        term: "Annealed Glass",
        definition:
          "Standard glass that has been slowly cooled to relieve internal stresses.",
      },
      {
        term: "Aluminum Framing",
        definition: "A durable, lightweight frame used in glass installations.",
      },
      {
        term: "Anti-Glare Glass",
        definition: "Glass treated to reduce reflections and glare.",
      },
      {
        term: "Atrium Glass",
        definition:
          "Large glass panels used in building atriums to allow natural light.",
      },
      {
        term: "Auto-Closing Partition",
        definition:
          "A movable glass partition that closes automatically for convenience.",
      },
      {
        term: "Back-Painted Glass",
        definition:
          "Glass with a painted back surface for decorative or functional purposes.",
      },
      {
        term: "Beveled Glass",
        definition: "Glass with angled edges for an elegant look.",
      },
      {
        term: "Blast-Resistant Glass",
        definition: "Glass designed to withstand explosions and impact.",
      },
      {
        term: "Bulletproof Glass",
        definition: "Multi-layered glass that resists bullets.",
      },
      {
        term: "Butt Joint Glazing",
        definition:
          "A seamless glass installation where panels meet without visible framing.",
      },
      {
        term: "Casement Window",
        definition: "A window that swings open on hinges.",
      },
      {
        term: "Cladding Panel",
        definition:
          "A protective or decorative covering applied to building exteriors.",
      },
      {
        term: "Clear Glass",
        definition: "Standard transparent glass with no tint or coating.",
      },
      {
        term: "Curtain Wall",
        definition:
          "A non-load-bearing glass façade attached to a building structure.",
      },
      {
        term: "Cutting Table",
        definition: "A specialized table used for cutting glass accurately.",
      },
      {
        term: "Double Glazed Unit",
        definition:
          "Two panes of glass separated by an insulating air or gas layer.",
      },
      {
        term: "Decorative Glass",
        definition:
          "Glass designed with patterns, colors, or textures for aesthetic appeal.",
      },
      {
        term: "Divider Strip",
        definition: "A thin bar used to separate glass panels.",
      },
      {
        term: "Double-Glazed Partition",
        definition:
          "An interior glass wall with two layers for insulation and soundproofing.",
      },
      {
        term: "Draft Seal",
        definition:
          "A seal placed around windows or doors to prevent air leakage.",
      },
      {
        term: "Edge Polishing",
        definition: "The process of smoothing and finishing glass edges.",
      },
      {
        term: "Etched Glass",
        definition:
          "Glass with a frosted or decorative pattern created by acid or sandblasting.",
      },
      {
        term: "Exterior Glazing",
        definition: "Glass installed on a building's exterior.",
      },
      {
        term: "Facade Glass",
        definition:
          "Glass used for building exteriors to enhance aesthetics and efficiency.",
      },
      {
        term: "Fire-Rated Glass",
        definition: "Glass designed to resist fire for a specific period.",
      },
      {
        term: "Fixed Partition",
        definition: "A non-movable glass divider.",
      },
      {
        term: "Float Glass",
        definition:
          "Basic glass made by floating molten glass on molten tin for a smooth finish.",
      },
      {
        term: "Folding Glass Partition",
        definition: "A glass partition that folds to open up space.",
      },
      {
        term: "Frameless Glass Door",
        definition: "A door made entirely of glass without visible frames.",
      },
      {
        term: "Frosted Glass",
        definition:
          "Glass treated to have a translucent, frosted appearance for privacy.",
      },
      {
        term: "Full-Height Partition",
        definition: "A floor-to-ceiling glass partition.",
      },
      {
        term: "Glass Balustrade",
        definition: "A glass railing system used for safety and aesthetics.",
      },
      {
        term: "Glass Block",
        definition: "Thick, hollow glass units used for decorative walls.",
      },
      {
        term: "Glass Door Closer",
        definition: "A mechanism that automatically closes a glass door.",
      },
      {
        term: "Glass Partition",
        definition:
          "A glass wall used to divide spaces while maintaining openness.",
      },
      {
        term: "Glass Reinforcement",
        definition:
          "Additional support added to glass structures for strength.",
      },
      {
        term: "Glass Railing",
        definition: "A safety barrier made from glass panels.",
      },
      {
        term: "Glazing Bead",
        definition: "A strip that holds glass in place within a frame.",
      },
      {
        term: "Glazing Gasket",
        definition:
          "A rubber or plastic seal used in glazing to prevent leaks.",
      },
      {
        term: "Glazing Sealant",
        definition: "A material used to seal gaps between glass and frames.",
      },
      {
        term: "Green Glass",
        definition: "Glass with a slight green tint due to iron content.",
      },
      {
        term: "Grid Partition",
        definition: "A partition with a grid-like frame design.",
      },
      {
        term: "Heat-Resistant Glass",
        definition: "Glass designed to withstand high temperatures.",
      },
      {
        term: "Heat-Strengthened Glass",
        definition:
          "Glass that has been partially tempered for added strength.",
      },
      {
        term: "Hinged Glass Door",
        definition: "A glass door that swings open on hinges.",
      },
      {
        term: "Impact-Resistant Glass",
        definition:
          "Glass designed to withstand strong impacts without shattering.",
      },
      {
        term: "Insulated Glass Unit",
        definition: "A multi-pane glass unit for improved thermal efficiency.",
      },
      {
        term: "Interior Glass Wall",
        definition: "A glass partition used indoors.",
      },
      {
        term: "Integrated Blinds",
        definition:
          "Blinds built inside a glass panel for privacy and sun control.",
      },
      {
        term: "Jamb Trim",
        definition: "The finishing trim around a door or window frame.",
      },
      {
        term: "Joint Sealant",
        definition: "A material used to seal joints in glass installations.",
      },
      {
        term: "Kiln-Formed Glass",
        definition: "Glass shaped using heat in a kiln.",
      },
      {
        term: "Laminated Glass",
        definition: "Glass with an interlayer for safety and soundproofing.",
      },
      {
        term: "Light Diffusing Glass",
        definition: "Glass designed to evenly distribute light.",
      },
      {
        term: "Low-E Glass",
        definition: "Glass with a coating that minimizes heat transfer.",
      },
      {
        term: "Louvre Glass",
        definition: "Angled glass slats for ventilation and shading.",
      },
      {
        term: "Manifestation Film",
        definition: "A safety marking applied to glass to make it visible.",
      },
      {
        term: "Mirror Glass",
        definition: "Glass with a reflective surface.",
      },
      {
        term: "Mobile Partition",
        definition: "A movable glass divider.",
      },
      {
        term: "Modular Glass Partition",
        definition: "A prefabricated, flexible glass partition system.",
      },
      {
        term: "Mullion",
        definition: "A vertical or horizontal bar dividing glass panels.",
      },
      {
        term: "Noise Reduction Glass",
        definition: "Glass designed to minimize sound transmission.",
      },
      {
        term: "Non-Reflective Glass",
        definition: "Glass treated to reduce reflections.",
      },
      {
        term: "Obscure Glass",
        definition: "Glass with reduced visibility for privacy.",
      },
      {
        term: "Office Partition",
        definition: "A glass wall used to divide office spaces.",
      },
      {
        term: "Operable Wall System",
        definition:
          "A movable wall system that can open or close sections of a space.",
      },
      {
        term: "Optical Glass",
        definition:
          "High-quality glass used in lenses and precision instruments.",
      },
      {
        term: "Overhead Glazing",
        definition: "Glass installed above eye level, such as skylights.",
      },
      {
        term: "Partition Wall",
        definition: "A non-load-bearing wall used to divide spaces.",
      },
      {
        term: "Patterned Glass",
        definition: "Glass with a textured surface for decoration or privacy.",
      },
      {
        term: "Polycarbonate Panel",
        definition: "A strong, lightweight alternative to glass.",
      },
      {
        term: "Powder-Coated Frame",
        definition: "A metal frame coated with a protective powder finish.",
      },
      {
        term: "Privacy Glass",
        definition: "Glass that can switch between transparent and opaque.",
      },
      {
        term: "Protective Glazing",
        definition: "Glass designed for safety and impact resistance.",
      },
      {
        term: "Quartz Glass",
        definition:
          "Glass made from pure silica, resistant to high temperatures.",
      },
      {
        term: "Quick-Release Partition",
        definition: "A partition designed for easy removal or reconfiguration.",
      },
      {
        term: "Reinforced Glass",
        definition: "Glass strengthened with additional materials.",
      },
      {
        term: "Reflective Glass",
        definition: "Glass with a metallic coating to reduce heat and glare.",
      },
      {
        term: "Retractable Glass Wall",
        definition: "A movable glass wall that can be opened fully.",
      },
      {
        term: "Rubber Gasket",
        definition: "A flexible seal used in glass installations.",
      },
      {
        term: "Safety Glass",
        definition: "Glass designed to reduce injury risk when broken.",
      },
      {
        term: "Sandblasted Glass",
        definition: "Glass with a frosted texture created by sandblasting.",
      },
      {
        term: "Sealed Glass Unit",
        definition: "A preassembled multi-pane glass unit.",
      },
      {
        term: "Security Glazing",
        definition: "Glass designed for protection against forced entry.",
      },
      {
        term: "Tempered Glass",
        definition: "Heat-treated glass that shatters into small, safe pieces.",
      },
      {
        term: "UV-Protective Glass",
        definition: "Glass that blocks ultraviolet radiation.",
      },
      {
        term: "Wire Glass",
        definition: "Glass reinforced with wire for safety.",
      },
      {
        term: "Zoned Partitioning",
        definition:
          "A partitioning system dividing spaces into functional zones.",
      },
    ],
  },

  masonry: {
    promotionalText:
      "Strong walls, timeless finishes, LaborHack masons build with skill and durability.",
    terms: [
      {
        term: "Aggregate",
        definition:
          "Crushed stone, gravel, or sand used in concrete and mortar mixtures.",
      },
      {
        term: "Anchor Bolt",
        definition:
          "A bolt used to secure masonry structures to foundations or other surfaces.",
      },
      {
        term: "Ashlar",
        definition:
          "Precisely cut and fitted stone blocks used in high-quality masonry construction.",
      },
      {
        term: "Bed Joint",
        definition:
          "The horizontal mortar joint between courses of masonry units.",
      },
      {
        term: "Block",
        definition:
          "A masonry unit, typically made of concrete, used in construction.",
      },
      {
        term: "Bond",
        definition:
          "The pattern in which masonry units are laid to provide structural strength.",
      },
      {
        term: "Brick",
        definition: "A rectangular masonry unit made from clay or concrete.",
      },
      {
        term: "Buttress",
        definition:
          "A structural support built against a wall to provide additional strength.",
      },
      {
        term: "Cavity Wall",
        definition:
          "A wall with two separate layers of masonry with an air space between them.",
      },
      {
        term: "Cement",
        definition:
          "A binding agent used in mortar and concrete to hold masonry units together.",
      },
      {
        term: "Chinking",
        definition:
          "The process of filling gaps between stones or logs with mortar or other materials.",
      },
      {
        term: "Concrete Block",
        definition: "A hollow or solid masonry unit made from concrete.",
      },
      {
        term: "Course",
        definition: "A horizontal row of masonry units.",
      },
      {
        term: "Damp Proof Course",
        definition:
          "A waterproof layer in masonry walls to prevent moisture penetration.",
      },
      {
        term: "Efflorescence",
        definition:
          "White, chalky deposits that appear on masonry surfaces due to salt migration.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A gap in masonry construction that allows for thermal expansion and contraction.",
      },
      {
        term: "Face Brick",
        definition:
          "High-quality brick used for exterior walls where appearance is important.",
      },
      {
        term: "Fire Brick",
        definition:
          "Heat-resistant brick used in fireplaces, furnaces, and chimneys.",
      },
      {
        term: "Flashing",
        definition:
          "Waterproof material used to prevent water penetration at joints and intersections.",
      },
      {
        term: "Grout",
        definition:
          "A fluid mixture of cement, sand, and water used to fill gaps between masonry units or tiles.",
      },
      {
        term: "Header",
        definition:
          "A brick or stone laid perpendicular to the face of a wall.",
      },
      {
        term: "Joint",
        definition: "The space between masonry units filled with mortar.",
      },
      {
        term: "Lime Mortar",
        definition: "Traditional mortar made with lime, sand, and water.",
      },
      {
        term: "Lintel",
        definition:
          "A horizontal structural element spanning an opening in a masonry wall.",
      },
      {
        term: "Masonry",
        definition:
          "Construction using individual units such as brick, stone, or concrete blocks.",
      },
      {
        term: "Mortar",
        definition:
          "A mixture of cement, sand, and water used to bond masonry units.",
      },
      {
        term: "Natural Stone",
        definition:
          "Stone quarried from the earth and used in masonry construction.",
      },
      {
        term: "Parapet",
        definition: "A low wall along the edge of a roof or balcony.",
      },
      {
        term: "Pier",
        definition: "A vertical masonry support structure.",
      },
      {
        term: "Pointing",
        definition: "The process of finishing mortar joints in masonry work.",
      },
      {
        term: "Quoin",
        definition:
          "Decorative corner stones used to emphasize building corners.",
      },
      {
        term: "Reinforcement",
        definition: "Steel bars or mesh used to strengthen masonry structures.",
      },
      {
        term: "Retaining Wall",
        definition:
          "A masonry wall designed to hold back soil or other materials.",
      },
      {
        term: "Rubble Stone",
        definition: "Irregularly shaped stones used in masonry construction.",
      },
      {
        term: "Sandstone",
        definition: "A sedimentary rock commonly used in masonry construction.",
      },
      {
        term: "Stretcher",
        definition: "A brick or stone laid parallel to the face of a wall.",
      },
      {
        term: "Tuckpointing",
        definition:
          "The process of removing and replacing deteriorated mortar joints.",
      },
      {
        term: "Veneer",
        definition:
          "A thin layer of masonry material applied over a structural wall.",
      },
      {
        term: "Weep Hole",
        definition:
          "Small openings in masonry walls to allow moisture drainage.",
      },
    ],
  },

  painting: {
    promotionalText:
      "Color your world with excellence, LaborHack painters deliver flawless, lasting finishes.",
    terms: [
      {
        term: "Acrylic Paint",
        definition:
          "A water-based paint made with acrylic resin, known for its durability and quick drying time.",
      },
      {
        term: "Adhesion",
        definition:
          "The ability of paint to stick to a surface without peeling or flaking.",
      },
      {
        term: "Airless Sprayer",
        definition:
          "A high-pressure device that sprays paint without using compressed air, providing even coverage.",
      },
      {
        term: "Alkyd Paint",
        definition:
          "A solvent-based paint that dries to a hard, durable finish, commonly used for trim and high-traffic areas.",
      },
      {
        term: "Alligatoring",
        definition:
          "A paint defect where the surface develops a cracked pattern resembling alligator skin due to improper application or aging.",
      },
      {
        term: "Back Rolling",
        definition:
          "The process of using a roller to spread sprayed paint evenly over a surface.",
      },
      {
        term: "Basecoat",
        definition:
          "The first layer of paint that provides adhesion for subsequent layers.",
      },
      {
        term: "Binder",
        definition:
          "The ingredient in paint that holds pigments together and ensures adhesion to surfaces.",
      },
      {
        term: "Blistering",
        definition:
          "The formation of bubbles or blisters on a painted surface, often caused by moisture or heat.",
      },
      {
        term: "Brick Sealer",
        definition:
          "A protective coating that prevents water absorption and enhances the durability of brick surfaces.",
      },
      {
        term: "Brush Marks",
        definition:
          "Visible streaks or lines left by a paintbrush, often due to improper application.",
      },
      {
        term: "Caulking",
        definition:
          "A flexible material used to seal gaps and joints in surfaces to prevent air or water infiltration.",
      },
      {
        term: "Chalking",
        definition:
          "A powdery residue that forms on a painted surface due to weathering or UV exposure.",
      },
      {
        term: "Coating",
        definition:
          "A protective or decorative layer of paint, varnish, or sealant applied to a surface.",
      },
      {
        term: "Color Fading",
        definition:
          "The gradual loss of paint color due to sunlight, weather exposure, or poor-quality pigments.",
      },
      {
        term: "Coverage",
        definition:
          "The area a given amount of paint can cover, usually measured in square feet per gallon.",
      },
      {
        term: "Cracking",
        definition:
          "The formation of small or large breaks in paint due to aging, moisture, or movement.",
      },
      {
        term: "Damp Proof Paint",
        definition:
          "A special coating designed to resist moisture and prevent dampness from seeping through walls.",
      },
      {
        term: "Drop Cloth",
        definition:
          "A protective sheet used to cover floors and furniture during painting.",
      },
      {
        term: "Drying Time",
        definition:
          "The period required for paint to become dry to the touch or ready for reapplication.",
      },
      {
        term: "Durability",
        definition:
          "The ability of paint to withstand wear, weather, and cleaning over time.",
      },
      {
        term: "Efflorescence",
        definition:
          "White, chalky deposits of salts that appear on masonry surfaces due to water evaporation.",
      },
      {
        term: "Elastomeric Paint",
        definition:
          "A flexible, waterproof coating designed to bridge small cracks and prevent water damage.",
      },
      {
        term: "Enamel Paint",
        definition:
          "A hard, glossy paint that provides a smooth and durable finish, often used for doors and cabinets.",
      },
      {
        term: "Epoxy Paint",
        definition:
          "A strong, chemical-resistant coating used for floors, countertops, and industrial applications.",
      },
      {
        term: "Exterior Paint",
        definition:
          "Paint formulated to withstand outdoor elements such as UV rays, rain, and temperature changes.",
      },
      {
        term: "Fading",
        definition:
          "The gradual loss of paint vibrancy due to exposure to sunlight and weather conditions.",
      },
      {
        term: "Feathering",
        definition:
          "The technique of blending paint smoothly into surrounding areas to create an even transition.",
      },
      {
        term: "Filler",
        definition:
          "A material used to fill holes, cracks, or imperfections before painting.",
      },
      {
        term: "Finish",
        definition:
          "The final texture and sheen of dried paint, such as matte, satin, or gloss.",
      },
      {
        term: "Gloss Paint",
        definition:
          "A high-sheen paint that reflects light and is easy to clean, often used in kitchens and bathrooms.",
      },
      {
        term: "Graining",
        definition:
          "A painting technique that mimics the appearance of wood grain.",
      },
      {
        term: "Green Building Paint",
        definition:
          "Eco-friendly paint with low environmental impact, often containing low or no VOCs.",
      },
      {
        term: "Ground Coat",
        definition:
          "A base layer applied before decorative finishes or glazing techniques.",
      },
      {
        term: "Hardener",
        definition:
          "A chemical additive that speeds up paint drying and increases durability.",
      },
      {
        term: "Humidity Resistance",
        definition:
          "The ability of paint to withstand moisture without peeling, blistering, or mildew growth.",
      },
      {
        term: "HVLP (High Volume Low Pressure) Sprayer",
        definition:
          "A spray system that delivers paint with minimal overspray and waste.",
      },
      {
        term: "Industrial Coating",
        definition:
          "A specialized protective paint used for heavy-duty applications such as factories and machinery.",
      },
      {
        term: "Interior Paint",
        definition:
          "Paint formulated for indoor use, designed for aesthetic appeal and easy cleaning.",
      },
      {
        term: "Intumescent Paint",
        definition:
          "A fire-resistant coating that expands when exposed to heat, forming an insulating barrier.",
      },
      {
        term: "Latex Paint",
        definition:
          "A water-based paint that dries quickly and is easy to clean with soap and water.",
      },
      {
        term: "Layering",
        definition:
          "Applying multiple coats of paint for depth, coverage, or texture.",
      },
      {
        term: "Low-VOC Paint",
        definition:
          "Paint with reduced levels of volatile organic compounds, making it safer for indoor air quality.",
      },
      {
        term: "Masonry Paint",
        definition:
          "A durable paint designed for porous surfaces like brick, concrete, and stucco.",
      },
      {
        term: "Matte Finish",
        definition:
          "A non-reflective paint finish that provides a soft, smooth appearance but is less washable.",
      },
      {
        term: "Mildew-Resistant Paint",
        definition:
          "Paint formulated with additives that prevent mold and mildew growth.",
      },
      {
        term: "Oil-Based Paint",
        definition:
          "A paint made with natural or synthetic oils, known for its durability and slow drying time.",
      },
      {
        term: "Opacity",
        definition:
          "The degree to which paint can cover the surface beneath it without showing through.",
      },
      {
        term: "Overcoating",
        definition:
          "Applying an additional layer of paint over an existing coat for enhanced durability or finish.",
      },
      {
        term: "Peeling",
        definition:
          "The detachment of paint from a surface, often due to poor adhesion, moisture, or aging.",
      },
      {
        term: "Polyurethane",
        definition:
          "A tough, protective finish used on wood, floors, and furniture.",
      },
      {
        term: "Pressure Washing",
        definition:
          "A high-pressure water cleaning method used to remove dirt, mildew, and loose paint.",
      },
      {
        term: "Primer",
        definition:
          "A preparatory coating that improves adhesion and enhances paint durability.",
      },
      {
        term: "Recoat Time",
        definition:
          "The recommended waiting period before applying a second coat of paint.",
      },
      {
        term: "Roller Application",
        definition:
          "A painting method using a roller for even and efficient paint distribution.",
      },
      {
        term: "Rust-Inhibiting Paint",
        definition: "Paint formulated to prevent rust on metal surfaces.",
      },
      {
        term: "Satin Finish",
        definition:
          "A paint finish with a soft sheen that offers a balance between matte and gloss.",
      },
      {
        term: "Scrub Resistance",
        definition:
          "The ability of paint to withstand repeated cleaning without losing color or finish.",
      },
      {
        term: "Sealer",
        definition:
          "A protective layer that prevents moisture, stains, or other contaminants from affecting the surface.",
      },
      {
        term: "Semi-Gloss Paint",
        definition:
          "A slightly glossy paint that provides durability and moisture resistance, often used for trim and bathrooms.",
      },
      {
        term: "Stain-Blocking Primer",
        definition:
          "A primer designed to prevent stains from bleeding through the topcoat.",
      },
      {
        term: "Texture Paint",
        definition:
          "A thick paint designed to create a textured or decorative surface effect.",
      },
      {
        term: "Tinting",
        definition:
          "The process of adding color pigments to paint to achieve a desired shade.",
      },
      {
        term: "Topcoat",
        definition:
          "The final layer of paint applied to a surface for protection and appearance.",
      },
      {
        term: "TSP (Trisodium Phosphate)",
        definition:
          "A cleaning agent used to remove grease and prepare surfaces before painting.",
      },
      {
        term: "Undercoat",
        definition:
          "A preparatory layer of paint that helps improve adhesion and coverage of the topcoat.",
      },
      {
        term: "UV Protection Paint",
        definition:
          "Paint formulated to resist fading and damage from ultraviolet (UV) rays.",
      },
      {
        term: "Varnish",
        definition:
          "A transparent protective coating applied over wood or painted surfaces for durability and shine.",
      },
      {
        term: "VOC (Volatile Organic Compounds)",
        definition:
          "Harmful chemicals in paint that evaporate into the air, contributing to indoor air pollution.",
      },
      {
        term: "Washable Paint",
        definition:
          "Paint that can be cleaned easily without damaging the surface.",
      },
      {
        term: "Weather-Resistant Paint",
        definition:
          "Paint designed to withstand rain, wind, and temperature changes without deteriorating.",
      },
      {
        term: "Wet-on-Wet Application",
        definition:
          "A technique where a second coat is applied before the first coat fully dries for smooth blending.",
      },
    ],
  },

  POP: {
    promotionalText:
      "Smooth ceilings, bold designs, LaborHack POP specialists redefine interior beauty.",
    terms: [
      {
        term: "Acrylic Sealant",
        definition:
          "A flexible, water-based sealant used for filling gaps and cracks.",
      },
      {
        term: "Adhesion Promoter",
        definition:
          "A substance applied to improve the bonding of plaster to surfaces.",
      },
      {
        term: "Air Bubble Removal",
        definition:
          "The process of eliminating trapped air from plaster to ensure a smooth finish.",
      },
      {
        term: "Angle Bead",
        definition:
          "A metal or plastic strip used to reinforce and shape the corners of plastered surfaces.",
      },
      {
        term: "Application Trowel",
        definition: "A flat-bladed tool used to spread and smooth plaster.",
      },
      {
        term: "Arch Moulding",
        definition:
          "A decorative curved plaster feature used to enhance ceilings and walls.",
      },
      {
        term: "Artisanal Finish",
        definition:
          "A handcrafted decorative plaster finish with a unique texture or pattern.",
      },
      {
        term: "Auto-Leveling Compound",
        definition:
          "A self-smoothing mixture used to create even surfaces before plastering.",
      },
      {
        term: "Base Coat",
        definition:
          "The first layer of plaster applied to a surface before finishing.",
      },
      {
        term: "Beading Strip",
        definition:
          "A reinforcing strip used to strengthen plaster edges and corners.",
      },
      {
        term: "Bedding Compound",
        definition:
          "A material used to bond plasterboards or moldings to surfaces.",
      },
      {
        term: "Binding Agent",
        definition:
          "A substance that helps plaster adhere to surfaces or bond together.",
      },
      {
        term: "Board Jointing",
        definition: "The process of sealing gaps between plasterboards.",
      },
      {
        term: "Bonding Agent",
        definition:
          "A liquid or adhesive used to enhance the adhesion of plaster to a substrate.",
      },
      {
        term: "Bracket Support",
        definition:
          "A structural component used to hold plaster elements in place.",
      },
      {
        term: "Bullnose Corner",
        definition:
          "A rounded corner detail used in plastering for a smooth transition.",
      },
      {
        term: "Burnishing",
        definition:
          "The process of polishing plaster surfaces for a shiny, smooth finish.",
      },
      {
        term: "Ceiling Board",
        definition:
          "A gypsum or plaster-based panel used to construct ceilings.",
      },
      {
        term: "Ceiling Medallion",
        definition:
          "A decorative plaster feature installed at the center of a ceiling.",
      },
      {
        term: "Ceiling Rose",
        definition:
          "An ornamental circular plaster design often placed around light fixtures.",
      },
      {
        term: "Center Panel",
        definition: "The central decorative element of a plastered ceiling.",
      },
      {
        term: "Chalk Line",
        definition:
          "A tool used to mark straight guidelines on walls and ceilings before plastering.",
      },
      {
        term: "Chipping Hammer",
        definition:
          "A tool used to break or remove old plaster or roughen surfaces for adhesion.",
      },
      {
        term: "Column Moulding",
        definition:
          "A decorative plaster covering used on columns for aesthetic enhancement.",
      },
      {
        term: "Compounding Knife",
        definition:
          "A tool used to apply and smooth joint compound on plasterboard.",
      },
      {
        term: "Compression Strength",
        definition:
          "The ability of plaster to resist pressure without cracking.",
      },
      {
        term: "Cornice Adhesive",
        definition:
          "A glue-like substance used to attach cornices to walls and ceilings.",
      },
      {
        term: "Cornice Moulding",
        definition:
          "A decorative plaster trim used at the junction of walls and ceilings.",
      },
      {
        term: "Crack Prevention",
        definition:
          "Techniques or materials used to stop plaster from developing cracks.",
      },
      {
        term: "Crack Repair Compound",
        definition:
          "A filler used to seal cracks and restore plaster surfaces.",
      },
      {
        term: "Curing Time",
        definition:
          "The period required for plaster to fully dry and reach maximum strength.",
      },
      {
        term: "Cutting Saw",
        definition: "A tool used to cut plasterboards and moldings.",
      },
      {
        term: "Decorative Ceiling Panel",
        definition: "A prefabricated plaster panel with ornamental designs.",
      },
      {
        term: "Decorative Moulding",
        definition:
          "Ornamental plaster designs used to enhance walls and ceilings.",
      },
      {
        term: "Design Template",
        definition:
          "A stencil or guide used for creating intricate plaster patterns.",
      },
      {
        term: "Direct Fixing",
        definition:
          "A method of attaching plaster elements directly to a surface without additional framing.",
      },
      {
        term: "Dry Mix Ratio",
        definition:
          "The correct proportion of dry plaster components before adding water.",
      },
      {
        term: "Drywall Screws",
        definition:
          "Special screws used to fasten plasterboard to walls and ceilings.",
      },
      {
        term: "Dust Control",
        definition: "Techniques to reduce airborne dust during plastering.",
      },
      {
        term: "Dust Mask",
        definition:
          "Protective gear worn to prevent inhalation of plaster dust.",
      },
      {
        term: "Edge Finishing",
        definition:
          "Smoothing and refining the edges of plaster surfaces for a clean look.",
      },
      {
        term: "Embossed Panel",
        definition:
          "A decorative plaster panel with raised patterns or textures.",
      },
      {
        term: "Epoxy Resin",
        definition:
          "A strong adhesive used for sealing and strengthening plaster surfaces.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A gap left between plaster sections to accommodate movement and prevent cracks.",
      },
      {
        term: "Exterior POP Finish",
        definition: "A durable plaster finish designed for outdoor use.",
      },
      {
        term: "Extrusion Moulding",
        definition:
          "A manufacturing process used to create uniform plaster moldings.",
      },
      {
        term: "False Ceiling",
        definition:
          "A secondary ceiling made of plasterboard or POP, often for aesthetics or insulation.",
      },
      {
        term: "Feathering Technique",
        definition:
          "A method of blending plaster edges smoothly into the surrounding surface.",
      },
      {
        term: "Fiberglass Mesh",
        definition: "A reinforcing mesh used to prevent cracks in plaster.",
      },
      {
        term: "Filler Compound",
        definition:
          "A material used to fill holes, gaps, or imperfections in plaster.",
      },
      {
        term: "Finishing Coat",
        definition:
          "The final layer of plaster applied for a smooth or decorative surface.",
      },
      {
        term: "Fire-Resistant POP",
        definition:
          "A formulation of plaster of Paris designed to withstand high temperatures.",
      },
      {
        term: "Flexural Strength",
        definition:
          "The ability of plaster to resist bending without cracking.",
      },
      {
        term: "Floating Ceiling",
        definition:
          "A suspended ceiling design that appears to hover below the main ceiling.",
      },
      {
        term: "Flush Joint",
        definition:
          "A seamless joint between plaster panels for a smooth surface.",
      },
      {
        term: "Framework Support",
        definition:
          "The structural framework that supports plasterboard or moldings.",
      },
      {
        term: "Gesso Coating",
        definition:
          "A primer layer used on plaster surfaces for smooth painting or gilding.",
      },
      {
        term: "Glazing Compound",
        definition:
          "A material applied to plaster for a glossy, polished finish.",
      },
      {
        term: "Grid Ceiling System",
        definition:
          "A suspended ceiling framework used for supporting plaster panels.",
      },
      {
        term: "Groove Cutter",
        definition:
          "A tool used to carve decorative grooves in plaster surfaces.",
      },
      {
        term: "Gypsum Board",
        definition:
          "A panel made of gypsum plaster, commonly used for walls and ceilings.",
      },
      {
        term: "Gypsum Plaster",
        definition:
          "A plaster material made from gypsum powder, used for wall finishes.",
      },
      {
        term: "Hand Moulding",
        definition:
          "The manual process of shaping plaster into decorative forms.",
      },
      {
        term: "Hand Trowel",
        definition: "A handheld tool used for spreading and smoothing plaster.",
      },
      {
        term: "Heat Resistance",
        definition:
          "The ability of plaster to withstand high temperatures without damage.",
      },
      {
        term: "High-Density POP",
        definition: "A stronger and more durable form of plaster of Paris.",
      },
      {
        term: "Hollow Panel",
        definition:
          "A lightweight plaster panel with internal air pockets for insulation.",
      },
      {
        term: "Hydrocal Plaster",
        definition:
          "A high-strength gypsum plaster used for detailed moldings and sculptures.",
      },
      {
        term: "Impact-Resistant Board",
        definition:
          "A reinforced plasterboard designed to withstand impact and damage.",
      },
      {
        term: "Industrial POP",
        definition:
          "A specialized plaster of Paris mix designed for heavy-duty applications.",
      },
      {
        term: "Insulated POP Panels",
        definition:
          "Plaster panels designed to provide thermal and acoustic insulation.",
      },
      {
        term: "Interior Moulding",
        definition:
          "Decorative plaster trim used inside buildings for aesthetic enhancement.",
      },
      {
        term: "Intricate Design Work",
        definition: "Highly detailed decorative plaster patterns and carvings.",
      },
      {
        term: "Joint Compound",
        definition:
          "A paste used to fill and smooth joints between plasterboards.",
      },
      {
        term: "Jointing Tape",
        definition:
          "A tape applied over plasterboard joints to prevent cracking.",
      },
      {
        term: "Jute Fiber Reinforcement",
        definition:
          "Natural fiber added to plaster for extra strength and durability.",
      },
      {
        term: "Knockdown Texture",
        definition:
          "A decorative plaster finish with a slightly rough, textured appearance.",
      },
      {
        term: "Knife-Edge Finish",
        definition: "A sharp, clean plaster edge that creates a modern look.",
      },
      {
        term: "Lath and Plaster",
        definition:
          "A traditional plastering method where wet plaster is applied over wooden slats (laths).",
      },
      {
        term: "Lightweight POP",
        definition:
          "A lighter formulation of plaster of Paris used to reduce load on ceilings and walls.",
      },
      {
        term: "Load-Bearing Consideration",
        definition:
          "Structural factors affecting the weight distribution of plaster elements.",
      },
      {
        term: "Louvered Ceiling",
        definition:
          "A ceiling design featuring angled slats or openings for ventilation and aesthetics.",
      },
      {
        term: "Moisture-Resistant POP",
        definition:
          "A type of plaster of Paris designed to withstand humid conditions.",
      },
      {
        term: "Mould Release Agent",
        definition:
          "A substance applied to moulds to prevent plaster from sticking.",
      },
      {
        term: "Moulding Frame",
        definition:
          "A structural support used for shaping decorative plaster mouldings.",
      },
      {
        term: "Moulding Knife",
        definition:
          "A specialized tool used for carving and shaping plaster mouldings.",
      },
      {
        term: "Moulding Paste",
        definition:
          "A thick, malleable plaster used to create intricate moulding designs.",
      },
      {
        term: "Multi-Layer POP Finish",
        definition:
          "A plaster technique involving multiple layers for durability and detail.",
      },
      {
        term: "Non-Sagging Compound",
        definition: "A plaster mix designed to stay in place without drooping.",
      },
      {
        term: "Notched Trowel",
        definition:
          "A trowel with a serrated edge used for evenly spreading plaster or adhesive.",
      },
      {
        term: "Ornamental Ceiling",
        definition:
          "A ceiling featuring decorative plaster designs, such as medallions or patterns.",
      },
      {
        term: "Overhead Plastering",
        definition:
          "The process of applying plaster to ceilings or high surfaces.",
      },
      {
        term: "Oxidation Resistance",
        definition:
          "The ability of plaster or coatings to resist rusting or chemical deterioration.",
      },
      {
        term: "Paintable Surface",
        definition: "A plaster finish that is smooth and ready for painting.",
      },
      {
        term: "Panel Board",
        definition:
          "A flat plasterboard used for wall and ceiling installations.",
      },
      {
        term: "Pattern Roller",
        definition: "A roller tool used to imprint designs onto wet plaster.",
      },
      {
        term: "Perforated Board",
        definition:
          "A plasterboard with holes to improve ventilation or acoustics.",
      },
      {
        term: "Plaster Adhesive",
        definition:
          "A bonding agent that ensures strong attachment of plaster to surfaces.",
      },
      {
        term: "Plaster of Paris (POP)",
        definition:
          "A quick-setting material made from gypsum used for sculpting and construction.",
      },
      {
        term: "Plaster Reinforcement",
        definition:
          "Materials like mesh or fibers added to plaster for added strength.",
      },
      {
        term: "Plastering Float",
        definition:
          "A flat tool used to smooth and level freshly applied plaster.",
      },
      {
        term: "Polished Finish",
        definition: "A smooth, glossy surface achieved by burnishing plaster.",
      },
      {
        term: "POP Ceiling Design",
        definition: "Decorative ceiling layouts made using plaster of Paris.",
      },
      {
        term: "POP Cornices",
        definition:
          "Decorative mouldings made of plaster of Paris for ceilings.",
      },
      {
        term: "POP Panel Board",
        definition:
          "Pre-fabricated plaster panels used for ceilings and walls.",
      },
      {
        term: "POP Screeding",
        definition:
          "A method of leveling surfaces with a smooth layer of plaster.",
      },
      {
        term: "Pre-Fabricated Moulding",
        definition: "Ready-made plaster mouldings for easy installation.",
      },
      {
        term: "Priming Coat",
        definition:
          "The first layer of primer applied to prepare plaster for painting.",
      },
      {
        term: "Putty Knife",
        definition:
          "A small, flat tool used for applying and smoothing putty or plaster.",
      },
      {
        term: "Quick-Setting Plaster",
        definition: "A fast-drying plaster mixture that hardens rapidly.",
      },
      {
        term: "Reinforcement Mesh",
        definition:
          "A mesh embedded in plaster to prevent cracks and improve durability.",
      },
      {
        term: "Resin-Coated Moulding",
        definition:
          "Plaster mouldings coated with resin for added strength and moisture resistance.",
      },
      {
        term: "Reusable Mould",
        definition: "A mould designed for multiple uses in plaster casting.",
      },
      {
        term: "Ribbed Ceiling",
        definition:
          "A ceiling design with raised or recessed lines for texture.",
      },
      {
        term: "Rock Hard Plaster",
        definition: "A highly durable plaster mix with superior hardness.",
      },
      {
        term: "Sanding Block",
        definition: "A tool used for smoothing plaster surfaces.",
      },
      {
        term: "Sandpaper Finish",
        definition:
          "A slightly rough plaster texture achieved using sandpaper.",
      },
      {
        term: "Scratch Coat",
        definition:
          "The first rough layer of plaster applied for better adhesion of the final coat.",
      },
      {
        term: "Screeding Board",
        definition: "A straight-edged tool used to level wet plaster surfaces.",
      },
      {
        term: "Seamless Jointing",
        definition:
          "A plastering technique that ensures no visible gaps between panels.",
      },
      {
        term: "Shadow Gap Design",
        definition:
          "A recessed gap in plaster to create a modern, floating effect.",
      },
      {
        term: "Silica-Free Plaster",
        definition:
          "A plaster formula without silica, reducing health hazards.",
      },
      {
        term: "Skim Coat",
        definition:
          "A thin, smooth layer of plaster applied for a flawless surface.",
      },
      {
        term: "Smooth Finish",
        definition: "A polished and even plaster surface.",
      },
      {
        term: "Soundproof POP Panels",
        definition: "Plaster panels designed to reduce noise transmission.",
      },
      {
        term: "Stencil Cutting",
        definition:
          "The process of cutting patterns into plaster for decorative effects.",
      },
      {
        term: "Stud Framework",
        definition: "A structural frame used to support plasterboard walls.",
      },
      {
        term: "Surface Hardness",
        definition:
          "The durability of a plaster surface against wear and tear.",
      },
      {
        term: "Suspended Ceiling",
        definition:
          "A ceiling hung below the main ceiling, often for aesthetic or acoustic purposes.",
      },
      {
        term: "Tape Jointing",
        definition:
          "The use of tape to reinforce plasterboard joints before plastering.",
      },
      {
        term: "Template Cutting",
        definition:
          "The process of shaping plaster using a pre-designed guide.",
      },
      {
        term: "Textured POP Finish",
        definition: "A decorative plaster finish with patterns or reliefs.",
      },
      {
        term: "Thermal Resistance",
        definition: "The ability of plaster to resist heat transfer.",
      },
      {
        term: "Thistle Plaster",
        definition: "A branded type of high-quality finishing plaster.",
      },
      {
        term: "Three-Dimensional Moulding",
        definition:
          "Plaster elements designed with depth and intricate detailing.",
      },
      {
        term: "Trowel Application",
        definition: "The process of spreading plaster using a trowel.",
      },
      {
        term: "Two-Coat Plaster System",
        definition:
          "A plastering method that involves applying a base coat and a finishing coat.",
      },
      {
        term: "Undercoat Plaster",
        definition:
          "The first layer of plaster applied before the finishing coat.",
      },
      {
        term: "UV-Resistant Plaster",
        definition:
          "A type of plaster that resists damage from ultraviolet light.",
      },
      {
        term: "Veneer Plaster",
        definition:
          "A thin layer of high-quality plaster applied over a base surface.",
      },
      {
        term: "Wall Cladding",
        definition:
          "A decorative plaster covering applied to walls for texture or protection.",
      },
      {
        term: "Water-Resistant POP",
        definition:
          "A moisture-resistant plaster of Paris mix for damp environments.",
      },
      {
        term: "Weatherproof Coating",
        definition:
          "A protective layer applied to plaster to withstand environmental conditions.",
      },
      {
        term: "Wire Mesh Reinforcement",
        definition: "A metal mesh embedded in plaster for extra durability.",
      },
      {
        term: "Workability Time",
        definition:
          "The period during which plaster remains usable before setting.",
      },
      {
        term: "Zero Shrinkage Formula",
        definition:
          "A plaster mix designed to prevent cracking or shrinking as it dries.",
      },
    ],
  },

  plumbing: {
    promotionalText:
      "No leaks, no stress, LaborHack plumbers keep your water systems flowing perfectly.",
    terms: [
      {
        term: "ABS Pipe",
        definition:
          "A type of black plastic pipe used in plumbing for drain, waste, and vent (DWV) systems, known for its durability and resistance to impact.",
      },
      {
        term: "Access Panel",
        definition:
          "A removable panel that provides access to plumbing fixtures, valves, or pipes for maintenance and repairs.",
      },
      {
        term: "Air Admittance Valve (AAV)",
        definition:
          "A one-way valve that allows air to enter the drainage system to prevent siphoning without the need for an external vent.",
      },
      {
        term: "Air Gap",
        definition:
          "The vertical space between a water outlet (like a faucet) and the flood level of a fixture to prevent backflow contamination.",
      },
      {
        term: "Angle Stop Valve",
        definition:
          "A small shutoff valve located under sinks or toilets, allowing for localized water supply control.",
      },
      {
        term: "Anti-Siphon Valve",
        definition:
          "A valve designed to prevent backflow and contamination of potable water supplies.",
      },
      {
        term: "Backflow",
        definition:
          "The unwanted flow of water in the reverse direction in a plumbing system.",
      },
      {
        term: "Backflow Preventer",
        definition:
          "A device that stops contaminated water from reversing into the potable water supply.",
      },
      {
        term: "Ball Valve",
        definition:
          "A shutoff valve that controls water flow using a rotating ball inside a chamber, commonly used for main water supply lines.",
      },
      {
        term: "Basin",
        definition:
          "A bowl-shaped plumbing fixture, such as a sink, used for washing hands or dishes.",
      },
      {
        term: "Basin Wrench",
        definition:
          "A specialized tool with a long handle and pivoting jaw, used for tightening or loosening nuts on sink faucets.",
      },
      {
        term: "Bath Drain",
        definition:
          "The drain system in a bathtub that removes wastewater and connects to the home's plumbing.",
      },
      {
        term: "Bath Spout",
        definition:
          "The outlet fixture on a bathtub from which water flows, often with a diverter to direct water to a showerhead.",
      },
      {
        term: "Bell and Spigot Joint",
        definition:
          "A connection method for pipes where one pipe end (bell) is flared to fit over the end of another pipe (spigot) and sealed with a gasket or joint compound.",
      },
      {
        term: "Bibcock",
        definition: "A type of outdoor faucet, commonly used for garden hoses.",
      },
      {
        term: "Bidet",
        definition:
          "A bathroom fixture used for washing after using the toilet, common in many parts of the world.",
      },
      {
        term: "Bleed Valve",
        definition:
          "A valve used to release trapped air or excess pressure from a plumbing system.",
      },
      {
        term: "Boiler System",
        definition:
          "A system that heats water for central heating or domestic hot water supply.",
      },
      {
        term: "Branch Drain",
        definition:
          "A secondary drain pipe that connects fixtures like sinks and toilets to the main drain line.",
      },
      {
        term: "BTU (British Thermal Unit)",
        definition:
          "A unit of measurement for heat energy, commonly used to rate water heaters.",
      },
      {
        term: "Building Drain",
        definition:
          "The lowest part of a building's drainage system that collects wastewater from various fixtures before directing it to the sewer or septic system.",
      },
      {
        term: "Building Sewer",
        definition:
          "The pipe that carries wastewater from a building's drainage system to the municipal sewer or septic tank.",
      },
      {
        term: "Burst Pressure",
        definition:
          "The maximum pressure a pipe or fitting can withstand before it ruptures.",
      },
      {
        term: "Check Valve",
        definition:
          "A valve that allows water to flow in only one direction, preventing backflow.",
      },
      {
        term: "Cistern",
        definition:
          "A storage tank for holding water, often used in toilets or rainwater collection systems.",
      },
      {
        term: "Cleanout Plug",
        definition:
          "A removable cap on a drain or sewer line that provides access for clearing clogs.",
      },
      {
        term: "Closet Bend",
        definition:
          "A curved pipe fitting that connects a toilet to the drainpipe.",
      },
      {
        term: "Closet Flange",
        definition:
          "A fitting that secures a toilet to the floor and connects it to the drainpipe.",
      },
      {
        term: "Compression Fitting",
        definition:
          "A type of plumbing connection that seals pipes together using a compression ring and nut.",
      },
      {
        term: "Condensate Drain",
        definition:
          "A pipe that removes excess moisture from air conditioning or heating systems.",
      },
      {
        term: "Copper Pipe",
        definition:
          "A durable metal pipe commonly used in plumbing for water supply lines.",
      },
      {
        term: "Cross-Connection",
        definition:
          "A connection between potable and non-potable water systems that could allow contamination.",
      },
      {
        term: "Dielectric Union",
        definition:
          "A special fitting used to connect dissimilar metals (e.g., copper and steel) in plumbing systems to prevent galvanic corrosion.",
      },
      {
        term: "Dimmer Switch",
        definition:
          "A switch that allows the user to adjust the brightness of a light by varying the voltage supply.",
      },
      {
        term: "Drain Snake",
        definition:
          "A flexible auger used to clear clogs in drains by breaking through blockages.",
      },
      {
        term: "Drainage System",
        definition:
          "The network of pipes that removes wastewater from a building.",
      },
      {
        term: "Drain-Waste-Vent (DWV) System",
        definition:
          "The plumbing system that removes wastewater and prevents sewer gases from entering a building.",
      },
      {
        term: "Drip Leak",
        definition:
          "A small, slow leak in a plumbing fixture or pipe, often caused by worn-out washers or seals.",
      },
      {
        term: "Drop Ear Elbow",
        definition:
          "A 90-degree pipe fitting with mounting tabs used to secure it to a surface for added stability.",
      },
      {
        term: "Drum Trap",
        definition:
          "An older style of plumbing trap that holds water to prevent sewer gases from entering a home, often replaced with modern P-traps.",
      },
      {
        term: "Dual-Flush Toilet",
        definition:
          "A toilet with two flush options (low and high volume) to conserve water.",
      },
      {
        term: "Elbow Fitting",
        definition:
          "A pipe fitting that allows for a change in direction, typically at 90 or 45 degrees.",
      },
      {
        term: "Energy-Efficient Plumbing",
        definition:
          "Plumbing systems designed to reduce water and energy consumption, such as low-flow fixtures.",
      },
      {
        term: "Escutcheon Plate",
        definition:
          "A decorative plate that covers the hole where a pipe passes through a wall or floor.",
      },
      {
        term: "Expansion Tank",
        definition:
          "A small tank installed in a plumbing system to absorb excess pressure caused by thermal expansion in water heating systems.",
      },
      {
        term: "Faucet",
        definition:
          "A device that controls the release of water from a pipe, commonly found on sinks, bathtubs, and outdoor spigots.",
      },
      {
        term: "Ferrule",
        definition:
          "A small metal or plastic ring used in compression fittings to create a watertight seal.",
      },
      {
        term: "Fixture Unit",
        definition:
          "A measurement unit used in plumbing design to estimate water demand based on fixture flow rates.",
      },
      {
        term: "Flapper Valve",
        definition:
          "A rubber or plastic valve in a toilet tank that lifts to allow water to flush and then seals to stop water flow.",
      },
      {
        term: "Float Valve",
        definition:
          "A valve that controls water levels in tanks or cisterns using a floating mechanism.",
      },
      {
        term: "Floor Drain",
        definition:
          "A plumbing drain installed in the floor of basements, garages, or commercial buildings to remove excess water.",
      },
      {
        term: "Flow Rate",
        definition:
          "The volume of water moving through a pipe or fixture, typically measured in gallons per minute (GPM).",
      },
      {
        term: "Flush Handle",
        definition:
          "The lever or button on a toilet that activates the flushing mechanism.",
      },
      {
        term: "Flush Valve",
        definition:
          "The mechanism inside a toilet tank that releases water to initiate a flush.",
      },
      {
        term: "Flushometer",
        definition:
          "A high-pressure flushing system commonly used in commercial toilets and urinals.",
      },
      {
        term: "Flushometer Valve",
        definition:
          "A high-pressure valve used in commercial toilets and urinals to control water flow without a tank.",
      },
      {
        term: "Flux",
        definition:
          "A chemical used in soldering to clean and prepare pipe surfaces for a secure bond.",
      },
      {
        term: "Frost-Free Hose Bibb",
        definition:
          "An outdoor faucet designed to prevent freezing by draining water when shut off.",
      },
      {
        term: "Fuse",
        definition:
          "A protective device containing a thin wire that melts when excessive current flows through it, breaking the circuit to prevent damage.",
      },
      {
        term: "Garbage Disposal",
        definition:
          "A device installed under a kitchen sink that grinds food waste into small particles to be washed away through the drain.",
      },
      {
        term: "Gate Valve",
        definition:
          "A valve that controls water flow by raising or lowering a gate inside the valve body; used for on/off control rather than flow regulation.",
      },
      {
        term: "Gray Water",
        definition:
          "Wastewater from sinks, showers, and washing machines that can be recycled for irrigation or other non-potable uses.",
      },
      {
        term: "Gray Water System",
        definition:
          "A plumbing system that collects and reuses wastewater from sinks, showers, and laundry for irrigation or flushing toilets.",
      },
      {
        term: "Grease Trap",
        definition:
          "A plumbing device that captures grease, oil, and solids before they enter the wastewater system, preventing clogs.",
      },
      {
        term: "Grounding",
        definition:
          "A safety measure where electrical circuits are connected to the earth to prevent electrical shock and equipment damage.",
      },
      {
        term: "Gully Trap",
        definition:
          "A plumbing trap that prevents foul odors and gases from escaping into a building while allowing wastewater to drain away.",
      },
      {
        term: "Hand Shower",
        definition:
          "A detachable showerhead that can be handheld for flexible washing.",
      },
      {
        term: "Hard Water",
        definition:
          "Water with a high mineral content (mainly calcium and magnesium), which can cause scale buildup in pipes and appliances.",
      },
      {
        term: "Hose Bibb",
        definition:
          "An outdoor faucet used for connecting garden hoses and other outdoor water needs.",
      },
      {
        term: "Hot Water Heater",
        definition:
          "A device that heats water for domestic use in homes and businesses.",
      },
      {
        term: "Hydraulic Shock",
        definition:
          "A sudden surge of pressure in a plumbing system, commonly known as water hammer.",
      },
      {
        term: "Hydronic Heating",
        definition:
          "A heating system that uses hot water or steam to warm a building through radiators, underfloor heating, or baseboards.",
      },
      {
        term: "Hydronic Heating System",
        definition:
          "A heating system that uses water to transfer heat through radiators, baseboard heaters, or underfloor piping.",
      },
      {
        term: "Inlet Pipe",
        definition:
          "A pipe that brings water into a plumbing system or fixture.",
      },
      {
        term: "Instant Hot Water System",
        definition:
          "A water heating system that provides near-instant hot water, often using a small storage tank or a continuous-flow heater.",
      },
      {
        term: "Interceptor",
        definition:
          "A device that captures contaminants (such as grease or sediment) before they enter a plumbing system.",
      },
      {
        term: "Isolation Valve",
        definition:
          "A valve that allows a section of a plumbing system to be shut off without affecting the entire system.",
      },
      {
        term: "Joint Compound",
        definition:
          "A sealant or adhesive used in plumbing connections to create a watertight seal between pipes or fittings.",
      },
      {
        term: "Junction Box",
        definition:
          "A protective enclosure where electrical wires are connected and contained.",
      },
      {
        term: "Lead-Free Pipe",
        definition:
          "A pipe that meets safety standards for drinking water by containing little to no lead, ensuring safe water consumption.",
      },
      {
        term: "Leak Detection System",
        definition:
          "A system that monitors for water leaks and can automatically shut off the water supply to prevent damage.",
      },
      {
        term: "LED (Light-Emitting Diode)",
        definition:
          "A highly efficient light source that uses semiconductors to produce illumination with minimal energy consumption.",
      },
      {
        term: "Live Wire",
        definition:
          "A wire carrying an active electrical current, typically marked in red or black in standard wiring.",
      },
      {
        term: "Low-Flow Faucet",
        definition:
          "A faucet designed to reduce water usage by limiting the flow rate.",
      },
      {
        term: "Low-Flow Toilet",
        definition:
          "A toilet that uses less water per flush to conserve water and improve efficiency.",
      },
      {
        term: "Main Service Panel",
        definition:
          "The primary electrical panel that receives power from the utility and distributes it throughout a building.",
      },
      {
        term: "Main Shutoff Valve",
        definition:
          "The primary valve that controls the water supply to an entire building.",
      },
      {
        term: "Main Water Line",
        definition:
          "The primary pipe that delivers water from the municipal supply or well into a building's plumbing system.",
      },
      {
        term: "Manifold",
        definition:
          "A plumbing device that distributes water from a single source to multiple fixtures.",
      },
      {
        term: "MAPP Gas",
        definition:
          "A type of fuel gas used for high-temperature soldering and brazing in plumbing applications.",
      },
      {
        term: "Mechanical Joint (MJ)",
        definition:
          "A type of pipe connection that uses gaskets, glands, and bolts to create a secure and flexible joint.",
      },
      {
        term: "Meter Pit",
        definition:
          "A below-ground enclosure housing a water meter to measure water usage.",
      },
      {
        term: "Mixer Tap",
        definition:
          "A faucet that combines hot and cold water into a single stream, allowing users to adjust the temperature.",
      },
      {
        term: "Neutral Wire",
        definition:
          "A conductor that carries current back to the power source to complete an electrical circuit.",
      },
      {
        term: "Nipple Fitting",
        definition:
          "A short piece of pipe with threads on both ends used to connect two fittings or extend a pipe.",
      },
      {
        term: "No-Hub Coupling",
        definition:
          "A flexible connector used to join cast iron pipes, secured with metal bands and clamps.",
      },
      {
        term: "Ohm",
        definition: "The unit of measurement for electrical resistance.",
      },
      {
        term: "O-Ring",
        definition:
          "A rubber gasket used in plumbing connections to create a watertight seal.",
      },
      {
        term: "Overload",
        definition:
          "A condition where a circuit receives more current than it is designed to handle, potentially causing overheating or fire.",
      },
      {
        term: "Overflow Drain",
        definition:
          "A secondary drain in sinks, bathtubs, or toilets that prevents water from overflowing if the main drain is blocked.",
      },
      {
        term: "PEX Pipe",
        definition:
          "A flexible plastic piping material used in plumbing systems for hot and cold water supply.",
      },
      {
        term: "Phase",
        definition:
          "The timing relationship of alternating current (AC) waveforms, commonly single-phase (residential use) or three-phase (industrial use).",
      },
      {
        term: "Pipe Dope",
        definition:
          "A thread-sealing compound applied to pipe joints to prevent leaks.",
      },
      {
        term: "Pipe Insulation",
        definition:
          "Material wrapped around pipes to reduce heat loss, prevent freezing, and minimize condensation.",
      },
      {
        term: "Plumbing Code",
        definition:
          "A set of regulations that governs the design, installation, and maintenance of plumbing systems to ensure safety and efficiency.",
      },
      {
        term: "Power Surge",
        definition:
          "A sudden spike in electrical voltage that can damage electronic devices and appliances.",
      },
      {
        term: "Pressure-Reducing Valve (PRV)",
        definition:
          "A valve that regulates water pressure in a plumbing system to prevent damage to pipes and fixtures.",
      },
      {
        term: "Pressure Test",
        definition:
          "A test conducted by applying water or air pressure to check for leaks in a plumbing system.",
      },
      {
        term: "P-Trap",
        definition:
          "A curved section of pipe under sinks and other drains that holds water to block sewer gases from entering the building.",
      },
      {
        term: "Pump Sump",
        definition:
          "A pit that collects excess water, usually in basements, and uses a sump pump to prevent flooding.",
      },
      {
        term: "PVC Pipe",
        definition:
          "A common type of plastic pipe used for plumbing, known for its durability and resistance to corrosion.",
      },
      {
        term: "Rainwater Harvesting System",
        definition:
          "A system that collects and stores rainwater for irrigation or other non-potable uses.",
      },
      {
        term: "Recessed Lighting",
        definition:
          "A type of lighting fixture installed into a hollow opening in a ceiling, providing a clean and modern look.",
      },
      {
        term: "Relief Valve",
        definition:
          "A safety valve that releases excess pressure in a plumbing or heating system to prevent damage.",
      },
      {
        term: "Return Loop",
        definition:
          "A plumbing setup used in hot water recirculation systems to ensure instant access to hot water.",
      },
      {
        term: "Riser Pipe",
        definition:
          "A vertical pipe that carries water or waste between floors in a building.",
      },
      {
        term: "Saddle Valve",
        definition:
          "A self-tapping valve clamped onto an existing pipe to create a new water outlet, often used for refrigerator water lines.",
      },
      {
        term: "Sanitary Sewer",
        definition:
          "The system of underground pipes that transports wastewater from homes and businesses to a treatment facility.",
      },
      {
        term: "Septic System",
        definition:
          "A self-contained wastewater treatment system used in areas without municipal sewers.",
      },
      {
        term: "Service Line",
        definition:
          "The pipe that connects a home's plumbing to the main water supply or sewer system.",
      },
      {
        term: "Short Circuit",
        definition:
          "An electrical fault where current bypasses the normal path, leading to excessive current flow.",
      },
      {
        term: "Shower Arm",
        definition:
          "The pipe that connects a showerhead to the plumbing system.",
      },
      {
        term: "Shower Drain",
        definition:
          "The drain at the bottom of a shower that removes wastewater.",
      },
      {
        term: "Shower Head",
        definition: "The fixture from which water sprays in a shower.",
      },
      {
        term: "Shut-Off Valve",
        definition:
          "A valve that allows water flow to be stopped to a specific fixture or section of plumbing.",
      },
      {
        term: "Sillcock",
        definition:
          "An outdoor faucet designed to withstand freezing temperatures.",
      },
      {
        term: "Siphon Breaker",
        definition:
          "A device that prevents backflow in plumbing systems by introducing air into the line.",
      },
      {
        term: "Smart Home Wiring",
        definition:
          "Electrical wiring designed to integrate with smart home automation systems, allowing remote control of lighting, security, and appliances.",
      },
      {
        term: "Soil Stack",
        definition:
          "A vertical pipe that carries wastewater and sewer gases from plumbing fixtures to the main drain.",
      },
      {
        term: "Solenoid Valve",
        definition:
          "An electrically controlled valve used in automated plumbing systems.",
      },
      {
        term: "Soldering Flux",
        definition:
          "A chemical agent applied before soldering to clean metal surfaces and improve adhesion.",
      },
      {
        term: "Storm Drain",
        definition:
          "A drainage system that collects and directs rainwater away from streets and properties.",
      },
      {
        term: "Sump Pump",
        definition:
          "A pump installed in a basement or crawl space to remove excess groundwater and prevent flooding.",
      },
      {
        term: "Supply Line",
        definition:
          "The pipe that delivers water from the main source to fixtures like sinks, toilets, and showers.",
      },
      {
        term: "Surge Protector",
        definition:
          "A device that protects electronic equipment from voltage spikes by diverting excess electricity to the ground.",
      },
      {
        term: "Sweating Pipes",
        definition:
          "A term used for soldering copper pipes to create a watertight joint.",
      },
      {
        term: "Tailpiece",
        definition: "A short pipe connecting a sink drain to the P-trap.",
      },
      {
        term: "Tankless Water Heater",
        definition:
          "A water heater that heats water on demand rather than storing it in a tank.",
      },
      {
        term: "Tap",
        definition:
          "A British term for a faucet, a device that controls water flow.",
      },
      {
        term: "Tee Fitting",
        definition:
          "A T-shaped pipe fitting that connects three pipes, allowing for branch connections.",
      },
      {
        term: "Thermal Expansion",
        definition:
          "The increase in pipe volume due to heat, which can cause pressure buildup in a plumbing system.",
      },
      {
        term: "Thermostatic Mixing Valve (TMV)",
        definition:
          "A valve that automatically blends hot and cold water to maintain a safe and consistent water temperature.",
      },
      {
        term: "Three-Phase Power",
        definition:
          "A high-efficiency electrical power system used in commercial and industrial settings, featuring three alternating currents that work together to provide constant energy flow.",
      },
      {
        term: "Toilet Bowl",
        definition:
          "The lower part of a toilet that holds wastewater before it is flushed away.",
      },
      {
        term: "Toilet Flange",
        definition:
          "A fitting that connects the toilet to the floor and drain pipe.",
      },
      {
        term: "Toilet Seat",
        definition: "The hinged seat that covers the toilet bowl.",
      },
      {
        term: "Toilet Wax Ring",
        definition:
          "A wax seal that prevents leaks between the toilet and the drain pipe.",
      },
      {
        term: "Transformer",
        definition:
          "A device that changes the voltage level of an alternating current (AC) electrical supply, either stepping it up or down.",
      },
      {
        term: "Trap Primer",
        definition:
          "A device that maintains the water seal in a P-trap by automatically adding water to prevent evaporation.",
      },
      {
        term: "Trench Drain",
        definition:
          "A long, narrow drainage system designed to collect surface water and prevent flooding.",
      },
      {
        term: "Union Fitting",
        definition:
          "A plumbing fitting that allows for easy disconnection and reconnection of pipes.",
      },
      {
        term: "Urinal",
        definition:
          "A wall-mounted plumbing fixture used for urination, commonly found in public restrooms.",
      },
      {
        term: "Utility Sink",
        definition:
          "A deep, durable sink used for laundry, cleaning, or industrial purposes.",
      },
      {
        term: "Valve Seat",
        definition:
          "The part of a valve that comes into contact with the valve disk to control water flow.",
      },
      {
        term: "Vent Pipe",
        definition:
          "A pipe that allows air into a plumbing system to maintain proper pressure and prevent siphoning of water from traps.",
      },
      {
        term: "Vent Stack",
        definition:
          "A vertical pipe that allows air to enter the drainage system, preventing siphoning and ensuring proper wastewater flow.",
      },
      {
        term: "Vertical Stack",
        definition:
          "A tall, vertical pipe that carries wastewater or ventilation air in a multi-story building.",
      },
      {
        term: "Voltage",
        definition:
          "The electrical potential difference between two points in a circuit, measured in volts (V). It determines the force that pushes current through a conductor.",
      },
      {
        term: "Waste Arm",
        definition:
          "The horizontal pipe that connects a sink or tub drain to the main drainage system.",
      },
      {
        term: "Waste Pipe",
        definition:
          "A pipe that carries wastewater from fixtures like sinks, tubs, and toilets to the sewer or septic system.",
      },
      {
        term: "Water Closet (WC)",
        definition: "Another term for a toilet.",
      },
      {
        term: "Water Hammer",
        definition:
          "A loud banging noise in pipes caused by a sudden stop in water flow, often due to high pressure or quick-closing valves.",
      },
      {
        term: "Water Heater",
        definition: "A device that heats water for domestic use.",
      },
      {
        term: "Water Main",
        definition:
          "The primary water supply pipe that delivers water to a home or building.",
      },
      {
        term: "Water Meter",
        definition: "A device that measures water usage in a home or business.",
      },
      {
        term: "Water Pressure Regulator",
        definition:
          "A valve that reduces high water pressure to a safe level in a plumbing system.",
      },
      {
        term: "Water Softener",
        definition:
          "A system that removes hard minerals (like calcium and magnesium) from water to prevent scale buildup.",
      },
      {
        term: "Water Supply Line",
        definition:
          "The pipe that delivers water from the main supply to individual fixtures.",
      },
      {
        term: "Wattage",
        definition:
          "A measure of electrical power, indicating how much energy an appliance or device consumes, calculated as volts × amps.",
      },
      {
        term: "Wax Ring",
        definition:
          "A wax gasket used to create a watertight seal between a toilet and the floor flange.",
      },
      {
        term: "Wet Vent",
        definition:
          "A plumbing vent that also serves as a drain for another fixture.",
      },
      {
        term: "Winterizing Pipes",
        definition:
          "The process of preparing pipes for cold weather by draining or insulating them to prevent freezing and bursting.",
      },
      {
        term: "Wiring Harness",
        definition:
          "A bundled assembly of wires and connectors used to transmit electrical signals in vehicles, machinery, and appliances.",
      },
    ],
  },

  roofing: {
    promotionalText:
      "Protect your home with durable and long lasting roofing, LaborHack roofing experts cover you with quality.",
    terms: [
      {
        term: "Acrylic Roof Coating",
        definition:
          "A reflective, waterproof coating that protects roofs from UV rays and weathering.",
      },
      {
        term: "Adhesive Underlayment",
        definition:
          "A sticky layer applied beneath roofing materials to improve waterproofing.",
      },
      {
        term: "Air Barrier",
        definition:
          "A material that prevents uncontrolled airflow through a roof system.",
      },
      {
        term: "Algae-Resistant Shingles",
        definition: "Shingles treated to prevent algae growth and staining.",
      },
      {
        term: "Asphalt Roofing",
        definition:
          "A roofing system using asphalt-based shingles or sheets for durability.",
      },
      {
        term: "Attic Ventilation",
        definition:
          "The system that allows air circulation in an attic to reduce heat and moisture buildup.",
      },
      {
        term: "Awning Roof",
        definition:
          "A small, sloped roof extending from a structure to provide shade and protection.",
      },
      {
        term: "Back Nailing",
        definition:
          "A method of securing roofing layers with hidden nails to prevent slippage.",
      },
      {
        term: "Ballasted Roof System",
        definition:
          "A flat roofing system held in place with heavy materials like gravel.",
      },
      {
        term: "Base Flashing",
        definition:
          "The lower section of flashing that directs water away from joints and edges.",
      },
      {
        term: "Batten Seam Roof",
        definition:
          "A metal roofing style with raised seams for waterproofing.",
      },
      {
        term: "Bitumen Roof",
        definition:
          "A roof made of asphalt or coal tar for waterproofing and durability.",
      },
      {
        term: "Blistering",
        definition: "Raised bubbles on a roof due to trapped moisture or heat.",
      },
      {
        term: "Box Gutter",
        definition:
          "A concealed gutter built into the roof structure for drainage.",
      },
      {
        term: "Built-Up Roofing",
        definition:
          "A multi-layered roofing system made of bitumen and reinforcing fabric.",
      },
      {
        term: "Bundle",
        definition:
          "A package containing a set number of shingles for roofing installation.",
      },
      {
        term: "Butyl Sealant",
        definition: "A rubber-based adhesive used for waterproofing joints.",
      },
      {
        term: "Cap Flashing",
        definition:
          "A protective metal layer over roof joints to prevent water leaks.",
      },
      {
        term: "Cap Sheet",
        definition: "The topmost layer of a built-up roofing system.",
      },
      {
        term: "Chimney Flashing",
        definition:
          "Metal sheets installed around a chimney to prevent water penetration.",
      },
      {
        term: "Clay Roof Tiles",
        definition: "Durable, fire-resistant tiles made from natural clay.",
      },
      {
        term: "Cool Roof",
        definition:
          "A roofing system designed to reflect heat and reduce cooling costs.",
      },
      {
        term: "Cricket",
        definition:
          "A small, sloped structure used to divert water away from roof penetrations.",
      },
      {
        term: "Decking",
        definition:
          "The structural base layer of the roof, supporting roofing materials.",
      },
      {
        term: "Drip Edge",
        definition:
          "A metal strip along roof edges that directs water away from fascia.",
      },
      {
        term: "Eaves",
        definition: "The lower edge of a roof that extends beyond the walls.",
      },
      {
        term: "Fascia Board",
        definition: "A vertical board along the roof edge supporting gutters.",
      },
      {
        term: "Flashing",
        definition:
          "Metal or synthetic waterproof material used to prevent water penetration at joints and transitions.",
      },
      {
        term: "Gable Roof",
        definition: "A roof with two sloping sides meeting at a ridge.",
      },
      {
        term: "Hip Roof",
        definition: "A roof with slopes on all sides.",
      },
      {
        term: "Ice and Water Shield",
        definition: "A waterproof membrane preventing ice dam damage.",
      },
      {
        term: "Mansard Roof",
        definition: "A four-sided roof with two different slopes on each side.",
      },
      {
        term: "Metal Roofing",
        definition: "A roofing system made from steel, aluminum, or copper.",
      },
      {
        term: "Modified Bitumen Roofing",
        definition:
          "A durable, asphalt-based roofing material reinforced with polymers.",
      },
      {
        term: "Ridge Vent",
        definition:
          "A vent running along the roof ridge for attic ventilation.",
      },
      {
        term: "Roof Valley",
        definition:
          "The intersection of two sloping roof sections, directing water runoff.",
      },
      {
        term: "Slate Roofing",
        definition: "A natural stone roofing material known for durability.",
      },
      {
        term: "Soffit",
        definition: "The underside of a roof overhang.",
      },
      {
        term: "Standing Seam Metal Roof",
        definition: "A metal roof with raised seams for waterproofing.",
      },
      {
        term: "TPO Roofing",
        definition:
          "A single-ply roofing membrane known for energy efficiency.",
      },
      {
        term: "UV-Resistant Roofing",
        definition:
          "A roof material designed to withstand ultraviolet radiation.",
      },
      {
        term: "Valley Flashing",
        definition:
          "A metal flashing installed in roof valleys to direct water.",
      },
      {
        term: "Vapor Barrier",
        definition:
          "A material preventing moisture from passing through the roof.",
      },
      {
        term: "Vent Pipe Flashing",
        definition: "A waterproof seal around vent pipes.",
      },
      {
        term: "Ventilation Baffle",
        definition: "A structure that ensures continuous airflow in attics.",
      },
      {
        term: "Water Drainage Membrane",
        definition: "A waterproof layer facilitating proper drainage.",
      },
      {
        term: "Weatherproof Coating",
        definition:
          "A protective layer shielding the roof from weather conditions.",
      },
      {
        term: "Wind Uplift Resistance",
        definition: "The roof's ability to withstand strong winds.",
      },
      {
        term: "Zinc Roofing",
        definition: "A corrosion-resistant metal roofing material.",
      },
    ],
  },

  "solar-power": {
    promotionalText:
      "Go green, save more, LaborHack solar specialists power your future sustainably.",
    terms: [
      {
        term: "AC Coupling",
        definition:
          "A method of connecting solar and battery systems using alternating current (AC) instead of direct current (DC).",
      },
      {
        term: "AC Inverter",
        definition:
          "A device that converts direct current (DC) into alternating current (AC) for use in homes and businesses.",
      },
      {
        term: "Alternating Current",
        definition:
          "Electric current that periodically reverses direction, commonly used in power grids.",
      },
      {
        term: "Ampere",
        definition:
          "A unit of electric current that measures the flow of electrical charge.",
      },
      {
        term: "Array",
        definition:
          "A collection of solar panels connected together to generate electricity.",
      },
      {
        term: "Battery Bank",
        definition:
          "A group of batteries connected to store energy for later use.",
      },
      {
        term: "Bifacial Solar Panel",
        definition:
          "A solar panel that generates electricity from both sides by capturing reflected sunlight.",
      },
      {
        term: "Charge Controller",
        definition:
          "A device that regulates power flow to batteries to prevent overcharging or discharging.",
      },
      {
        term: "Circuit Breaker",
        definition:
          "A safety device that interrupts electrical flow during faults to prevent damage.",
      },
      {
        term: "Conversion Efficiency",
        definition:
          "The percentage of sunlight converted into usable electricity by a solar panel.",
      },
      {
        term: "Grid-Connected System",
        definition:
          "A solar power system that operates while being connected to the electrical grid.",
      },
      {
        term: "Ground Mount System",
        definition:
          "A solar installation where panels are placed on the ground instead of a roof.",
      },
      {
        term: "Inverter",
        definition:
          "A device that converts DC power from solar panels to AC power for home use.",
      },
      {
        term: "Kilowatt",
        definition: "A unit of power equal to 1,000 watts.",
      },
      {
        term: "Maximum Power Point Tracking",
        definition:
          "A technology that optimizes power output from solar panels.",
      },
      {
        term: "Micro-Inverter",
        definition:
          "A small inverter attached to each solar panel for individual energy conversion.",
      },
      {
        term: "Net Metering",
        definition:
          "A billing system that credits solar system owners for excess electricity fed into the grid.",
      },
      {
        term: "Off-Grid System",
        definition:
          "A solar power system that operates independently of the electrical grid.",
      },
      {
        term: "Photovoltaic System",
        definition:
          "A system that converts sunlight into electricity using solar panels.",
      },
      {
        term: "Solar Tracker",
        definition:
          "A device that moves solar panels to follow the sun's path for maximum energy absorption.",
      },
      {
        term: "String Inverter",
        definition:
          "An inverter that converts DC to AC for multiple solar panels wired in a series.",
      },
      {
        term: "Temperature Coefficient",
        definition:
          "A measure of how a solar panel's efficiency decreases with rising temperatures.",
      },
      {
        term: "Thin-Film Solar Panel",
        definition:
          "A lightweight, flexible solar panel made from thin photovoltaic layers.",
      },
      {
        term: "Tilt Angle",
        definition:
          "The angle at which solar panels are installed to optimize sunlight exposure.",
      },
      {
        term: "Time-of-Use Rates",
        definition:
          "Electricity pricing that varies based on the time of day, encouraging off-peak consumption.",
      },
      {
        term: "Tracking System",
        definition:
          "A mechanism that moves solar panels to follow the sun's movement.",
      },
      {
        term: "Transformerless Inverter",
        definition:
          "A lightweight, high-efficiency inverter that does not use a transformer for voltage conversion.",
      },
      {
        term: "Uninterruptible Power Supply",
        definition:
          "A backup power system that provides immediate electricity during outages.",
      },
      {
        term: "Utility-Scale Solar",
        definition:
          "Large solar power plants supplying electricity to the grid.",
      },
      {
        term: "Voltage Drop",
        definition:
          "A reduction in voltage as electricity travels through a conductor.",
      },
      {
        term: "Voltage Regulator",
        definition:
          "A device that maintains a stable voltage level in an electrical circuit.",
      },
      {
        term: "Watt",
        definition:
          "A unit of power measuring energy generation or consumption.",
      },
      {
        term: "Watt-Hour",
        definition: "A unit of energy measuring electricity used over time.",
      },
      {
        term: "Weatherproof Junction Box",
        definition:
          "A sealed enclosure that protects electrical connections from environmental damage.",
      },
      {
        term: "Zero Export Limit",
        definition:
          "A restriction preventing a solar system from sending excess electricity to the grid.",
      },
      {
        term: "Zero Net Energy Building",
        definition:
          "A building that produces as much energy as it consumes over a year.",
      },
      {
        term: "Power Purchase Agreement",
        definition:
          "A financial agreement where a developer installs, owns, and maintains a solar system, and the customer buys the electricity at a fixed rate.",
      },
      {
        term: "Renewable Energy Certificate",
        definition:
          "A market-based instrument representing the environmental benefits of renewable electricity generation.",
      },
      {
        term: "Solar Carport",
        definition: "A parking structure with an integrated solar panel roof.",
      },
      {
        term: "Solar Farm",
        definition:
          "A large-scale solar installation that generates electricity for commercial or utility use.",
      },
      {
        term: "Solar Insolation",
        definition:
          "The total amount of solar energy received per unit area over a specific period.",
      },
      {
        term: "Solar Panel Degradation Rate",
        definition:
          "The rate at which a solar panel loses efficiency over time.",
      },
      {
        term: "Solar Payback Period",
        definition:
          "The time it takes for energy savings from a solar system to cover its installation cost.",
      },
      {
        term: "Standalone PV System",
        definition:
          "A solar system that operates independently of the electrical grid.",
      },
      {
        term: "String Voltage",
        definition: "The total voltage of solar panels connected in a series.",
      },
    ],
  },

  tiling: {
    promotionalText:
      "Perfect tiles, perfect fit, LaborHack tilers deliver beauty and precision every time.",
    terms: [
      {
        term: "Abrasion Resistance",
        definition:
          "The ability of a tile to withstand wear and surface damage from foot traffic and friction.",
      },
      {
        term: "Absorption Rate",
        definition:
          "The percentage of water a tile absorbs, affecting its suitability for wet or dry areas.",
      },
      {
        term: "Adhesion Failure",
        definition:
          "When tiles detach from the substrate due to poor bonding or improper adhesive application.",
      },
      {
        term: "Adhesive",
        definition: "A bonding agent used to secure tiles to a surface.",
      },
      {
        term: "Angle Grinder",
        definition:
          "A power tool used to cut, grind, and polish tiles or other materials.",
      },
      {
        term: "Anti-Fracture Membrane",
        definition:
          "A flexible layer applied under tiles to prevent cracks from transferring from the substrate.",
      },
      {
        term: "Anti-Slip Tiles",
        definition:
          "Tiles designed with a textured surface to provide better traction and reduce slipping.",
      },
      {
        term: "Back Buttering",
        definition:
          "The process of applying adhesive to the back of a tile before setting it on a surface for better adhesion.",
      },
      {
        term: "Backer Board",
        definition:
          "A water-resistant board installed under tiles to provide stability and prevent moisture damage.",
      },
      {
        term: "Backsplash",
        definition:
          "A protective and decorative tile surface installed behind sinks, stoves, or countertops.",
      },
      {
        term: "Balancing Tiles",
        definition:
          "The technique of adjusting tile placement to ensure a symmetrical layout.",
      },
      {
        term: "Bevel Edge",
        definition:
          "A tile edge cut at an angle for a smoother transition between tiles.",
      },
      {
        term: "Bonding Agent",
        definition:
          "A material applied to improve the adhesion between tiles and the substrate.",
      },
      {
        term: "Bullnose Tile",
        definition:
          "A tile with a rounded edge, often used for finishing exposed edges.",
      },
      {
        term: "Butting Joint",
        definition:
          "A tile joint where tiles are placed edge-to-edge without gaps or grout lines.",
      },
      {
        term: "Caulking",
        definition:
          "A waterproof sealant applied to gaps between tiles and other surfaces.",
      },
      {
        term: "Ceramic Tile",
        definition:
          "A type of tile made from clay and fired in a kiln, known for its durability and variety of designs.",
      },
      {
        term: "Cladding",
        definition:
          "A decorative or protective layer of tiles applied to walls or building exteriors.",
      },
      {
        term: "Clip System",
        definition:
          "A leveling system that helps maintain uniform spacing between tiles during installation.",
      },
      {
        term: "Coefficient of Friction (COF)",
        definition:
          "A measure of a tile's slip resistance, important for safety in wet areas.",
      },
      {
        term: "Concrete Screed",
        definition:
          "A smooth, level layer of concrete applied before tiling to create an even surface.",
      },
      {
        term: "Cove Base",
        definition:
          "A curved tile installed at the base of walls to create a seamless transition between floors and walls.",
      },
      {
        term: "Crack Isolation Membrane",
        definition:
          "A protective layer that prevents cracks from transferring from the substrate to the tile.",
      },
      {
        term: "Cross Spacers",
        definition:
          "Small plastic spacers used to ensure even gaps between tiles during installation.",
      },
      {
        term: "Curing Time",
        definition:
          "The period required for adhesives, grout, or other materials to set and achieve full strength.",
      },
      {
        term: "Cut Tiles",
        definition:
          "Tiles that have been trimmed to fit specific areas, such as edges or corners.",
      },
      {
        term: "Damp-Proofing",
        definition:
          "A treatment applied to surfaces to prevent moisture penetration and tile damage.",
      },
      {
        term: "Dry Layout",
        definition:
          "A pre-installation process of arranging tiles without adhesive to visualize the final design.",
      },
      {
        term: "Dry Pack Mortar",
        definition:
          "A stiff mortar mix used to create a solid, level base for tiles.",
      },
      {
        term: "Dry-Pressed Tiles",
        definition:
          "Tiles manufactured by pressing dry clay under high pressure before firing.",
      },
      {
        term: "Dual Finish Tile",
        definition:
          "A tile with both matte and glossy finishes in a single design.",
      },
      {
        term: "Dustless Grout",
        definition:
          "A special grout formulation that produces less dust during mixing and application.",
      },
      {
        term: "Edge Trim",
        definition:
          "Decorative or protective strips placed at tile edges to create a finished look.",
      },
      {
        term: "Efflorescence",
        definition:
          "A white, powdery deposit on tiles caused by moisture bringing salts to the surface.",
      },
      {
        term: "Elevated Flooring",
        definition:
          "A raised floor system with a gap beneath for ventilation, wiring, or drainage.",
      },
      {
        term: "Embossed Tile",
        definition:
          "A tile with a raised or textured surface for aesthetic or functional purposes.",
      },
      {
        term: "Encaustic Tile",
        definition:
          "A tile with intricate, inlaid patterns made from different colored clays rather than surface glazing.",
      },
      {
        term: "Epoxy Grout",
        definition:
          "A highly durable, stain-resistant grout made from epoxy resins, commonly used in moisture-prone areas.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A flexible joint designed to allow movement and prevent tile cracking due to temperature changes or settling.",
      },
      {
        term: "Exterior Grade Tile",
        definition:
          "Tiles designed for outdoor use, resistant to weather, moisture, and temperature changes.",
      },
      {
        term: "Face Tiling",
        definition:
          "The visible side of a tile installation, often referring to decorative wall tiles.",
      },
      {
        term: "Floating Floor",
        definition:
          "A floor installation method where tiles or flooring materials are not glued or nailed to the subfloor.",
      },
      {
        term: "Floor Drainage",
        definition:
          "A system ensuring water flows toward drains in tiled floors, common in bathrooms and kitchens.",
      },
      {
        term: "Floor Leveling Compound",
        definition:
          "A self-leveling material used to smooth uneven floors before tiling.",
      },
      {
        term: "Floor Preparation",
        definition:
          "The process of cleaning, leveling, and priming a surface before tile installation.",
      },
      {
        term: "Full-Bodied Tile",
        definition:
          "A tile where the color and pattern extend throughout the tile's thickness, making chips less visible.",
      },
      {
        term: "Furring Strip",
        definition:
          "A thin strip of wood or metal used to create a level surface for tile installation.",
      },
      {
        term: "Glazed Tile",
        definition:
          "A tile with a glass-like coating that adds color, shine, and stain resistance.",
      },
      {
        term: "Grading",
        definition:
          "The classification of tiles based on quality, durability, and imperfections.",
      },
      {
        term: "Grout",
        definition:
          "A cementitious or epoxy-based material used to fill gaps between tiles.",
      },
      {
        term: "Grout Float",
        definition:
          "A rubber or foam tool used to spread grout into tile joints.",
      },
      {
        term: "Grout Haze",
        definition:
          "A thin, powdery residue left on tile surfaces after grouting.",
      },
      {
        term: "Grout Joint",
        definition:
          "The space between tiles filled with grout for structural integrity and aesthetics.",
      },
      {
        term: "Grout Line",
        definition: "The visible line between tiles formed by grout.",
      },
      {
        term: "Grout Sealer",
        definition:
          "A protective coating applied to grout lines to prevent stains and moisture penetration.",
      },
      {
        term: "Grout Spacers",
        definition:
          "Small plastic pieces placed between tiles to ensure even grout lines.",
      },
      {
        term: "Hard Trowel Finish",
        definition:
          "A smooth concrete surface finish created by using a steel trowel, providing a polished look.",
      },
      {
        term: "Heat-Resistant Tiles",
        definition:
          "Tiles designed to withstand high temperatures, commonly used in fireplaces and kitchens.",
      },
      {
        term: "Herringbone Pattern",
        definition:
          "A tile arrangement where rectangular tiles are laid in a zigzag pattern for a decorative effect.",
      },
      {
        term: "Hexagonal Tile",
        definition:
          "A six-sided tile commonly used for geometric floor and wall designs.",
      },
      {
        term: "High-Traffic Tile",
        definition:
          "A tile designed for durability in areas with heavy foot traffic.",
      },
      {
        term: "Honed Finish",
        definition:
          "A smooth, matte tile finish achieved by grinding the surface.",
      },
      {
        term: "Impact Resistance",
        definition:
          "The tile's ability to withstand sudden force or heavy loads without breaking.",
      },
      {
        term: "Impervious Tile",
        definition:
          "A tile with very low water absorption, making it highly resistant to moisture.",
      },
      {
        term: "Indoor-Outdoor Tiles",
        definition:
          "Tiles designed for both interior and exterior applications, often resistant to weather conditions.",
      },
      {
        term: "Insert Tiles",
        definition:
          "Decorative accent tiles used to create patterns or focal points in tile installations.",
      },
      {
        term: "Interlocking Tiles",
        definition:
          "Tiles with edges that fit together like a puzzle for easy installation and stability.",
      },
      {
        term: "Isolation Membrane",
        definition:
          "A layer placed beneath tiles to prevent cracks from transferring from the substrate.",
      },
      {
        term: "Jacking Up Tiles",
        definition:
          "The process of removing tiles that have lifted or become loose due to substrate movement.",
      },
      {
        term: "Joint Width",
        definition:
          "The space between tiles, which is filled with grout to ensure a secure fit.",
      },
      {
        term: "Jolly Trim",
        definition:
          "A finishing tile trim with a rounded edge, used to cover exposed edges or corners.",
      },
      {
        term: "Kiln-Fired Tile",
        definition:
          "A tile hardened by high-temperature firing in a kiln for durability.",
      },
      {
        term: "Kitchen Backsplash",
        definition:
          "A tiled surface behind sinks or stoves designed for easy cleaning and aesthetic appeal.",
      },
      {
        term: "Kitchen Flooring",
        definition:
          "Tile flooring specifically designed for kitchen areas, often featuring non-slip and stain-resistant properties.",
      },
      {
        term: "Lippage",
        definition:
          "Uneven tile edges that create height differences between adjacent tiles.",
      },
      {
        term: "Latex-Modified Mortar",
        definition:
          "A mortar mixture enhanced with latex additives to improve adhesion and flexibility.",
      },
      {
        term: "Leveling Screed",
        definition:
          "A layer of material applied to create a smooth and even surface before tiling.",
      },
      {
        term: "Leveling System",
        definition:
          "A system of clips and wedges used to prevent lippage during tile installation.",
      },
      {
        term: "Listello Tile",
        definition:
          "A decorative tile strip used as a border or accent in tile layouts.",
      },
      {
        term: "Load-Bearing Tile",
        definition:
          "Tiles designed to support significant weight without cracking or breaking.",
      },
      {
        term: "Low-Absorption Tile",
        definition:
          "A tile with minimal water absorption, ideal for moisture-prone areas like bathrooms.",
      },
      {
        term: "Mastic",
        definition:
          "A pre-mixed adhesive used for bonding tiles to walls or floors.",
      },
      {
        term: "Matte Finish",
        definition:
          "A non-glossy tile surface that reduces glare and enhances grip.",
      },
      {
        term: "Measuring Trowel",
        definition:
          "A trowel with measurement markings used for precise mortar application.",
      },
      {
        term: "Modular Tile",
        definition:
          "Tiles designed to fit together in specific patterns without excessive cutting.",
      },
      {
        term: "Mosaic Tile",
        definition:
          "Small tiles arranged in sheets to create intricate designs or patterns.",
      },
      {
        term: "Mortar",
        definition:
          "A cement-based adhesive used for securing tiles to a surface.",
      },
      {
        term: "Movement Joint",
        definition:
          "A flexible gap in a tile installation that accommodates expansion and contraction.",
      },
      {
        term: "Natural Stone Tile",
        definition:
          "Tiles made from real stone, such as marble, granite, or slate.",
      },
      {
        term: "Non-Slip Coating",
        definition: "A treatment applied to tiles to enhance slip resistance.",
      },
      {
        term: "Notched Trowel",
        definition:
          "A trowel with notches that create ridges in adhesive for better tile adhesion.",
      },
      {
        term: "Offset Pattern",
        definition:
          "A tile layout where each row is staggered, often resembling brickwork.",
      },
      {
        term: "Outdoor Porcelain Tile",
        definition:
          "Durable, weather-resistant porcelain tiles used for patios, walkways, or exterior walls.",
      },
      {
        term: "Overlapping Joint",
        definition:
          "A tile joint where one tile slightly overlaps another, often used in roofing or decorative tiling.",
      },
      {
        term: "Over-Tiling",
        definition:
          "The process of laying new tiles directly over existing tiles.",
      },
      {
        term: "Paver Tiles",
        definition:
          "Thick, durable tiles designed for outdoor flooring applications like patios and walkways.",
      },
      {
        term: "Penny Tile",
        definition:
          "Small, round tiles arranged in a grid pattern, often used for vintage-style flooring.",
      },
      {
        term: "Polished Finish",
        definition:
          "A high-gloss tile surface that enhances color depth and reflectivity.",
      },
      {
        term: "Porcelain Tile",
        definition:
          "A dense, durable tile made from refined clay, known for its low water absorption.",
      },
      {
        term: "Post-Tensioned Slab Tiling",
        definition:
          "Tiling over a concrete slab that has been reinforced with tensioned cables.",
      },
      {
        term: "Pressed Edge",
        definition:
          "A slightly rounded tile edge created during the manufacturing process.",
      },
      {
        term: "Profile Trim",
        definition:
          "A tile trim designed to protect and decorate exposed edges or transitions.",
      },
      {
        term: "Pumice Tiles",
        definition:
          "Lightweight, porous tiles made from volcanic rock for insulation and aesthetics.",
      },
      {
        term: "Quarry Tile",
        definition:
          "A thick, unglazed tile made from natural clay, known for its durability in commercial and outdoor settings.",
      },
      {
        term: "Quick-Set Mortar",
        definition:
          "A fast-drying mortar used for time-sensitive tile installations.",
      },
      {
        term: "Rectified Tile",
        definition:
          "A precisely cut tile with sharp edges, allowing for minimal grout lines and a seamless look.",
      },
      {
        term: "Regrouting",
        definition:
          "The process of removing old grout and applying fresh grout to restore tiled surfaces.",
      },
      {
        term: "Resin-Backed Tile",
        definition:
          "A tile with a resin coating on the back to improve adhesion and durability.",
      },
      {
        term: "Rippled Finish",
        definition:
          "A textured tile surface that adds visual interest and slip resistance.",
      },
      {
        term: "Running Bond Pattern",
        definition:
          "A classic tile layout where tiles are staggered, similar to a brick pattern.",
      },
      {
        term: "Sanded Grout",
        definition:
          "A grout mixture containing sand, used for wider tile joints to prevent cracking.",
      },
      {
        term: "Saw Cut Tile",
        definition: "A tile that has been cut using a saw for precise shaping.",
      },
      {
        term: "Scratch Coat",
        definition:
          "A rough base layer of mortar applied before tiling to enhance adhesion.",
      },
      {
        term: "Sealant",
        definition:
          "A protective coating applied to tiles and grout to prevent moisture and stains.",
      },
      {
        term: "Self-Leveling Compound",
        definition:
          "A liquid mixture used to create a flat, even surface before tiling.",
      },
      {
        term: "Shear Strength",
        definition:
          "A tile's resistance to forces that attempt to pull it apart or shift it sideways.",
      },
      {
        term: "Skirting Tile",
        definition:
          "A base tile installed at the bottom of walls to protect against moisture and impact.",
      },
      {
        term: "Slip-Resistant Tile",
        definition:
          "A tile designed with texture or coatings to enhance traction.",
      },
      {
        term: "Spacers",
        definition:
          "Small plastic pieces used to maintain even gaps between tiles during installation.",
      },
      {
        term: "Staggered Joint",
        definition:
          "A tile joint arrangement where tiles are offset rather than aligned in straight rows.",
      },
      {
        term: "Stained Grout",
        definition:
          "Grout that has discolored over time due to moisture, dirt, or improper sealing.",
      },
      {
        term: "Structural Tile",
        definition:
          "Tiles designed to bear heavy loads, often used in commercial applications.",
      },
      {
        term: "Subway Tile",
        definition:
          "A rectangular tile, typically 3x6 inches, commonly used in kitchen and bathroom walls.",
      },
      {
        term: "Surface Preparation",
        definition:
          "The process of cleaning, leveling, and priming a surface before installing tiles.",
      },
      {
        term: "Tactile Tile",
        definition:
          "A textured tile designed to assist visually impaired individuals, often used in public spaces.",
      },
      {
        term: "Tiling Trowel",
        definition: "A flat-bladed tool used for spreading adhesive or mortar.",
      },
      {
        term: "Tile Cutter",
        definition:
          "A manual or electric tool used to cut tiles to the desired size.",
      },
      {
        term: "Tile Expansion Joint",
        definition:
          "A flexible gap in a tile installation to allow for movement and prevent cracking.",
      },
      {
        term: "Tile Leveling Clips",
        definition:
          "Small plastic clips used to maintain even tile spacing and prevent lippage.",
      },
      {
        term: "Tile Nipper",
        definition:
          "A handheld tool used for trimming small sections of tiles.",
      },
      {
        term: "Tile Sealer",
        definition:
          "A protective coating applied to porous tiles to prevent staining and moisture absorption.",
      },
      {
        term: "Tile Spacer",
        definition:
          "A small plastic piece used to ensure uniform grout lines between tiles.",
      },
      {
        term: "Transition Strip",
        definition:
          "A strip used to create a smooth transition between different flooring materials.",
      },
      {
        term: "Trim Tile",
        definition:
          "A finishing tile used on edges, corners, or borders to complete a tile design.",
      },
      {
        term: "Troweled Finish",
        definition: "A smooth surface finish created using a trowel.",
      },
      {
        term: "Tumbled Finish",
        definition:
          "A tile surface that has been distressed for a rustic, aged look.",
      },
      {
        term: "Underlayment",
        definition:
          "A layer installed beneath tiles to provide stability and moisture resistance.",
      },
      {
        term: "Unglazed Tile",
        definition:
          "A tile without a surface coating, often more porous and textured.",
      },
      {
        term: "Urethane Grout",
        definition:
          "A flexible, stain-resistant grout that doesn't require sealing.",
      },
      {
        term: "Vapor Barrier",
        definition:
          "A material used to prevent moisture from penetrating through walls or floors.",
      },
      {
        term: "Vitrified Tile",
        definition:
          "A highly durable, low-porosity tile made from a vitrification process.",
      },
      {
        term: "Wall Tile",
        definition:
          "A tile specifically designed for vertical applications on walls.",
      },
      {
        term: "Waterproof Membrane",
        definition:
          "A protective layer applied beneath tiles in wet areas to prevent water damage.",
      },
      {
        term: "Wear Layer",
        definition: "The top surface of a tile that resists wear and damage.",
      },
      {
        term: "Weatherproofing",
        definition:
          "The process of making tiles resistant to environmental conditions like rain and sun.",
      },
      {
        term: "Wet Saw",
        definition:
          "A power tool with a water-cooled blade used for precise tile cutting.",
      },
    ],
  },

  welding: {
    promotionalText:
      "Strength in every joint, LaborHack welders guarantee safety and durability.",
    terms: [
      {
        term: "AC Welding",
        definition:
          "Welding using alternating current, commonly used for aluminum and magnesium.",
      },
      {
        term: "Active Flux",
        definition:
          "A flux that actively reacts with the weld pool to improve welding performance.",
      },
      {
        term: "Alloy Welding",
        definition:
          "Welding process used for joining metal alloys like aluminum or stainless steel.",
      },
      {
        term: "Annealing",
        definition: "Heat treatment to soften metal and relieve stress.",
      },
      {
        term: "Arc Length",
        definition:
          "The distance between the electrode and the workpiece in arc welding.",
      },
      {
        term: "Arc Welding",
        definition:
          "A welding process that uses an electric arc to melt and join metals.",
      },
      {
        term: "Argon Gas Shielding",
        definition:
          "Using argon gas to protect the weld pool from atmospheric contamination.",
      },
      {
        term: "Automatic Welding",
        definition:
          "A fully mechanized welding process with minimal manual intervention.",
      },
      {
        term: "Back Gouging",
        definition:
          "Removing metal from the back side of a weld to ensure full penetration.",
      },
      {
        term: "Backing Strip",
        definition:
          "A strip of metal placed behind a weld to support and reinforce it.",
      },
      {
        term: "Base Metal",
        definition: "The main metal being welded.",
      },
      {
        term: "Bead Welding",
        definition: "A single run of weld metal deposited on a workpiece.",
      },
      {
        term: "Brazing",
        definition:
          "A joining process using a filler metal with a melting point above 450°C but below the base metal.",
      },
      {
        term: "Butt Joint",
        definition:
          "A type of joint where two pieces of metal are joined in the same plane.",
      },
      {
        term: "Carbon Arc Welding",
        definition: "An arc welding process that uses a carbon electrode.",
      },
      {
        term: "Cold Cracking",
        definition:
          "A delayed cracking issue caused by hydrogen embrittlement.",
      },
      {
        term: "Consumable Electrode",
        definition:
          "An electrode that melts during welding to form the weld joint.",
      },
      {
        term: "Corner Joint",
        definition:
          "A welding joint where two metal pieces meet at a 90-degree angle.",
      },
      {
        term: "Crack Resistance",
        definition: "The ability of a weld to resist cracking.",
      },
      {
        term: "Cross Weld",
        definition: "A weld where two perpendicular metal pieces intersect.",
      },
      {
        term: "Defect Inspection",
        definition: "Examination of welds for defects like cracks or porosity.",
      },
      {
        term: "Distortion Control",
        definition: "Techniques used to minimize warping in welded materials.",
      },
      {
        term: "Double Weld",
        definition: "A welding process where both sides of a joint are welded.",
      },
      {
        term: "Ductility",
        definition: "The ability of a metal to deform without breaking.",
      },
      {
        term: "Edge Joint",
        definition:
          "A welding joint where two metal pieces are aligned along their edges.",
      },
      {
        term: "Electrode Holder",
        definition:
          "A device that holds and transfers current to the electrode.",
      },
      {
        term: "Electroslag Welding",
        definition: "A high-heat welding process for thick materials.",
      },
      {
        term: "Expansion Joint",
        definition:
          "A structural element that allows for thermal expansion in metal.",
      },
      {
        term: "Fabrication Welding",
        definition:
          "Welding used in metal fabrication for assembling structures.",
      },
      {
        term: "Face Reinforcement",
        definition:
          "Additional metal added to the surface of a weld for strength.",
      },
      {
        term: "Filler Metal",
        definition: "Metal added to a weld joint to facilitate joining.",
      },
      {
        term: "Fillet Weld",
        definition: "A weld that joins two metal surfaces at an angle.",
      },
      {
        term: "Flux Cored Arc Welding",
        definition:
          "A semi-automatic welding process using a tubular wire with flux.",
      },
      {
        term: "Gas Metal Arc Welding",
        definition:
          "Also known as MIG welding, using a consumable electrode and gas shield.",
      },
      {
        term: "Gas Shielded Welding",
        definition:
          "A process that uses a shielding gas to protect the weld pool.",
      },
      {
        term: "Gas Tungsten Arc Welding",
        definition: "Also known as TIG welding, using a tungsten electrode.",
      },
      {
        term: "Groove Weld",
        definition: "A weld in a groove between two metal parts.",
      },
      {
        term: "Hardfacing",
        definition: "Applying a wear-resistant layer to a surface.",
      },
      {
        term: "Heat Affected Zone",
        definition: "The area around the weld affected by heat.",
      },
      {
        term: "Hot Cracking",
        definition:
          "A type of cracking that occurs during solidification of the weld.",
      },
      {
        term: "Hydrogen Embrittlement",
        definition: "Weakening of metal due to hydrogen absorption.",
      },
      {
        term: "Incomplete Fusion",
        definition: "A welding defect where metals fail to fully fuse.",
      },
      {
        term: "Inert Gas Welding",
        definition: "Welding using inert gases like argon or helium.",
      },
      {
        term: "Joint Configuration",
        definition: "The design and layout of a weld joint.",
      },
      {
        term: "Joint Penetration",
        definition:
          "The depth to which the weld metal fuses into the base metal.",
      },
      {
        term: "Keyhole Welding",
        definition:
          "A deep-penetration welding process using a keyhole effect.",
      },
      {
        term: "Lap Joint",
        definition: "A joint where two metal pieces overlap.",
      },
      {
        term: "Laser Welding",
        definition: "Welding process using a laser beam for precise joining.",
      },
      {
        term: "Manual Metal Arc Welding",
        definition: "Also known as stick welding.",
      },
      {
        term: "Metal Transfer Mode",
        definition:
          "The way molten metal transfers from the electrode to the weld.",
      },
      {
        term: "Non-Destructive Testing",
        definition: "Methods for inspecting welds without damaging them.",
      },
      {
        term: "Overhead Welding",
        definition: "Welding performed on the underside of a structure.",
      },
      {
        term: "Plasma Arc Welding",
        definition: "A precision welding process using a plasma arc.",
      },
      {
        term: "Post-Weld Heat Treatment",
        definition: "Heating a weld after completion to improve properties.",
      },
      {
        term: "Root Pass",
        definition: "The first weld pass in a multi-pass welding process.",
      },
      {
        term: "Shielded Metal Arc Welding",
        definition: "Stick welding using a flux-coated electrode.",
      },
      {
        term: "Spot Welding",
        definition:
          "A resistance welding method for joining thin metal sheets.",
      },
      {
        term: "Tack Welding",
        definition: "Temporary welds used to hold metal parts in place.",
      },
      {
        term: "TIG Welding",
        definition: "Tungsten Inert Gas welding for high-quality joins.",
      },
      {
        term: "Ultrasonic Testing",
        definition:
          "A non-destructive weld inspection method using sound waves.",
      },
      {
        term: "Underbead Crack",
        definition: "A crack occurring below the weld bead.",
      },
      {
        term: "Vertical Welding",
        definition: "Welding performed in a vertical position.",
      },
      {
        term: "Welding Helmet",
        definition: "Protective gear for welders.",
      },
      {
        term: "Welding Rod",
        definition: "A filler metal used in welding.",
      },
      {
        term: "Weldability",
        definition: "The ease of welding a material.",
      },
      {
        term: "Zero Defect Welding",
        definition: "Aiming for welds with no defects.",
      },
    ],
  },
};

// Utility function to get available letters for an artisan
export const getAvailableLetters = (artisan: string): string[] => {
  const artisanData = glossaryData[artisan];
  if (!artisanData) return [];

  const letters = new Set<string>();
  artisanData.terms.forEach((term) => {
    const firstLetter = term.term.charAt(0).toUpperCase();
    letters.add(firstLetter);
  });

  return Array.from(letters).sort();
};

// Utility function to get terms for a specific letter
export const getTermsForLetter = (
  artisan: string,
  letter: string
): GlossaryTerm[] => {
  const artisanData = glossaryData[artisan];
  if (!artisanData) return [];

  return artisanData.terms
    .filter(
      (term) => term.term.charAt(0).toUpperCase() === letter.toUpperCase()
    )
    .sort((a, b) => a.term.localeCompare(b.term));
};

// All possible letters A-Z
export const allLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// Get available artisans from the existing constants
export const getAvailableCategories = (): string[] => {
  return Object.keys(glossaryData);
};
